var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPDeployment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-26",
    cx: 250,
    cy: 368.25,
    rx: 211.22,
    ry: 123.68,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-26",
    points: "140.31 367.6 180.94 344.14 144.38 323.04 103.76 346.49 140.31 367.6",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-26",
    points: "341.7 367.6 382.32 344.14 345.76 323.04 305.14 346.49 341.7 367.6",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Towers--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tower--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363,339.78a.47.47,0,0,1-.47-.47V287.07a.47.47,0,0,1,.47-.47.46.46,0,0,1,.46.47v52.24A.46.46,0,0,1,363,339.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,342a.47.47,0,0,1-.46-.47V289.17a.47.47,0,0,1,.93,0v52.32A.47.47,0,0,1,366.81,342Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,339.54a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,339.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,337.36a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,335.18a.2.2,0,0,1-.11,0L362.92,333a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,335.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,333a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,333Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,330.82a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.23.23,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,330.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,328.63a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,326.45a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,324.27a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,324.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,322.09a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,319.91a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,317.73a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,317.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,315.55a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,315.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,313.37a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,313.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,311.18a.14.14,0,0,1-.11,0L362.92,309a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,309a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,306.82a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,306.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,304.64a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,302.46a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,300.28a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,300.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,298.1a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,298.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,295.92a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.23.23,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,295.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,293.73a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,291.55a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,344.14a.46.46,0,0,1-.4-.23.47.47,0,0,1,.17-.64L343.92,328a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1,.17.64.47.47,0,0,1-.63.17L344.16,329,318,344.08A.53.53,0,0,1,317.72,344.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.59,291.81a.46.46,0,0,1-.23-.06l-26.2-15.12L318,291.75a.46.46,0,1,1-.47-.8l26.43-15.26a.44.44,0,0,1,.47,0L370.82,291a.46.46,0,0,1-.23.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 344.25 355.47 335.52 355.47 282.64 340.38 291.35 340.38 344.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 344.25 329.05 337.66 329.05 284.81 340.38 291.35 340.38 344.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 282.64 344.16 276.09 329.05 284.81 340.38 291.35 355.47 282.64",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 282.64 344.16 276.09 329.05 284.81 340.38 291.35 355.47 282.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,359.4a.46.46,0,0,1-.23-.06.47.47,0,0,1-.24-.41V306.61a.46.46,0,0,1,.24-.4L370.36,291a.43.43,0,0,1,.46,0,.45.45,0,0,1,.24.4v52.32a.47.47,0,0,1-.24.41l-26.43,15.26A.46.46,0,0,1,344.16,359.4Zm.46-52.52v51.25l25.51-14.72V292.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,359.4a.46.46,0,0,1-.23-.06l-26.44-15.26a.49.49,0,0,1-.23-.41V291.35a.46.46,0,0,1,.23-.4.44.44,0,0,1,.47,0l26.43,15.26a.47.47,0,0,1,.23.4v52.32a.49.49,0,0,1-.23.41A.46.46,0,0,1,344.16,359.4Zm-26-16,25.5,14.72V306.88l-25.5-14.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,359.4a.47.47,0,0,1-.17,0,.47.47,0,0,1-.27-.6l26.44-67.59a.46.46,0,0,1,.86.34L344.59,359.1A.46.46,0,0,1,344.16,359.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,344.14a.43.43,0,0,1-.26-.09.47.47,0,0,1-.11-.65l26.43-37.06a.47.47,0,1,1,.76.54L318.1,343.94A.46.46,0,0,1,317.72,344.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,287.45a.46.46,0,0,1-.47-.46V234.74a.47.47,0,0,1,.47-.46.46.46,0,0,1,.46.46V287A.45.45,0,0,1,363,287.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,289.64a.47.47,0,0,1-.46-.47V236.85a.47.47,0,1,1,.93,0v52.32A.47.47,0,0,1,366.81,289.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,287.22a.2.2,0,0,1-.11,0L362.92,285a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,287.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,285a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,285Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,282.85a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,280.67a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,278.49a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,278.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,276.31a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,274.13a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,272a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,272Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,269.77a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,269.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,267.59a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.23.23,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,267.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,265.4a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,263.22a.2.2,0,0,1-.11,0L362.92,261a.23.23,0,0,1,.23-.4l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,261a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,261Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,258.86a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,256.68a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,254.5a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,254.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,252.32a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,252.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,250.14a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,250.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,248a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,245.77a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,243.59a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,243.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,241.41a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,239.23a.2.2,0,0,1-.11,0L362.92,237a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.59,291.81a.46.46,0,0,1-.23-.06l-26.2-15.12L318,291.75a.46.46,0,1,1-.47-.8l26.43-15.26a.44.44,0,0,1,.47,0L370.82,291a.46.46,0,0,1-.23.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,239.49a.46.46,0,0,1-.4-.23.47.47,0,0,1,.17-.64l26.43-15.26a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1,.17.64.47.47,0,0,1-.63.17l-26.2-15.13L318,239.43A.53.53,0,0,1,317.72,239.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 291.93 355.47 283.2 355.47 230.31 340.38 239.03 340.38 291.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 291.93 329.05 285.33 329.05 232.49 340.38 239.03 340.38 291.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 230.31 344.16 223.76 329.05 232.49 340.38 239.03 355.47 230.31",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 230.31 344.16 223.76 329.05 232.49 340.38 239.03 355.47 230.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,307.08a.39.39,0,0,1-.23-.07.45.45,0,0,1-.24-.4V254.29a.45.45,0,0,1,.24-.4l26.43-15.27a.47.47,0,0,1,.7.41v52.32a.45.45,0,0,1-.24.4L344.39,307A.39.39,0,0,1,344.16,307.08Zm.46-52.52v51.25l25.51-14.73V239.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,307.08a.39.39,0,0,1-.23-.07l-26.44-15.26a.46.46,0,0,1-.23-.4V239a.47.47,0,0,1,.7-.41l26.43,15.27a.46.46,0,0,1,.23.4v52.32a.46.46,0,0,1-.23.4A.39.39,0,0,1,344.16,307.08Zm-26-16,25.5,14.73V254.56l-25.5-14.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,307.08a.33.33,0,0,1-.17,0,.47.47,0,0,1-.27-.6l26.44-67.58a.46.46,0,1,1,.86.34l-26.43,67.58A.47.47,0,0,1,344.16,307.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,291.81a.42.42,0,0,1-.26-.08.47.47,0,0,1-.11-.65L343.78,254a.47.47,0,0,1,.65-.11.47.47,0,0,1,.11.65L318.1,291.62A.45.45,0,0,1,317.72,291.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,235.13a.47.47,0,0,1-.47-.46V182.42A.46.46,0,0,1,363,182a.45.45,0,0,1,.46.46v52.25A.46.46,0,0,1,363,235.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,237.31a.47.47,0,0,1-.46-.46V184.52a.47.47,0,0,1,.93,0v52.33A.47.47,0,0,1,366.81,237.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,234.89a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1,.23-.4l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,232.71a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,232.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,230.53a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,228.35a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,226.17a.2.2,0,0,1-.11,0L362.92,224a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,226.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,224a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,224Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,221.81a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,221.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,219.62a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,217.44a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,215.26a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,215.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,213.08a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,210.9a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,208.72a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,208.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,206.54a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,206.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,204.36a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,204.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,202.17a.2.2,0,0,1-.11,0L362.92,200a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,200a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,197.81a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,197.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,195.63a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,193.45a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,191.27a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,191.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,189.09a.15.15,0,0,1-.11,0l-3.78-2.17a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,189.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,186.91a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,186.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,239.49a.46.46,0,0,1-.4-.23.47.47,0,0,1,.17-.64l26.43-15.26a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1,.17.64.47.47,0,0,1-.63.17l-26.2-15.13L318,239.43A.53.53,0,0,1,317.72,239.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,187.17a.47.47,0,0,1-.4-.24.46.46,0,0,1,.17-.63L343.92,171a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1-.46.8L344.16,172,318,187.1A.44.44,0,0,1,317.72,187.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 239.6 355.47 230.87 355.47 177.99 340.38 186.7 340.38 239.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 239.6 329.05 233.01 329.05 180.16 340.38 186.7 340.38 239.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 177.99 344.16 171.44 329.05 180.16 340.38 186.7 355.47 177.99",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 177.99 344.16 171.44 329.05 180.16 340.38 186.7 355.47 177.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,254.75a.46.46,0,0,1-.23-.06.46.46,0,0,1-.24-.4V202a.46.46,0,0,1,.24-.4l26.43-15.26a.47.47,0,0,1,.46,0,.46.46,0,0,1,.24.4V239a.46.46,0,0,1-.24.4l-26.43,15.26A.46.46,0,0,1,344.16,254.75Zm.46-52.52v51.25l25.51-14.72V187.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,254.75a.46.46,0,0,1-.23-.06l-26.44-15.26a.47.47,0,0,1-.23-.4V186.7a.47.47,0,0,1,.23-.4.49.49,0,0,1,.47,0l26.43,15.26a.47.47,0,0,1,.23.4v52.33a.47.47,0,0,1-.23.4A.46.46,0,0,1,344.16,254.75Zm-26-16,25.5,14.72V202.23l-25.5-14.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,254.75a.46.46,0,0,1-.44-.63l26.44-67.59a.46.46,0,1,1,.86.34l-26.43,67.59A.46.46,0,0,1,344.16,254.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,239.49a.5.5,0,0,1-.26-.08.47.47,0,0,1-.11-.65l26.43-37.07a.47.47,0,0,1,.76.54L318.1,239.3A.47.47,0,0,1,317.72,239.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,182.81a.47.47,0,0,1-.47-.47V130.1a.47.47,0,0,1,.47-.47.46.46,0,0,1,.46.47v52.24A.46.46,0,0,1,363,182.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,185a.47.47,0,0,1-.46-.47V132.2a.47.47,0,1,1,.93,0v52.32A.47.47,0,0,1,366.81,185Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,182.57a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,180.39a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,180.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,178.21a.2.2,0,0,1-.11,0L362.92,176a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,178.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,176a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.23.23,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,173.84a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,171.66a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,169.48a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,169.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,167.3a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,165.12a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,162.94a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,162.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,160.76a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,160.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,158.58a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,158.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,156.39a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,154.21a.2.2,0,0,1-.11,0L362.92,152a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,152a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,152Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,149.85a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,147.67a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.19a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,145.49a.2.2,0,0,1-.11,0l-3.78-2.18a.24.24,0,0,1,.23-.41l3.78,2.18a.23.23,0,0,1,.08.32A.22.22,0,0,1,366.81,145.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,143.31a.2.2,0,0,1-.11,0l-3.78-2.19a.22.22,0,0,1-.08-.31.23.23,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,143.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,141.13a.15.15,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.23.23,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1,.08.32A.24.24,0,0,1,366.81,141.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,138.94a.2.2,0,0,1-.11,0l-3.78-2.18a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,136.76a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,134.58a.2.2,0,0,1-.11,0l-3.78-2.18a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l3.78,2.18a.23.23,0,0,1,.08.32A.23.23,0,0,1,366.81,134.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,187.17a.47.47,0,0,1-.4-.24.46.46,0,0,1,.17-.63L343.92,171a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1-.46.8L344.16,172,318,187.1A.44.44,0,0,1,317.72,187.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,134.84a.46.46,0,0,1-.23-.86l26.43-15.26a.44.44,0,0,1,.47,0L370.82,134a.46.46,0,0,1-.46.8l-26.2-15.13L318,134.78A.53.53,0,0,1,317.72,134.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 187.28 355.47 178.55 355.47 125.67 340.38 134.38 340.38 187.28",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.38 187.28 329.05 180.69 329.05 127.84 340.38 134.38 340.38 187.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.47 125.67 344.16 119.12 329.05 127.84 340.38 134.38 355.47 125.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,202.43a.46.46,0,0,1-.23-.06.47.47,0,0,1-.24-.41V149.64a.45.45,0,0,1,.24-.4L370.36,134a.43.43,0,0,1,.46,0,.45.45,0,0,1,.24.4V186.7a.45.45,0,0,1-.24.4l-26.43,15.27A.46.46,0,0,1,344.16,202.43Zm.46-52.52v51.25l25.51-14.73V135.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,202.43a.46.46,0,0,1-.23-.06L317.49,187.1a.46.46,0,0,1-.23-.4V134.38a.46.46,0,0,1,.23-.4.44.44,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1,.23.4V202a.49.49,0,0,1-.23.41A.46.46,0,0,1,344.16,202.43Zm-26-16,25.5,14.73V149.91l-25.5-14.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,202.43a.47.47,0,0,1-.17,0,.47.47,0,0,1-.27-.6l26.44-67.59a.46.46,0,0,1,.86.34l-26.43,67.58A.46.46,0,0,1,344.16,202.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,187.17a.43.43,0,0,1-.26-.09.47.47,0,0,1-.11-.65l26.43-37.06a.47.47,0,0,1,.65-.11.47.47,0,0,1,.11.65L318.1,187A.46.46,0,0,1,317.72,187.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.6 188.88 336.6 180.16 332.81 177.99 332.83 186.7 336.6 188.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "336.6 188.88 336.6 180.16 332.81 177.99 332.83 186.7 336.6 188.88"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,193.48a.15.15,0,0,1-.11,0,.21.21,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.23.23,0,0,1-.12.2l-7.55,4.36A.19.19,0,0,1,329.05,193.48Zm.23-8.82v8.18l7.08-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,191.3a.23.23,0,0,1-.23-.18.25.25,0,0,1,.19-.28l11.34-2.19a.24.24,0,0,1,.27.19.22.22,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,195.66a.22.22,0,0,1-.22-.19.23.23,0,0,1,.18-.27L329,193a.23.23,0,0,1,.27.19.22.22,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,200a.23.23,0,0,1-.23-.18.24.24,0,0,1,.18-.28l11.34-2.19a.25.25,0,0,1,.28.19.24.24,0,0,1-.19.27L310.23,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,204.38a.23.23,0,0,1-.23-.18.24.24,0,0,1,.18-.28l11.34-2.19a.25.25,0,0,1,.28.19.23.23,0,0,1-.19.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,208.74a.23.23,0,0,1-.23-.19.24.24,0,0,1,.19-.27l11.34-2.19a.24.24,0,0,1,.27.19.24.24,0,0,1-.19.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.57,213.1a.23.23,0,0,1-.23-.18.25.25,0,0,1,.19-.28l11.34-2.19a.24.24,0,0,1,.27.19.23.23,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6,189.12a.15.15,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1-.08-.31.23.23,0,0,1,.32-.09l7.55,4.36a.24.24,0,0,1,.09.32A.27.27,0,0,1,336.6,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,193.48a.15.15,0,0,1-.11,0,.23.23,0,0,1-.09-.31l7.55-13.08a.23.23,0,0,1,.32-.09.24.24,0,0,1,.09.32l-7.56,13.08A.24.24,0,0,1,329.05,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,197.84a.19.19,0,0,1-.12,0,.22.22,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2l7.55-4.36a.26.26,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.11.2l-7.55,4.36A.19.19,0,0,1,321.5,197.84Zm.23-8.82v8.18l7.09-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,193.48a.19.19,0,0,1-.12,0l-7.55-4.36a.22.22,0,0,1-.08-.31.23.23,0,0,1,.32-.09l7.55,4.36a.23.23,0,0,1,.08.32A.24.24,0,0,1,329.05,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,197.84a.19.19,0,0,1-.12,0,.22.22,0,0,1-.08-.31l7.55-13.08a.23.23,0,1,1,.4.23l-7.55,13.08A.24.24,0,0,1,321.5,197.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,202.2l-.12,0a.23.23,0,0,1-.11-.2v-8.73a.24.24,0,0,1,.12-.2l7.55-4.36a.25.25,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.72a.25.25,0,0,1-.11.21l-7.56,4.36A.2.2,0,0,1,314,202.2Zm.23-8.82v8.18l7.09-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,197.84a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1,.23-.41l7.56,4.36a.24.24,0,0,1,.08.32A.22.22,0,0,1,321.5,197.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,202.2l-.12,0a.23.23,0,0,1-.08-.32l7.55-13.08a.23.23,0,0,1,.32-.09.24.24,0,0,1,.08.32l-7.55,13.08A.22.22,0,0,1,314,202.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,206.56l-.12,0a.24.24,0,0,1-.12-.2V197.6a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.22.22,0,0,1,.12.2V202a.22.22,0,0,1-.12.2l-7.55,4.36A.2.2,0,0,1,306.4,206.56Zm.23-8.82v8.18l7.08-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,202.2l-.12,0-7.55-4.36a.24.24,0,1,1,.23-.41l7.55,4.36a.24.24,0,0,1,.09.32A.23.23,0,0,1,314,202.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,206.56l-.12,0a.24.24,0,0,1-.09-.32l7.56-13.08a.23.23,0,0,1,.31-.09.24.24,0,0,1,.09.32l-7.55,13.08A.23.23,0,0,1,306.4,206.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,210.92a.2.2,0,0,1-.11,0,.24.24,0,0,1-.12-.2V202a.24.24,0,0,1,.12-.21l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.73a.24.24,0,0,1-.12.2L299,210.89A.27.27,0,0,1,298.84,210.92Zm.23-8.82v8.18l7.08-4.09V198Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,206.56a.2.2,0,0,1-.11,0l-7.55-4.36a.23.23,0,0,1-.09-.32.24.24,0,0,1,.32-.09l7.55,4.37a.23.23,0,0,1,.09.31A.25.25,0,0,1,306.39,206.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,210.92a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.24.24,0,1,1,.41.23l-7.55,13.08A.25.25,0,0,1,298.84,210.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,215.28a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.11-.2l7.56-4.37a.24.24,0,0,1,.23,0,.25.25,0,0,1,.11.21v8.72a.23.23,0,0,1-.11.2l-7.55,4.36A.27.27,0,0,1,291.29,215.28Zm.23-8.82v8.18l7.09-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,210.92a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1,.24-.4l7.55,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,215.28a.2.2,0,0,1-.11,0,.23.23,0,0,1-.09-.32l7.55-13.08a.24.24,0,0,1,.32-.09.23.23,0,0,1,.08.32l-7.55,13.08A.22.22,0,0,1,291.29,215.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,191.3a.2.2,0,0,1-.11,0,.24.24,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36Zm.24-8.82v8.19l7.08-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.81,186.94a.2.2,0,0,1-.11,0l-7.55-4.36a.24.24,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.24.24,0,0,1,.09.32A.26.26,0,0,1,332.81,186.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,191.3a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.23.23,0,0,1,.32-.08.24.24,0,0,1,.09.32l-7.55,13.08A.26.26,0,0,1,325.26,191.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,195.66a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36A.27.27,0,0,1,317.71,195.66Zm.23-8.82V195l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,191.3a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1,.24-.4l7.55,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,195.66a.2.2,0,0,1-.11,0,.22.22,0,0,1-.09-.31l7.55-13.09a.23.23,0,0,1,.32-.08.23.23,0,0,1,.08.32l-7.55,13.08A.23.23,0,0,1,317.71,195.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,200a.27.27,0,0,1-.12,0,.22.22,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2l7.55-4.36a.25.25,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2L310.28,200Zm.23-8.81v8.18l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,195.66a.27.27,0,0,1-.12,0L310,191.27A.22.22,0,0,1,310,191a.22.22,0,0,1,.31-.09l7.56,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,200a.27.27,0,0,1-.12,0,.22.22,0,0,1-.08-.31l7.55-13.09a.23.23,0,0,1,.4.24l-7.55,13.08A.23.23,0,0,1,310.16,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,204.39a.19.19,0,0,1-.12,0,.22.22,0,0,1-.11-.2v-8.72a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.22.22,0,0,1,.12.2v8.72a.21.21,0,0,1-.12.2l-7.55,4.36A.15.15,0,0,1,302.61,204.39Zm.23-8.82v8.18l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,200a.19.19,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.09-.31.23.23,0,0,1,.32-.09l7.55,4.36a.23.23,0,0,1,.09.32A.24.24,0,0,1,310.16,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,204.39a.19.19,0,0,1-.12,0,.22.22,0,0,1-.08-.31L310,191a.21.21,0,0,1,.31-.09.23.23,0,0,1,.09.32l-7.55,13.08A.24.24,0,0,1,302.61,204.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,208.75a.21.21,0,0,1-.12,0,.26.26,0,0,1-.12-.21v-8.72a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.23.23,0,0,1-.12.2l-7.55,4.37A.23.23,0,0,1,295.06,208.75Zm.23-8.82v8.18l7.08-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,204.39a.19.19,0,0,1-.12,0L294.94,200a.24.24,0,1,1,.23-.41l7.55,4.36a.24.24,0,0,1,.09.32A.25.25,0,0,1,302.61,204.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,208.75a.24.24,0,0,1-.12,0,.24.24,0,0,1-.09-.32l7.55-13.08a.23.23,0,0,1,.32-.09.24.24,0,0,1,.09.32l-7.55,13.08A.25.25,0,0,1,295.06,208.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,213.11a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.73a.22.22,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.21l-7.55,4.36Zm.23-8.82v8.18l7.08-4.09V200.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05,208.75a.2.2,0,0,1-.11,0l-7.55-4.36a.23.23,0,0,1-.09-.32.24.24,0,0,1,.32-.09l7.55,4.36a.24.24,0,0,1,.09.32A.25.25,0,0,1,295.05,208.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,215.28a.2.2,0,0,1-.11,0l-3.79-2.17a.22.22,0,0,1-.11-.14.22.22,0,0,1,0-.18l7.55-13.08a.24.24,0,1,1,.41.23l-7.44,12.88,3.59,2.06a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.6 167.08 336.6 158.36 332.81 156.19 332.83 164.9 336.6 167.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "336.6 167.08 336.6 158.36 332.81 156.19 332.83 164.9 336.6 167.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,171.67a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36A.27.27,0,0,1,329.05,171.67Zm.23-8.82V171l7.08-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,169.5a.23.23,0,0,1-.23-.19.24.24,0,0,1,.19-.27l11.34-2.19a.24.24,0,0,1,.27.19.23.23,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,173.86a.23.23,0,0,1,0-.46L329,171.21a.23.23,0,0,1,.27.19.23.23,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,178.22a.23.23,0,0,1-.05-.46l11.34-2.19a.25.25,0,0,1,.28.19.24.24,0,0,1-.19.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,182.58a.23.23,0,0,1-.23-.19.23.23,0,0,1,.18-.27l11.34-2.19a.25.25,0,0,1,.28.19.24.24,0,0,1-.19.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,186.94a.24.24,0,0,1-.23-.19.24.24,0,0,1,.19-.27l11.34-2.19a.23.23,0,1,1,.08.46l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.57,191.3a.24.24,0,0,1-.23-.19.24.24,0,0,1,.19-.27l11.34-2.19a.24.24,0,0,1,.27.19.23.23,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6,167.31a.2.2,0,0,1-.11,0l-7.56-4.36a.24.24,0,0,1-.08-.32.23.23,0,0,1,.32-.08l7.55,4.36a.24.24,0,0,1,.09.32A.26.26,0,0,1,336.6,167.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,171.67a.2.2,0,0,1-.11,0,.23.23,0,0,1-.09-.31l7.55-13.09a.23.23,0,0,1,.32-.08.24.24,0,0,1,.09.32l-7.56,13.08A.23.23,0,0,1,329.05,171.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,176a.27.27,0,0,1-.12,0,.22.22,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2l7.55-4.36a.26.26,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2L321.62,176A.27.27,0,0,1,321.5,176Zm.23-8.81v8.18l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,171.67a.27.27,0,0,1-.12,0l-7.55-4.36a.22.22,0,0,1-.08-.31.23.23,0,0,1,.32-.09l7.55,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,176a.27.27,0,0,1-.12,0,.22.22,0,0,1-.08-.31l7.55-13.09a.23.23,0,0,1,.4.24l-7.55,13.08A.23.23,0,0,1,321.5,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,180.4a.19.19,0,0,1-.12,0,.22.22,0,0,1-.11-.2v-8.72a.24.24,0,0,1,.12-.2l7.55-4.36a.25.25,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.11.2l-7.56,4.36A.15.15,0,0,1,314,180.4Zm.23-8.82v8.18l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,176a.19.19,0,0,1-.12,0l-7.55-4.36a.22.22,0,0,1-.08-.31.22.22,0,0,1,.31-.09l7.56,4.36a.24.24,0,0,1-.12.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,180.4a.19.19,0,0,1-.12,0,.22.22,0,0,1-.08-.31L321.3,167a.23.23,0,0,1,.32-.09.24.24,0,0,1,.08.32l-7.55,13.08A.24.24,0,0,1,314,180.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,184.76a.19.19,0,0,1-.12,0,.23.23,0,0,1-.12-.2V175.8a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.22.22,0,0,1,.12.2v8.72a.21.21,0,0,1-.12.2l-7.55,4.36A.15.15,0,0,1,306.4,184.76Zm.23-8.82v8.18l7.08-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,180.4a.19.19,0,0,1-.12,0L306.28,176a.23.23,0,0,1-.09-.31.24.24,0,0,1,.32-.09l7.55,4.36a.24.24,0,0,1,.09.32A.25.25,0,0,1,314,180.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,184.76a.19.19,0,0,1-.12,0,.23.23,0,0,1-.09-.31l7.56-13.08a.22.22,0,0,1,.31-.09.24.24,0,0,1,.09.32l-7.55,13.08A.25.25,0,0,1,306.4,184.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,189.12a.2.2,0,0,1-.11,0,.24.24,0,0,1-.12-.2v-8.73a.22.22,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.26.26,0,0,1-.12.21L299,189.09A.27.27,0,0,1,298.84,189.12Zm.23-8.82v8.18l7.08-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,184.76a.2.2,0,0,1-.11,0l-7.55-4.36a.23.23,0,0,1-.09-.32A.24.24,0,0,1,299,180l7.55,4.36a.24.24,0,0,1,.09.32A.25.25,0,0,1,306.39,184.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,189.12a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.24.24,0,1,1,.41.23L299.05,189A.25.25,0,0,1,298.84,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,193.48a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.73a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.23.23,0,0,1,.11.2v8.73a.23.23,0,0,1-.11.2l-7.55,4.36A.27.27,0,0,1,291.29,193.48Zm.23-8.82v8.18l7.09-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,189.12a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1-.08-.32.24.24,0,0,1,.32-.09l7.55,4.36a.23.23,0,0,1,.08.32A.22.22,0,0,1,298.84,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,193.48a.2.2,0,0,1-.11,0,.23.23,0,0,1-.09-.32l7.55-13.08A.24.24,0,0,1,299,180a.23.23,0,0,1,.08.32l-7.55,13.08A.22.22,0,0,1,291.29,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,169.5a.2.2,0,0,1-.11,0,.24.24,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2L332.7,156a.24.24,0,0,1,.23,0,.23.23,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36Zm.24-8.82v8.19l7.08-4.1v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.81,165.14a.2.2,0,0,1-.11,0l-7.55-4.36a.24.24,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.23.23,0,0,1,.09.31A.25.25,0,0,1,332.81,165.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,169.5a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.24.24,0,0,1,.41.23l-7.55,13.09A.26.26,0,0,1,325.26,169.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,173.86a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36Zm.23-8.82v8.19l7.09-4.09V161Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,169.5a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,1,1,.24-.4l7.55,4.36a.23.23,0,0,1,.08.32A.23.23,0,0,1,325.26,169.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,173.86a.2.2,0,0,1-.11,0,.23.23,0,0,1-.09-.32l7.55-13.08a.23.23,0,0,1,.32-.08.22.22,0,0,1,.08.31l-7.55,13.09A.23.23,0,0,1,317.71,173.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,178.22a.27.27,0,0,1-.12,0,.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2l7.55-4.36a.25.25,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2l-7.55,4.36A.27.27,0,0,1,310.16,178.22Zm.23-8.82v8.19l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,173.86l-.12,0L310,169.47a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l7.56,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,178.22a.27.27,0,0,1-.12,0,.23.23,0,0,1-.08-.32l7.55-13.08a.23.23,0,1,1,.4.24l-7.55,13.08A.23.23,0,0,1,310.16,178.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,182.58a.27.27,0,0,1-.12,0,.23.23,0,0,1-.11-.2v-8.72a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.22.22,0,0,1,.12.2V178a.22.22,0,0,1-.12.2l-7.55,4.36A.2.2,0,0,1,302.61,182.58Zm.23-8.82V182l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,178.22a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.23.23,0,0,1-.11.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,182.58a.27.27,0,0,1-.12,0,.22.22,0,0,1-.08-.31L310,169.15a.22.22,0,0,1,.31-.08.23.23,0,0,1,.09.32l-7.55,13.08A.23.23,0,0,1,302.61,182.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,186.94a.21.21,0,0,1-.12,0,.23.23,0,0,1-.12-.2V178a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36A.23.23,0,0,1,295.06,186.94Zm.23-8.81v8.18l7.08-4.09V174Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,182.58a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.09-.31.23.23,0,0,1,.32-.09l7.55,4.36a.23.23,0,0,1-.11.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,186.94a.24.24,0,0,1-.12,0,.23.23,0,0,1-.09-.31l7.55-13.09a.23.23,0,0,1,.32-.08.24.24,0,0,1,.09.32l-7.55,13.08A.24.24,0,0,1,295.06,186.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,191.31a.15.15,0,0,1-.11,0,.21.21,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.23.23,0,0,1-.12.2l-7.55,4.36A.19.19,0,0,1,287.5,191.31Zm.23-8.82v8.18l7.08-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05,187a.15.15,0,0,1-.11,0l-7.55-4.36a.22.22,0,0,1-.09-.31.23.23,0,0,1,.32-.09l7.55,4.36a.24.24,0,0,1,.09.32A.27.27,0,0,1,295.05,187Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,193.48a.2.2,0,0,1-.11,0l-3.79-2.18a.22.22,0,0,1-.11-.14.2.2,0,0,1,0-.17l7.55-13.08a.23.23,0,0,1,.32-.09.24.24,0,0,1,.09.32L287.82,191l3.59,2a.23.23,0,0,1,.08.32A.22.22,0,0,1,291.29,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.6 241.21 336.6 232.49 332.81 230.31 332.83 239.03 336.6 241.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "336.6 241.21 336.6 232.49 332.81 230.31 332.83 239.03 336.6 241.21"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,245.8a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.25.25,0,0,1,.11-.21l7.56-4.36a.24.24,0,0,1,.23,0,.26.26,0,0,1,.12.21v8.72a.24.24,0,0,1-.12.2l-7.55,4.36Zm.23-8.82v8.18l7.08-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,243.63a.24.24,0,0,1-.23-.19.23.23,0,0,1,.19-.27L336.56,241a.23.23,0,0,1,.27.18.22.22,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.72,248a.23.23,0,0,1-.22-.19.22.22,0,0,1,.18-.27L329,245.34a.22.22,0,0,1,.27.18.23.23,0,0,1-.18.28L317.77,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,252.35a.24.24,0,0,1-.23-.19.22.22,0,0,1,.18-.27l11.34-2.19a.25.25,0,0,1,.28.18.23.23,0,0,1-.19.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,256.71a.24.24,0,0,1-.23-.19.22.22,0,0,1,.18-.27l11.34-2.19a.24.24,0,0,1,.28.18.23.23,0,0,1-.19.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,261.07a.24.24,0,0,1-.23-.19.23.23,0,0,1,.19-.27l11.34-2.19a.23.23,0,0,1,.27.18.25.25,0,0,1-.19.28l-11.34,2.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.57,265.43a.24.24,0,0,1-.23-.19.23.23,0,0,1,.19-.27l11.34-2.19a.23.23,0,0,1,.27.18.22.22,0,0,1-.18.27l-11.34,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6,241.44a.2.2,0,0,1-.11,0l-7.56-4.36a.24.24,0,0,1,.24-.41l7.55,4.37a.23.23,0,0,1,.09.31A.25.25,0,0,1,336.6,241.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,245.8a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.24.24,0,1,1,.41.23l-7.56,13.08A.22.22,0,0,1,329.05,245.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,250.16a.27.27,0,0,1-.12,0,.23.23,0,0,1-.11-.2v-8.72a.22.22,0,0,1,.11-.2l7.55-4.37a.26.26,0,0,1,.24,0,.25.25,0,0,1,.11.21v8.72a.23.23,0,0,1-.11.2l-7.55,4.36A.27.27,0,0,1,321.5,250.16Zm.23-8.82v8.19l7.09-4.1v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.05,245.8l-.12,0-7.55-4.36a.23.23,0,0,1,.24-.4l7.55,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,250.16a.27.27,0,0,1-.12,0,.23.23,0,0,1-.08-.32l7.55-13.08a.24.24,0,0,1,.32-.09.23.23,0,0,1,.08.32L321.7,250A.22.22,0,0,1,321.5,250.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,254.52l-.12,0a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.12-.2l7.55-4.36a.26.26,0,0,1,.24,0,.22.22,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2l-7.56,4.36A.2.2,0,0,1,314,254.52Zm.23-8.82v8.19l7.09-4.1v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,250.16a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.08-.32.22.22,0,0,1,.31-.08l7.56,4.36a.23.23,0,0,1,.08.31A.22.22,0,0,1,321.5,250.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,254.52l-.12,0a.23.23,0,0,1-.08-.32l7.55-13.08a.23.23,0,0,1,.4.23l-7.55,13.08A.22.22,0,0,1,314,254.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,258.88l-.12,0a.24.24,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.21.21,0,0,1,.12.2v8.72a.22.22,0,0,1-.12.2l-7.55,4.36A.2.2,0,0,1,306.4,258.88Zm.23-8.82v8.19l7.08-4.09V246Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,254.52l-.12,0-7.55-4.36a.24.24,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.24.24,0,0,1,.09.32A.24.24,0,0,1,314,254.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,258.88l-.12,0a.24.24,0,0,1-.09-.32l7.56-13.08a.22.22,0,0,1,.31-.08.23.23,0,0,1,.09.31l-7.55,13.09A.24.24,0,0,1,306.4,258.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,263.24a.2.2,0,0,1-.11,0,.24.24,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2L299,263.21A.27.27,0,0,1,298.84,263.24Zm.23-8.82v8.19l7.08-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,258.88a.2.2,0,0,1-.11,0l-7.55-4.36a.23.23,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.24.24,0,0,1,.09.32A.26.26,0,0,1,306.39,258.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,263.24a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.23.23,0,0,1,.32-.08.24.24,0,0,1,.09.32l-7.55,13.08A.26.26,0,0,1,298.84,263.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,267.6a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.23.23,0,0,1,.11.2V263a.23.23,0,0,1-.11.2l-7.55,4.36Zm.23-8.82V267l7.09-4.09v-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,263.24a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,1,1,.24-.4l7.55,4.36a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,267.6a.2.2,0,0,1-.11,0,.22.22,0,0,1-.09-.31l7.55-13.09a.23.23,0,0,1,.4.24l-7.55,13.08A.23.23,0,0,1,291.29,267.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,243.63a.2.2,0,0,1-.11,0,.26.26,0,0,1-.12-.21v-8.72a.22.22,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2V239a.26.26,0,0,1-.12.21l-7.55,4.36Zm.24-8.82V243l7.08-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.81,239.27a.2.2,0,0,1-.11,0l-7.55-4.36a.24.24,0,1,1,.23-.41l7.55,4.36a.24.24,0,0,1,.09.32A.27.27,0,0,1,332.81,239.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,243.63a.2.2,0,0,1-.11,0,.24.24,0,0,1-.09-.32l7.55-13.08a.24.24,0,1,1,.41.23l-7.55,13.08A.25.25,0,0,1,325.26,243.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,248a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2V239a.23.23,0,0,1,.11-.2l7.56-4.36a.24.24,0,0,1,.23,0,.24.24,0,0,1,.12.2v8.72a.26.26,0,0,1-.12.21L317.83,248Zm.23-8.82v8.18l7.09-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,243.63a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1-.08-.32.24.24,0,0,1,.32-.09l7.55,4.36a.23.23,0,0,1,.08.32A.22.22,0,0,1,325.26,243.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,248a.2.2,0,0,1-.11,0,.23.23,0,0,1-.09-.32l7.55-13.08a.24.24,0,0,1,.32-.09.23.23,0,0,1,.08.32l-7.55,13.08A.22.22,0,0,1,317.71,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,252.35a.27.27,0,0,1-.12,0,.23.23,0,0,1-.11-.2V243.4a.25.25,0,0,1,.11-.21l7.55-4.36a.26.26,0,0,1,.24,0,.23.23,0,0,1,.11.2v8.73a.23.23,0,0,1-.11.2l-7.55,4.36A.27.27,0,0,1,310.16,252.35Zm.23-8.82v8.18l7.09-4.09v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,248l-.12,0L310,243.6a.24.24,0,0,1,.23-.41l7.56,4.36a.23.23,0,0,1,.08.32A.22.22,0,0,1,317.71,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,252.35a.27.27,0,0,1-.12,0A.23.23,0,0,1,310,252l7.55-13.08a.24.24,0,0,1,.32-.09.23.23,0,0,1,.08.32l-7.55,13.08A.22.22,0,0,1,310.16,252.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,256.71l-.12,0a.23.23,0,0,1-.11-.2v-8.72a.26.26,0,0,1,.12-.21l7.55-4.36a.24.24,0,0,1,.35.21v8.72a.22.22,0,0,1-.12.2l-7.55,4.36A.2.2,0,0,1,302.61,256.71Zm.23-8.82v8.18l7.09-4.09V243.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,252.35a.27.27,0,0,1-.12,0L302.49,248a.24.24,0,0,1,.23-.41l7.55,4.37a.23.23,0,0,1-.11.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,256.71l-.12,0a.23.23,0,0,1-.08-.32L310,243.28a.23.23,0,0,1,.31-.09.23.23,0,0,1,.09.32l-7.55,13.08A.22.22,0,0,1,302.61,256.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,261.07a.21.21,0,0,1-.12,0,.24.24,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.12-.2l7.55-4.37a.24.24,0,0,1,.23,0,.26.26,0,0,1,.12.21v8.72a.24.24,0,0,1-.12.2L295.17,261A.23.23,0,0,1,295.06,261.07Zm.23-8.82v8.19l7.08-4.1v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.61,256.71l-.12,0-7.55-4.36a.24.24,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.23.23,0,0,1-.11.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.06,261.07a.24.24,0,0,1-.12,0,.24.24,0,0,1-.09-.32l7.55-13.08a.24.24,0,1,1,.41.23L295.26,261A.23.23,0,0,1,295.06,261.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,265.43a.2.2,0,0,1-.11,0,.22.22,0,0,1-.12-.2v-8.72a.21.21,0,0,1,.12-.2l7.55-4.36a.24.24,0,0,1,.23,0,.23.23,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2l-7.55,4.36A.27.27,0,0,1,287.5,265.43Zm.23-8.82v8.19l7.08-4.1v-8.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05,261.07a.2.2,0,0,1-.11,0l-7.55-4.36a.23.23,0,0,1-.09-.32.23.23,0,0,1,.32-.08l7.55,4.36a.23.23,0,0,1,.09.31A.25.25,0,0,1,295.05,261.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.29,267.6a.2.2,0,0,1-.11,0l-3.79-2.17a.22.22,0,0,1-.11-.14.23.23,0,0,1,0-.18L294.85,252a.24.24,0,0,1,.41.23l-7.44,12.88,3.59,2.06a.23.23,0,0,1-.12.43Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tower--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.24,339.78a.47.47,0,0,1-.46-.47V287.07a.47.47,0,1,1,.93,0v52.24A.47.47,0,0,1,124.24,339.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,342a.47.47,0,0,1-.47-.47V289.17a.47.47,0,0,1,.93,0v52.32A.47.47,0,0,1,120.47,342Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,339.54a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,339.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,337.36a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,337.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,335.18a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,335.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,333a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41L120.58,333A.2.2,0,0,1,120.47,333Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,330.82a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.23.23,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,330.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,328.63a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,328.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,326.45a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,326.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,324.27a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,324.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,322.09a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,322.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,319.91a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,319.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,317.73a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,317.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,315.55a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,315.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,313.37a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,313.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,311.18a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.14.14,0,0,1,120.47,311.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,309a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32L120.58,309A.2.2,0,0,1,120.47,309Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,306.82a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,306.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,304.64a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,304.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,302.46a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,302.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,300.28a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,300.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,298.1a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,298.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,295.92a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.23.23,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,295.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,293.73a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,293.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,291.55a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,291.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,344.14a.53.53,0,0,1-.24-.06L143.12,329l-26.2,15.13a.47.47,0,0,1-.46-.81L142.89,328a.49.49,0,0,1,.47,0l26.43,15.26a.47.47,0,0,1,.17.64A.46.46,0,0,1,169.56,344.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,291.81a.53.53,0,0,1-.24-.06l-26.2-15.12-26.2,15.12a.45.45,0,0,1-.63-.17.46.46,0,0,1,.17-.63l26.43-15.26a.44.44,0,0,1,.47,0L169.79,291a.46.46,0,0,1-.23.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 344.25 131.81 335.52 131.81 282.64 146.9 291.35 146.9 344.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 344.25 158.23 337.66 158.23 284.81 146.9 291.35 146.9 344.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 282.64 143.12 276.09 158.23 284.81 146.9 291.35 131.81 282.64",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 282.64 143.12 276.09 158.23 284.81 146.9 291.35 131.81 282.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,359.4a.46.46,0,0,1-.23-.06l-26.43-15.26a.47.47,0,0,1-.23-.41V291.35a.44.44,0,0,1,.23-.4.43.43,0,0,1,.46,0l26.44,15.26a.47.47,0,0,1,.23.4v52.32a.49.49,0,0,1-.23.41A.53.53,0,0,1,143.12,359.4Zm-26-16,25.5,14.72V306.88l-25.5-14.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,359.4a.46.46,0,0,1-.23-.06.49.49,0,0,1-.23-.41V306.61a.47.47,0,0,1,.23-.4L169.32,291a.44.44,0,0,1,.47,0,.46.46,0,0,1,.23.4v52.32a.49.49,0,0,1-.23.41l-26.43,15.26A.53.53,0,0,1,143.12,359.4Zm.47-52.52v51.25l25.5-14.72V292.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,359.4a.46.46,0,0,1-.43-.3l-26.43-67.58a.46.46,0,0,1,.86-.34l26.44,67.59a.47.47,0,0,1-.27.6A.47.47,0,0,1,143.12,359.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,344.14a.46.46,0,0,1-.38-.2l-26.44-37.06a.47.47,0,0,1,.76-.54l26.44,37.06a.47.47,0,0,1-.11.65A.46.46,0,0,1,169.56,344.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,287.45a.46.46,0,0,1-.46-.46V234.74a.47.47,0,0,1,.93,0V287A.46.46,0,0,1,124.24,287.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,289.64a.47.47,0,0,1-.47-.47V236.85a.47.47,0,1,1,.93,0v52.32A.47.47,0,0,1,120.47,289.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,287.22a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,287.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,285a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31L120.58,285A.15.15,0,0,1,120.47,285Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,282.85a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,282.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,280.67a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,280.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,278.49a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,278.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,276.31a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,276.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,274.13a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,274.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,272a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,272Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,269.77a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,269.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,267.59a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.23.23,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,267.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,265.4a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,265.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,263.22a.23.23,0,0,1-.12-.43l3.78-2.18a.23.23,0,0,1,.23.4l-3.78,2.18A.2.2,0,0,1,120.47,263.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,261a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32L120.58,261A.2.2,0,0,1,120.47,261Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,258.86a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,258.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,256.68a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,256.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,254.5a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,254.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,252.32a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,252.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,250.14a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,250.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,248a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,245.77a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,245.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,243.59a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,243.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,241.41a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,241.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,239.23a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,239.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,291.81a.53.53,0,0,1-.24-.06l-26.2-15.12-26.2,15.12a.45.45,0,0,1-.63-.17.46.46,0,0,1,.17-.63l26.43-15.26a.44.44,0,0,1,.47,0L169.79,291a.46.46,0,0,1-.23.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,239.49a.53.53,0,0,1-.24-.06l-26.2-15.13-26.2,15.13a.47.47,0,0,1-.46-.81l26.43-15.26a.49.49,0,0,1,.47,0l26.43,15.26a.47.47,0,0,1,.17.64A.46.46,0,0,1,169.56,239.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 291.93 131.81 283.2 131.81 230.31 146.9 239.03 146.9 291.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 291.93 158.23 285.33 158.23 232.49 146.9 239.03 146.9 291.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 230.31 143.12 223.76 158.23 232.49 146.9 239.03 131.81 230.31",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 230.31 143.12 223.76 158.23 232.49 146.9 239.03 131.81 230.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,307.08a.39.39,0,0,1-.23-.07l-26.43-15.26a.44.44,0,0,1-.23-.4V239a.47.47,0,0,1,.23-.41.47.47,0,0,1,.46,0l26.44,15.27a.46.46,0,0,1,.23.4v52.32a.46.46,0,0,1-.23.4A.44.44,0,0,1,143.12,307.08Zm-26-16,25.5,14.73V254.56l-25.5-14.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,307.08a.39.39,0,0,1-.23-.07.46.46,0,0,1-.23-.4V254.29a.46.46,0,0,1,.23-.4l26.43-15.27a.47.47,0,0,1,.7.41v52.32a.46.46,0,0,1-.23.4L143.36,307A.44.44,0,0,1,143.12,307.08Zm.47-52.52v51.25l25.5-14.73V239.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,307.08a.47.47,0,0,1-.43-.3L116.26,239.2a.46.46,0,1,1,.86-.34l26.44,67.58a.47.47,0,0,1-.27.6A.33.33,0,0,1,143.12,307.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,291.81a.45.45,0,0,1-.38-.19l-26.44-37.06a.47.47,0,0,1,.11-.65.47.47,0,0,1,.65.11l26.44,37.06a.47.47,0,0,1-.11.65A.45.45,0,0,1,169.56,291.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,235.13a.47.47,0,0,1-.46-.46V182.42a.47.47,0,0,1,.93,0v52.25A.47.47,0,0,1,124.24,235.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,237.31a.47.47,0,0,1-.47-.46V184.52a.47.47,0,0,1,.93,0v52.33A.47.47,0,0,1,120.47,237.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,234.89a.23.23,0,0,1-.12-.43l3.78-2.18a.23.23,0,0,1,.23.4l-3.78,2.18A.2.2,0,0,1,120.47,234.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,232.71a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,232.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,230.53a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,230.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,228.35a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,228.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,226.17a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,226.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,224a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41L120.58,224A.2.2,0,0,1,120.47,224Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,221.81a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,221.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,219.62a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,219.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,217.44a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,217.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,215.26a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,215.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,213.08a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,213.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,210.9a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,210.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,208.72a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,208.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,206.54a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,206.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,204.36a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,204.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,202.17a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,202.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,200a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32L120.58,200A.2.2,0,0,1,120.47,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,197.81a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,197.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,195.63a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,195.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,193.45a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,193.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,191.27a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,191.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,189.09a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.17A.15.15,0,0,1,120.47,189.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,186.91a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,186.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,239.49a.53.53,0,0,1-.24-.06l-26.2-15.13-26.2,15.13a.47.47,0,0,1-.46-.81l26.43-15.26a.49.49,0,0,1,.47,0l26.43,15.26a.47.47,0,0,1,.17.64A.46.46,0,0,1,169.56,239.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,187.17a.44.44,0,0,1-.24-.07L143.12,172l-26.2,15.12a.45.45,0,0,1-.63-.17.46.46,0,0,1,.17-.63L142.89,171a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1,.17.63A.47.47,0,0,1,169.56,187.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 239.6 131.81 230.87 131.81 177.99 146.9 186.7 146.9 239.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 239.6 158.23 233.01 158.23 180.16 146.9 186.7 146.9 239.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 177.99 143.12 171.44 158.23 180.16 146.9 186.7 131.81 177.99",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 177.99 143.12 171.44 158.23 180.16 146.9 186.7 131.81 177.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,254.75a.46.46,0,0,1-.23-.06l-26.43-15.26a.45.45,0,0,1-.23-.4V186.7a.45.45,0,0,1,.23-.4.47.47,0,0,1,.46,0l26.44,15.26a.47.47,0,0,1,.23.4v52.33a.47.47,0,0,1-.23.4A.53.53,0,0,1,143.12,254.75Zm-26-16,25.5,14.72V202.23l-25.5-14.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,254.75a.46.46,0,0,1-.23-.06.47.47,0,0,1-.23-.4V202a.47.47,0,0,1,.23-.4l26.43-15.26a.49.49,0,0,1,.47,0,.47.47,0,0,1,.23.4V239a.47.47,0,0,1-.23.4l-26.43,15.26A.53.53,0,0,1,143.12,254.75Zm.47-52.52v51.25l25.5-14.72V187.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,254.75a.46.46,0,0,1-.43-.29l-26.43-67.59a.46.46,0,1,1,.86-.34l26.44,67.59a.46.46,0,0,1-.44.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,239.49a.47.47,0,0,1-.38-.19l-26.44-37.07a.47.47,0,0,1,.76-.54l26.44,37.07a.47.47,0,0,1-.11.65A.53.53,0,0,1,169.56,239.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,182.81a.47.47,0,0,1-.46-.47V130.1a.47.47,0,1,1,.93,0v52.24A.47.47,0,0,1,124.24,182.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,185a.47.47,0,0,1-.47-.47V132.2a.47.47,0,1,1,.93,0v52.32A.47.47,0,0,1,120.47,185Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,182.57a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,182.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,180.39a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,180.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,178.21a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,178.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,176a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.23.23,0,0,1,.31.09.22.22,0,0,1-.08.31L120.58,176A.15.15,0,0,1,120.47,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,173.84a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,173.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,171.66a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,171.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,169.48a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,169.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,167.3a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,167.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,165.12a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,165.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,162.94a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,162.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,160.76a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,160.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,158.58a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,158.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,156.39a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,156.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,154.21a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,154.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,152a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32L120.58,152A.2.2,0,0,1,120.47,152Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,149.85a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,149.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,147.67a.23.23,0,0,1-.12-.43l3.78-2.19a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,147.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,145.49a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.24.24,0,0,1,.23.41l-3.78,2.18A.2.2,0,0,1,120.47,145.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,143.31a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.23.23,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.19A.2.2,0,0,1,120.47,143.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,141.13a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.78-2.18a.23.23,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.15.15,0,0,1,120.47,141.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,138.94a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-3.78,2.18A.2.2,0,0,1,120.47,138.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,136.76a.23.23,0,0,1-.12-.43l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,136.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,134.58a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l3.78-2.18a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-3.78,2.18A.2.2,0,0,1,120.47,134.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,187.17a.44.44,0,0,1-.24-.07L143.12,172l-26.2,15.12a.45.45,0,0,1-.63-.17.46.46,0,0,1,.17-.63L142.89,171a.49.49,0,0,1,.47,0l26.43,15.26a.46.46,0,0,1,.17.63A.47.47,0,0,1,169.56,187.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,134.84a.53.53,0,0,1-.24-.06l-26.2-15.13-26.2,15.13a.45.45,0,0,1-.63-.17.46.46,0,0,1,.17-.63l26.43-15.26a.44.44,0,0,1,.47,0L169.79,134a.46.46,0,0,1-.23.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 187.28 131.81 178.55 131.81 125.67 146.9 134.38 146.9 187.28",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.9 187.28 158.23 180.69 158.23 127.84 146.9 134.38 146.9 187.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.81 125.67 143.12 119.12 158.23 127.84 146.9 134.38 131.81 125.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,202.43a.46.46,0,0,1-.23-.06L116.46,187.1a.44.44,0,0,1-.23-.4V134.38a.44.44,0,0,1,.23-.4.43.43,0,0,1,.46,0l26.44,15.26a.46.46,0,0,1,.23.4V202a.49.49,0,0,1-.23.41A.53.53,0,0,1,143.12,202.43Zm-26-16,25.5,14.73V149.91l-25.5-14.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,202.43a.46.46,0,0,1-.23-.06.49.49,0,0,1-.23-.41V149.64a.46.46,0,0,1,.23-.4L169.32,134a.44.44,0,0,1,.47,0,.46.46,0,0,1,.23.4V186.7a.46.46,0,0,1-.23.4l-26.43,15.27A.53.53,0,0,1,143.12,202.43Zm.47-52.52v51.25l25.5-14.73V135.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,202.43a.46.46,0,0,1-.43-.3l-26.43-67.58a.46.46,0,0,1,.86-.34l26.44,67.59a.47.47,0,0,1-.27.6A.47.47,0,0,1,143.12,202.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,187.17a.46.46,0,0,1-.38-.2l-26.44-37.06a.47.47,0,0,1,.11-.65.47.47,0,0,1,.65.11l26.44,37.06a.47.47,0,0,1-.11.65A.46.46,0,0,1,169.56,187.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.68 188.88 150.68 180.16 154.47 177.99 154.45 186.7 150.68 188.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.68 188.88 150.68 180.16 154.47 177.99 154.45 186.7 150.68 188.88"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,193.48a.19.19,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.72a.21.21,0,0,1-.12.2A.15.15,0,0,1,158.23,193.48Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,191.3H162l-11.34-2.19a.22.22,0,0,1-.18-.27.24.24,0,0,1,.27-.19l11.34,2.19a.25.25,0,0,1,.19.28A.23.23,0,0,1,162,191.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,195.66h-.05l-11.34-2.19a.23.23,0,0,1-.18-.27.24.24,0,0,1,.27-.19l11.34,2.19a.24.24,0,0,1,.19.27A.23.23,0,0,1,169.56,195.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,200h0l-11.34-2.19a.22.22,0,0,1-.18-.27.24.24,0,0,1,.27-.19l11.34,2.19a.24.24,0,0,1,.18.28A.22.22,0,0,1,177.1,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,204.38h0l-11.34-2.19a.23.23,0,0,1-.19-.27.25.25,0,0,1,.28-.19l11.34,2.19a.24.24,0,0,1,.18.28A.23.23,0,0,1,184.63,204.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.17,208.74h0l-11.34-2.19a.24.24,0,0,1-.19-.27.24.24,0,0,1,.27-.19l11.35,2.19a.24.24,0,0,1,.18.27A.23.23,0,0,1,192.17,208.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,213.1h0l-11.35-2.19a.23.23,0,0,1,.09-.46l11.34,2.19a.25.25,0,0,1,.19.28A.23.23,0,0,1,199.71,213.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,189.12a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l7.55-4.36a.23.23,0,0,1,.32.09.22.22,0,0,1-.08.31l-7.56,4.36A.15.15,0,0,1,150.68,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,193.48a.24.24,0,0,1-.2-.12l-7.55-13.08a.23.23,0,0,1,.08-.32.23.23,0,0,1,.32.09l7.55,13.08a.22.22,0,0,1-.09.31A.15.15,0,0,1,158.23,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,197.84a.19.19,0,0,1-.12,0l-7.55-4.36a.22.22,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.11.2A.19.19,0,0,1,165.78,197.84Zm-7.32-4.73,7.09,4.09V189l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,193.48a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l7.56-4.36a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-7.55,4.36A.19.19,0,0,1,158.23,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,197.84a.24.24,0,0,1-.2-.12L158,184.64a.23.23,0,1,1,.4-.23L166,197.49a.22.22,0,0,1-.08.31A.19.19,0,0,1,165.78,197.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,202.2a.2.2,0,0,1-.11,0l-7.55-4.36a.24.24,0,0,1-.12-.21v-8.72a.22.22,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.24.24,0,0,1,.12.2V202a.23.23,0,0,1-.11.2A.27.27,0,0,1,173.33,202.2ZM166,197.47l7.09,4.09v-8.18L166,189.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,197.84a.22.22,0,0,1-.2-.12.23.23,0,0,1,.09-.32l7.55-4.36a.24.24,0,0,1,.23.41l-7.55,4.36A.27.27,0,0,1,165.78,197.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,202.2a.22.22,0,0,1-.2-.12L165.58,189a.23.23,0,0,1,.09-.32.22.22,0,0,1,.31.09l7.55,13.08a.23.23,0,0,1-.08.32A.27.27,0,0,1,173.33,202.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,206.56a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.12-.2v-8.73a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0L181,197.4a.24.24,0,0,1,.12.2v8.73a.24.24,0,0,1-.12.2A.2.2,0,0,1,180.89,206.56Zm-7.32-4.73,7.08,4.09v-8.18l-7.08-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,202.2a.23.23,0,0,1-.2-.12.24.24,0,0,1,.09-.32l7.55-4.36a.24.24,0,0,1,.23.41l-7.55,4.36A.27.27,0,0,1,173.33,202.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,206.56a.25.25,0,0,1-.21-.12l-7.55-13.08a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.23.23,0,0,1,180.89,206.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,210.92a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.12-.2V197.6a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.25.25,0,0,1,.11.21v8.72a.22.22,0,0,1-.12.2A.2.2,0,0,1,188.44,210.92Zm-7.32-4.73,7.08,4.09V202.1L181.12,198Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,206.56a.25.25,0,0,1-.21-.12.23.23,0,0,1,.09-.31l7.55-4.37a.24.24,0,0,1,.32.09.24.24,0,0,1-.08.32L181,206.53A.2.2,0,0,1,180.89,206.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,210.92a.22.22,0,0,1-.2-.12l-7.56-13.08a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,188.44,210.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,215.28a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.11-.2V202a.25.25,0,0,1,.11-.21.25.25,0,0,1,.24,0l7.55,4.37a.22.22,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2A.27.27,0,0,1,196,215.28Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,210.92a.23.23,0,0,1-.12-.43l7.55-4.36a.23.23,0,1,1,.24.4l-7.55,4.36A.27.27,0,0,1,188.44,210.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,215.28a.22.22,0,0,1-.2-.12l-7.55-13.08a.23.23,0,0,1,.08-.32.24.24,0,0,1,.32.09l7.55,13.08a.23.23,0,0,1-.08.32A.27.27,0,0,1,196,215.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,191.3l-.12,0-7.55-4.36a.24.24,0,0,1-.12-.2V178a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.12.2A.2.2,0,0,1,162,191.3Zm-7.32-4.72,7.08,4.09v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,186.94a.26.26,0,0,1-.21-.11.24.24,0,0,1,.09-.32l7.55-4.36a.23.23,0,0,1,.32.08.24.24,0,0,1-.08.32l-7.56,4.36A.2.2,0,0,1,154.47,186.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,191.3a.23.23,0,0,1-.2-.11l-7.56-13.08a.24.24,0,0,1,.09-.32.23.23,0,0,1,.32.08L162.22,191a.24.24,0,0,1-.09.32A.2.2,0,0,1,162,191.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,195.66a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2A.27.27,0,0,1,169.57,195.66Zm-7.32-4.72,7.09,4.09v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,191.3a.23.23,0,0,1-.12-.43l7.55-4.36a.23.23,0,0,1,.24.4l-7.55,4.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,195.66a.23.23,0,0,1-.2-.11l-7.55-13.08a.23.23,0,0,1,.08-.32.23.23,0,0,1,.32.08l7.55,13.09a.22.22,0,0,1-.08.31A.27.27,0,0,1,169.57,195.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,200a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.26.26,0,0,1,.24,0l7.55,4.36a.24.24,0,0,1,.12.2v8.72a.22.22,0,0,1-.11.2Zm-7.32-4.72,7.09,4.09v-8.18l-7.09-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,195.66a.23.23,0,0,1-.2-.11.24.24,0,0,1,.08-.32l7.56-4.36a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-7.55,4.36A.27.27,0,0,1,169.57,195.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,200a.23.23,0,0,1-.2-.11l-7.55-13.08a.24.24,0,0,1,.08-.32.23.23,0,0,1,.32.08l7.55,13.09a.22.22,0,0,1-.08.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,204.39a.15.15,0,0,1-.11,0L177,200a.21.21,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.24.24,0,0,1,.12.2v8.72a.23.23,0,0,1-.12.2A.19.19,0,0,1,184.67,204.39Zm-7.31-4.73,7.08,4.09v-8.18l-7.08-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,200a.25.25,0,0,1-.2-.12.24.24,0,0,1,.09-.32l7.55-4.36a.23.23,0,0,1,.32.09.23.23,0,0,1-.09.31L177.24,200A.19.19,0,0,1,177.12,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,204.39a.25.25,0,0,1-.2-.12l-7.55-13.08a.24.24,0,0,1,.09-.32.21.21,0,0,1,.31.09L184.88,204a.23.23,0,0,1-.09.31A.19.19,0,0,1,184.67,204.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,208.75a.27.27,0,0,1-.12,0l-7.55-4.37a.23.23,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.22.22,0,0,1,.12.2v8.72a.26.26,0,0,1-.12.21A.2.2,0,0,1,192.23,208.75ZM184.91,204l7.08,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,204.39a.27.27,0,0,1-.21-.12.24.24,0,0,1,.09-.32l7.55-4.36a.24.24,0,0,1,.32.09.23.23,0,0,1-.09.32l-7.55,4.35A.17.17,0,0,1,184.68,204.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,208.75a.27.27,0,0,1-.21-.12l-7.55-13.08a.24.24,0,0,1,.09-.32.23.23,0,0,1,.32.09l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,192.23,208.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.78,213.11l-.12,0-7.55-4.36a.24.24,0,0,1-.11-.21v-8.72a.23.23,0,0,1,.11-.2.24.24,0,0,1,.23,0L199.9,204a.23.23,0,0,1,.11.2v8.73a.22.22,0,0,1-.12.2A.2.2,0,0,1,199.78,213.11Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,208.75a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l7.55-4.36a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-7.56,4.36A.2.2,0,0,1,192.23,208.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,215.28a.23.23,0,0,1-.12-.43l3.59-2.06L192,199.91a.23.23,0,0,1,.08-.32.24.24,0,0,1,.32.09L200,212.76a.22.22,0,0,1,0,.18.19.19,0,0,1-.11.14l-3.79,2.17A.2.2,0,0,1,196,215.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.68 167.08 150.68 158.36 154.47 156.19 154.45 164.9 150.68 167.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.68 167.08 150.68 158.36 154.47 156.19 154.45 164.9 150.68 167.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,171.67a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.12.2A.2.2,0,0,1,158.23,171.67ZM150.91,167,158,171v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,169.5H162l-11.34-2.19a.23.23,0,0,1-.18-.27.24.24,0,0,1,.27-.19L162.06,169a.24.24,0,0,1,.19.27A.23.23,0,0,1,162,169.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,173.86h-.05l-11.34-2.19a.23.23,0,0,1,.09-.46l11.34,2.19a.24.24,0,0,1,.19.27A.24.24,0,0,1,169.56,173.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,178.22h0L165.71,176a.22.22,0,0,1-.18-.27.24.24,0,0,1,.27-.19l11.34,2.19a.23.23,0,0,1,0,.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,182.58h0l-11.34-2.19a.24.24,0,0,1-.19-.27.25.25,0,0,1,.28-.19l11.34,2.19a.23.23,0,0,1,.18.27A.23.23,0,0,1,184.63,182.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.17,186.94h0l-11.34-2.19a.23.23,0,1,1,.08-.46l11.35,2.19a.24.24,0,0,1,.18.27A.24.24,0,0,1,192.17,186.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,191.3h0l-11.35-2.19a.23.23,0,0,1,.09-.46l11.34,2.19a.24.24,0,0,1,.19.27A.24.24,0,0,1,199.71,191.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,167.31a.23.23,0,0,1-.12-.43l7.55-4.36a.23.23,0,1,1,.24.4l-7.56,4.36A.2.2,0,0,1,150.68,167.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,171.67a.23.23,0,0,1-.2-.11l-7.55-13.08a.23.23,0,0,1,.08-.32.23.23,0,0,1,.32.08l7.55,13.09a.22.22,0,0,1-.09.31A.2.2,0,0,1,158.23,171.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,176a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.26.26,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.11.2A.27.27,0,0,1,165.78,176Zm-7.32-4.72,7.09,4.09v-8.18l-7.09-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,171.67a.23.23,0,0,1-.12-.43l7.56-4.36a.22.22,0,0,1,.31.09.22.22,0,0,1-.08.31l-7.55,4.36A.27.27,0,0,1,158.23,171.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,176a.23.23,0,0,1-.2-.11L158,162.84a.23.23,0,0,1,.4-.24L166,175.69a.22.22,0,0,1-.08.31A.27.27,0,0,1,165.78,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,180.4a.15.15,0,0,1-.11,0L165.67,176a.21.21,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.24.24,0,0,1,.12.2v8.72a.22.22,0,0,1-.11.2A.19.19,0,0,1,173.33,180.4ZM166,175.67l7.09,4.09v-8.18l-7.09-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,176a.24.24,0,0,1-.2-.12.23.23,0,0,1,.09-.32l7.55-4.36a.23.23,0,0,1,.32.09.23.23,0,0,1-.09.31L165.9,176A.19.19,0,0,1,165.78,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,180.4a.24.24,0,0,1-.2-.12l-7.55-13.08a.23.23,0,0,1,.09-.32.22.22,0,0,1,.31.09l7.55,13.08a.22.22,0,0,1-.08.31A.19.19,0,0,1,173.33,180.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,184.76a.19.19,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0L181,175.6a.24.24,0,0,1,.12.2v8.72a.23.23,0,0,1-.12.2A.15.15,0,0,1,180.89,184.76ZM173.57,180l7.08,4.09v-8.18l-7.08-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,180.4a.25.25,0,0,1-.2-.12.24.24,0,0,1,.09-.32l7.55-4.36a.24.24,0,0,1,.32.09.23.23,0,0,1-.09.31l-7.55,4.36A.19.19,0,0,1,173.33,180.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,184.76a.27.27,0,0,1-.21-.12l-7.55-13.08a.24.24,0,0,1,.09-.32.23.23,0,0,1,.32.09l7.55,13.08a.23.23,0,0,1-.09.31A.17.17,0,0,1,180.89,184.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,189.12l-.12,0-7.55-4.36a.26.26,0,0,1-.12-.21V175.8a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.73a.22.22,0,0,1-.12.2A.2.2,0,0,1,188.44,189.12Zm-7.32-4.73,7.08,4.09V180.3l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,184.76a.25.25,0,0,1-.21-.12.24.24,0,0,1,.09-.32l7.55-4.36a.24.24,0,0,1,.32.09.24.24,0,0,1-.08.32L181,184.73A.2.2,0,0,1,180.89,184.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,189.12a.22.22,0,0,1-.2-.12l-7.56-13.08a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,188.44,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,193.48a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.11-.2v-8.73a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.73a.23.23,0,0,1-.11.2A.27.27,0,0,1,196,193.48Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,189.12a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l7.55-4.36a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-7.55,4.36A.27.27,0,0,1,188.44,189.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,193.48a.22.22,0,0,1-.2-.12l-7.55-13.08a.23.23,0,0,1,.08-.32.24.24,0,0,1,.32.09l7.55,13.08a.23.23,0,0,1-.08.32A.27.27,0,0,1,196,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,169.5a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.72a.22.22,0,0,1-.12.2A.2.2,0,0,1,162,169.5Zm-7.32-4.73,7.08,4.1v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,165.14a.25.25,0,0,1-.21-.12.23.23,0,0,1,.09-.31l7.55-4.36a.23.23,0,0,1,.32.08.24.24,0,0,1-.08.32l-7.56,4.36A.2.2,0,0,1,154.47,165.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,169.5a.23.23,0,0,1-.2-.11l-7.56-13.09a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,162,169.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,173.86l-.12,0-7.55-4.36a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2Zm-7.32-4.72,7.09,4.09V165L162.25,161Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,169.5a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.32l7.55-4.36a.23.23,0,1,1,.24.4l-7.55,4.36A.27.27,0,0,1,162,169.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,173.86a.23.23,0,0,1-.2-.11l-7.55-13.09a.22.22,0,0,1,.08-.31.23.23,0,0,1,.32.08l7.55,13.08a.23.23,0,0,1-.08.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,178.22a.2.2,0,0,1-.11,0l-7.56-4.36a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.24.24,0,0,1,.12.2V178a.23.23,0,0,1-.11.2A.27.27,0,0,1,177.12,178.22Zm-7.32-4.72,7.09,4.09V169.4l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,173.86a.23.23,0,0,1-.2-.11.24.24,0,0,1,.08-.32l7.56-4.36a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-7.55,4.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,178.22a.23.23,0,0,1-.2-.11L169.37,165a.24.24,0,0,1,.08-.32.23.23,0,0,1,.32.08l7.55,13.08a.23.23,0,0,1-.08.32A.27.27,0,0,1,177.12,178.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,182.58a.2.2,0,0,1-.11,0L177,178.19a.22.22,0,0,1-.12-.2v-8.72a.22.22,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2A.27.27,0,0,1,184.67,182.58Zm-7.31-4.72,7.08,4.09v-8.19l-7.08-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,178.22a.23.23,0,0,1-.11-.43l7.55-4.36a.23.23,0,0,1,.32.08.24.24,0,0,1-.09.32l-7.55,4.36A.27.27,0,0,1,177.12,178.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,182.58a.24.24,0,0,1-.2-.11l-7.55-13.08a.24.24,0,0,1,.09-.32.22.22,0,0,1,.31.08l7.56,13.09a.23.23,0,0,1-.09.31A.27.27,0,0,1,184.67,182.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,186.94a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.22.22,0,0,1,.12.2v8.72a.23.23,0,0,1-.12.2A.2.2,0,0,1,192.23,186.94Zm-7.32-4.72,7.08,4.09v-8.18l-7.09-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,182.58a.26.26,0,0,1-.21-.11.24.24,0,0,1,.09-.32l7.55-4.36a.23.23,0,0,1,.32.09.22.22,0,0,1-.09.31l-7.55,4.36A.2.2,0,0,1,184.68,182.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,186.94a.26.26,0,0,1-.21-.11l-7.55-13.08a.24.24,0,0,1,.09-.32.23.23,0,0,1,.32.08l7.55,13.09a.23.23,0,0,1-.09.31A.2.2,0,0,1,192.23,186.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.78,191.31a.19.19,0,0,1-.12,0l-7.55-4.36a.22.22,0,0,1-.11-.2V178a.23.23,0,0,1,.11-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.72a.21.21,0,0,1-.12.2A.15.15,0,0,1,199.78,191.31Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,187a.24.24,0,0,1-.2-.12.23.23,0,0,1,.08-.32l7.55-4.36a.23.23,0,0,1,.32.09.22.22,0,0,1-.08.31l-7.56,4.36A.15.15,0,0,1,192.23,187Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,193.48a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l3.59-2L192,178.11a.23.23,0,0,1,.08-.32.23.23,0,0,1,.32.09L200,191a.2.2,0,0,1,0,.17.19.19,0,0,1-.11.14l-3.79,2.18A.2.2,0,0,1,196,193.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.68 241.21 150.68 232.49 154.47 230.31 154.45 239.03 150.68 241.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.68 241.21 150.68 232.49 154.47 230.31 154.45 239.03 150.68 241.21"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,245.8l-.12,0-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.26.26,0,0,1,.12-.21.24.24,0,0,1,.23,0l7.56,4.36a.25.25,0,0,1,.11.21v8.72a.22.22,0,0,1-.12.2A.2.2,0,0,1,158.23,245.8Zm-7.32-4.73,7.09,4.09V237l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,243.63H162l-11.34-2.19a.22.22,0,0,1-.18-.27.23.23,0,0,1,.27-.18l11.34,2.19a.23.23,0,0,1,.19.27A.24.24,0,0,1,162,243.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,248h-.05l-11.34-2.18a.24.24,0,0,1-.18-.28.23.23,0,0,1,.27-.18l11.34,2.19a.23.23,0,0,1,.19.27A.24.24,0,0,1,169.56,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,252.35h0l-11.34-2.19a.22.22,0,0,1-.18-.27.24.24,0,0,1,.27-.18l11.34,2.19a.22.22,0,0,1,.18.27A.23.23,0,0,1,177.1,252.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,256.71h0l-11.34-2.19a.23.23,0,0,1-.19-.27.24.24,0,0,1,.28-.18l11.34,2.19a.22.22,0,0,1,.18.27A.24.24,0,0,1,184.63,256.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.17,261.07h0l-11.34-2.18a.25.25,0,0,1-.19-.28.23.23,0,0,1,.27-.18l11.35,2.19a.23.23,0,0,1,.18.27A.24.24,0,0,1,192.17,261.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,265.43h0l-11.35-2.19a.23.23,0,0,1-.18-.27.23.23,0,0,1,.27-.18L199.75,265a.23.23,0,0,1,.19.27A.24.24,0,0,1,199.71,265.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,241.44a.23.23,0,0,1-.12-.43l7.55-4.37a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-7.56,4.36A.2.2,0,0,1,150.68,241.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,245.8a.22.22,0,0,1-.2-.12l-7.55-13.08a.23.23,0,0,1,.08-.32.24.24,0,0,1,.32.09l7.55,13.08a.23.23,0,0,1-.09.32A.2.2,0,0,1,158.23,245.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,250.16a.27.27,0,0,1-.12,0l-7.55-4.36a.23.23,0,0,1-.11-.2v-8.72a.25.25,0,0,1,.11-.21.26.26,0,0,1,.24,0L165.9,241a.22.22,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2A.27.27,0,0,1,165.78,250.16Zm-7.32-4.73,7.09,4.1v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.23,245.8a.23.23,0,0,1-.12-.43l7.56-4.36a.22.22,0,0,1,.31.08.23.23,0,0,1-.08.32l-7.55,4.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,250.16a.22.22,0,0,1-.2-.12L158,237a.23.23,0,0,1,.08-.32.24.24,0,0,1,.32.09L166,249.81a.23.23,0,0,1-.08.32A.27.27,0,0,1,165.78,250.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,254.52a.2.2,0,0,1-.11,0l-7.55-4.36a.22.22,0,0,1-.12-.2v-8.72a.21.21,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.23.23,0,0,1,.12.2v8.72a.23.23,0,0,1-.11.2ZM166,249.79l7.09,4.1V245.7L166,241.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,250.16a.23.23,0,0,1-.11-.43l7.55-4.36a.23.23,0,0,1,.32.08.24.24,0,0,1-.09.32l-7.55,4.36A.27.27,0,0,1,165.78,250.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,254.52a.22.22,0,0,1-.2-.12l-7.55-13.08a.22.22,0,0,1,.09-.31.22.22,0,0,1,.31.08l7.55,13.08a.23.23,0,0,1-.08.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,258.88l-.12,0-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.23.23,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.55,4.36a.24.24,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2A.2.2,0,0,1,180.89,258.88Zm-7.32-4.72,7.08,4.09v-8.19L173.57,246Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.33,254.52a.24.24,0,0,1-.2-.11.24.24,0,0,1,.09-.32l7.55-4.36a.23.23,0,0,1,.32.08.24.24,0,0,1-.09.32l-7.55,4.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,258.88a.26.26,0,0,1-.21-.11l-7.55-13.09a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.23.23,0,0,1,180.89,258.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,263.24a.27.27,0,0,1-.12,0l-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2V263a.22.22,0,0,1-.12.2A.2.2,0,0,1,188.44,263.24Zm-7.32-4.72,7.08,4.09v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,258.88a.26.26,0,0,1-.21-.11.24.24,0,0,1,.09-.32l7.55-4.36a.23.23,0,0,1,.32.08.24.24,0,0,1-.08.32L181,258.85A.2.2,0,0,1,180.89,258.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,263.24a.23.23,0,0,1-.2-.11l-7.56-13.08a.24.24,0,0,1,.09-.32.23.23,0,0,1,.32.08l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,188.44,263.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,267.6l-.12,0-7.55-4.36a.23.23,0,0,1-.11-.2v-8.72a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.72a.23.23,0,0,1-.11.2Zm-7.32-4.72,7.09,4.09v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.44,263.24a.23.23,0,0,1-.12-.43l7.55-4.36a.23.23,0,1,1,.24.4l-7.55,4.36A.27.27,0,0,1,188.44,263.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,267.6a.23.23,0,0,1-.2-.11l-7.55-13.08a.23.23,0,0,1,.08-.32.23.23,0,0,1,.32.08l7.55,13.09a.22.22,0,0,1-.08.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,243.63a.27.27,0,0,1-.12,0l-7.55-4.36a.26.26,0,0,1-.12-.21v-8.72a.24.24,0,0,1,.12-.2.24.24,0,0,1,.23,0l7.56,4.36a.23.23,0,0,1,.11.2v8.72a.24.24,0,0,1-.12.21A.2.2,0,0,1,162,243.63Zm-7.32-4.73,7.08,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,239.27a.27.27,0,0,1-.21-.12.24.24,0,0,1,.09-.32l7.55-4.36a.24.24,0,0,1,.32.09.24.24,0,0,1-.08.32l-7.56,4.36A.2.2,0,0,1,154.47,239.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,243.63a.22.22,0,0,1-.2-.12l-7.56-13.08a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,162,243.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,248l-.12,0-7.55-4.36a.25.25,0,0,1-.11-.21v-8.72a.23.23,0,0,1,.11-.2.25.25,0,0,1,.24,0l7.55,4.36a.23.23,0,0,1,.11.2v8.73a.23.23,0,0,1-.11.2Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,243.63a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l7.55-4.36a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-7.55,4.36A.27.27,0,0,1,162,243.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,248a.22.22,0,0,1-.2-.12l-7.55-13.08a.23.23,0,0,1,.08-.32.24.24,0,0,1,.32.09l7.55,13.08a.23.23,0,0,1-.08.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,252.35a.2.2,0,0,1-.11,0L169.45,248a.23.23,0,0,1-.11-.2V239a.23.23,0,0,1,.11-.2.26.26,0,0,1,.24,0l7.55,4.36a.26.26,0,0,1,.12.21v8.72a.23.23,0,0,1-.11.2A.27.27,0,0,1,177.12,252.35Zm-7.32-4.73,7.09,4.09v-8.18l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,248a.22.22,0,0,1-.2-.12.24.24,0,0,1,.08-.32l7.56-4.36a.24.24,0,0,1,.23.41L169.69,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,252.35a.22.22,0,0,1-.2-.12l-7.55-13.08a.23.23,0,1,1,.4-.23L177.32,252a.23.23,0,0,1-.08.32A.27.27,0,0,1,177.12,252.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,256.71a.2.2,0,0,1-.11,0L177,252.32a.22.22,0,0,1-.12-.2V243.4a.24.24,0,0,1,.35-.21l7.55,4.36a.26.26,0,0,1,.12.21v8.72a.24.24,0,0,1-.12.2ZM177.36,252l7.08,4.09v-8.18l-7.08-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,252.35a.23.23,0,0,1-.11-.43l7.55-4.37a.24.24,0,0,1,.23.41l-7.55,4.36A.27.27,0,0,1,177.12,252.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,256.71a.23.23,0,0,1-.2-.12l-7.55-13.08a.24.24,0,0,1,.09-.32.23.23,0,0,1,.31.09l7.56,13.08a.24.24,0,0,1-.09.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,261.07l-.12,0-7.55-4.36a.24.24,0,0,1-.12-.2v-8.72a.26.26,0,0,1,.12-.21.24.24,0,0,1,.23,0l7.55,4.37a.21.21,0,0,1,.12.2v8.72a.24.24,0,0,1-.12.2A.2.2,0,0,1,192.23,261.07Zm-7.32-4.73,7.08,4.1v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,256.71a.25.25,0,0,1-.21-.12.23.23,0,0,1,.09-.31l7.55-4.36a.23.23,0,0,1,.32.08.23.23,0,0,1-.09.32l-7.55,4.36A.2.2,0,0,1,184.68,256.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,261.07A.25.25,0,0,1,192,261l-7.55-13.08a.24.24,0,0,1,.41-.23l7.55,13.08a.24.24,0,0,1-.09.32A.2.2,0,0,1,192.23,261.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.78,265.43a.27.27,0,0,1-.12,0L192.11,261a.23.23,0,0,1-.11-.2v-8.72a.22.22,0,0,1,.11-.2.24.24,0,0,1,.23,0l7.56,4.36a.22.22,0,0,1,.11.2v8.72a.22.22,0,0,1-.12.2A.2.2,0,0,1,199.78,265.43Zm-7.32-4.73,7.09,4.1v-8.19l-7.09-4.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,261.07a.23.23,0,0,1-.12-.43l7.55-4.36a.23.23,0,0,1,.24.4L192.34,261A.2.2,0,0,1,192.23,261.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,267.6a.23.23,0,0,1-.12-.43l3.59-2.06L192,252.23a.22.22,0,0,1,.08-.31.23.23,0,0,1,.32.08L200,265.08a.23.23,0,0,1,0,.18.19.19,0,0,1-.11.14l-3.79,2.17A.2.2,0,0,1,196,267.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.65,
    cy: 383.37,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.65,
    cy: 383.37,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.65,
    cy: 383.37,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,371.05a25.85,25.85,0,0,1,51.69,0c0,.25,0,.47,0,.72s0,.47,0,.72c-.3,3.58-2.82,7.09-7.57,9.84-10.08,5.83-26.47,5.83-36.58,0-4.72-2.75-7.25-6.26-7.54-9.84,0-.25,0-.47,0-.72S223.37,371.3,223.39,371.05Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,371.05a25.85,25.85,0,0,1,51.69,0c0,.25,0,.47,0,.72s0,.47,0,.72c-.3,3.58-2.82,7.09-7.57,9.84-10.08,5.83-26.47,5.83-36.58,0-4.72-2.75-7.25-6.26-7.54-9.84,0-.25,0-.47,0-.72S223.37,371.3,223.39,371.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,348.49h0a25.8,25.8,0,0,1,37.06,22.56c0,.25,0,.47,0,.72s0,.47,0,.72c-.3,3.58-2.82,7.09-7.57,9.84a34.28,34.28,0,0,1-13,4c6.71-1.15,11-8.64,9-16.91C261.13,359.87,251.44,346,238,348.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,372.49c0-.25,0-.47,0-.72s0-.47,0-.72a25.69,25.69,0,0,1,8.78-18.68c-2.81,2.88-9.06,13.77-2.27,22.06,4.47,5.46,25.66,13.25,43.1,3.24a18,18,0,0,1-5.49,4.66c-10.08,5.83-26.47,5.83-36.58,0C226.21,379.58,223.68,376.07,223.39,372.49Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5,351.73c-1.16,2.64,1.06,6.16,5,7.87s8,1,9.16-1.67-1.07-6.16-5-7.87S250.65,349.1,249.5,351.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,362.46c-.6,1.37.27,3.08,2,3.82s3.53.23,4.13-1.15-.27-3.08-1.95-3.82S265.07,361.09,264.47,362.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.79,376.64a22,22,0,0,0-43.89,0c0,.21,0,.4,0,.61s0,.4,0,.61c.24,3,2.39,6,6.42,8.35,8.56,5,22.48,5,31.07,0,4-2.33,6.15-5.31,6.4-8.35,0-.21,0-.4,0-.61S329.81,376.85,329.79,376.64Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.79,376.64a22,22,0,0,0-43.89,0c0,.21,0,.4,0,.61s0,.4,0,.61c.24,3,2.39,6,6.42,8.35,8.56,5,22.48,5,31.07,0,4-2.33,6.15-5.31,6.4-8.35,0-.21,0-.4,0-.61S329.81,376.85,329.79,376.64Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,357.47h0a21.93,21.93,0,0,0-31.47,19.17c0,.21,0,.4,0,.61s0,.4,0,.61c.24,3,2.39,6,6.42,8.35a29.27,29.27,0,0,0,11,3.44c-5.7-1-9.39-7.34-7.63-14.36C297.74,367.14,306,355.37,317.37,357.47Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.79,377.86c0-.21,0-.4,0-.61s0-.4,0-.61a21.83,21.83,0,0,0-7.45-15.87c2.38,2.45,7.69,11.7,1.92,18.74-3.79,4.64-21.79,11.25-36.6,2.75a15.15,15.15,0,0,0,4.66,3.95c8.56,5,22.48,5,31.07,0C327.4,383.88,329.54,380.9,329.79,377.86Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.62,360.23c1,2.24-.91,5.23-4.22,6.69s-6.79.82-7.77-1.42.9-5.23,4.21-6.69S306.64,358,307.62,360.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9,369.34a2.88,2.88,0,1,1-3.51-1A2.61,2.61,0,0,1,294.9,369.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,380.4a14.52,14.52,0,0,0-29,0c0,.14,0,.27,0,.41s0,.26,0,.4c.17,2,1.58,4,4.25,5.52,5.66,3.28,14.87,3.28,20.54,0,2.66-1.54,4.07-3.51,4.24-5.52,0-.14,0-.27,0-.4S352.11,380.54,352.1,380.4Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,380.4a14.52,14.52,0,0,0-29,0c0,.14,0,.27,0,.41s0,.26,0,.4c.17,2,1.58,4,4.25,5.52,5.66,3.28,14.87,3.28,20.54,0,2.66-1.54,4.07-3.51,4.24-5.52,0-.14,0-.27,0-.4S352.11,380.54,352.1,380.4Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,367.73h0a14.5,14.5,0,0,0-20.82,12.67c0,.14,0,.27,0,.41s0,.26,0,.4c.17,2,1.58,4,4.25,5.52a19.44,19.44,0,0,0,7.29,2.28c-3.77-.65-6.21-4.86-5.05-9.5C330.9,374.12,336.35,366.34,343.89,367.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,381.21c0-.14,0-.27,0-.4s0-.27,0-.41a14.46,14.46,0,0,0-4.93-10.49c1.58,1.62,5.09,7.73,1.27,12.39-2.5,3.07-14.4,7.44-24.2,1.82a9.92,9.92,0,0,0,3.08,2.61c5.66,3.28,14.87,3.28,20.54,0C350.52,385.19,351.93,383.22,352.1,381.21Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.44,369.55c.65,1.48-.6,3.46-2.79,4.42s-4.49.55-5.14-.93.6-3.46,2.79-4.42S336.79,368.07,337.44,369.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,375.58a1.91,1.91,0,1,1-2.32-.65A1.73,1.73,0,0,1,329,375.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,382.89a19.73,19.73,0,0,0-39.45,0c0,.19,0,.36,0,.55s0,.36,0,.55c.23,2.73,2.15,5.41,5.78,7.5,7.69,4.45,20.2,4.45,27.91,0,3.61-2.09,5.53-4.77,5.76-7.5a7.57,7.57,0,0,0,0-1.1Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,382.89a19.73,19.73,0,0,0-39.45,0c0,.19,0,.36,0,.55s0,.36,0,.55c.23,2.73,2.15,5.41,5.78,7.5,7.69,4.45,20.2,4.45,27.91,0,3.61-2.09,5.53-4.77,5.76-7.5a7.57,7.57,0,0,0,0-1.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26,365.67h0A19.71,19.71,0,0,0,346,382.89c0,.19,0,.36,0,.55s0,.36,0,.55c.23,2.73,2.15,5.41,5.78,7.5a26,26,0,0,0,9.9,3.09c-5.12-.88-8.44-6.59-6.86-12.9C356.61,374.36,364,363.78,374.26,365.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,384a7.57,7.57,0,0,0,0-1.1,19.65,19.65,0,0,0-6.7-14.26c2.14,2.21,6.91,10.51,1.73,16.84-3.41,4.17-19.58,10.11-32.89,2.47a13.56,13.56,0,0,0,4.19,3.55c7.69,4.45,20.2,4.45,27.91,0C383.27,389.4,385.19,386.72,385.42,384Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5,368.15c.88,2-.82,4.7-3.79,6s-6.11.74-7-1.27.81-4.7,3.79-6S364.61,366.14,365.5,368.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.07,376.33a2.59,2.59,0,1,1-3.16-.87A2.34,2.34,0,0,1,354.07,376.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.24,325.86A22.39,22.39,0,0,1,296.31,343,14.63,14.63,0,0,0,291,354.13V405.9c0,1.37-.9,2.73-2.71,3.78a11.69,11.69,0,0,1-3.39,1.24,15.86,15.86,0,0,1-6.29,0,11.81,11.81,0,0,1-3.38-1.24c-1.8-1.05-2.71-2.41-2.71-3.78V354a14.49,14.49,0,0,0-5.29-11,22.34,22.34,0,0,1-8-17.33,22.49,22.49,0,0,1,45,.18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.24,325.86A22.39,22.39,0,0,1,296.31,343,14.63,14.63,0,0,0,291,354.13V405.9c0,1.37-.9,2.73-2.71,3.78a11.69,11.69,0,0,1-3.39,1.24,15.86,15.86,0,0,1-6.29,0,11.81,11.81,0,0,1-3.38-1.24c-1.8-1.05-2.71-2.41-2.71-3.78V354a14.49,14.49,0,0,0-5.29-11,22.34,22.34,0,0,1-8-17.33,22.49,22.49,0,0,1,45,.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3,325.86A12.53,12.53,0,0,1,289,336.08a10.19,10.19,0,0,0-4.12,8.35V405.9a3.18,3.18,0,0,1-3.11,3.21h-.07a3.18,3.18,0,0,1-3.11-3.21V344.27a10,10,0,0,0-4.12-8.19,12.53,12.53,0,0,1-5.28-10.57,12.68,12.68,0,0,1,12.05-12.19A12.55,12.55,0,0,1,294.3,325.86Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3,325.86A12.53,12.53,0,0,1,289,336.08a10.19,10.19,0,0,0-4.12,8.35V405.9a3.18,3.18,0,0,1-3.11,3.21h-.07a3.18,3.18,0,0,1-3.11-3.21V344.27a10,10,0,0,0-4.12-8.19,12.53,12.53,0,0,1-5.28-10.57,12.68,12.68,0,0,1,12.05-12.19A12.55,12.55,0,0,1,294.3,325.86Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,334.17a5.87,5.87,0,1,1,5.86,5.87A5.86,5.86,0,0,1,285.27,334.17Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.55,322.5a3.59,3.59,0,1,1,3.58,3.58A3.58,3.58,0,0,1,287.55,322.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,316.78a1.78,1.78,0,1,1,1.78,1.78A1.78,1.78,0,0,1,280.7,316.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.52,318.92a4.82,4.82,0,1,1,4.82,4.81A4.82,4.82,0,0,1,266.52,318.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.72,327.62a2.26,2.26,0,1,0,2.26-2.26A2.26,2.26,0,0,0,265.72,327.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,335.53a3.67,3.67,0,1,1,3.66,3.67A3.66,3.66,0,0,1,267.41,335.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,341.07a3,3,0,1,1,3,3A3,3,0,0,1,276.16,341.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,322.5A1.54,1.54,0,1,1,263,324,1.54,1.54,0,0,1,261.43,322.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.94,316.13a2,2,0,1,1,2,2A2,2,0,0,1,294.94,316.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 326.08,
    r: 2.04,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8,327.73a2,2,0,1,1,2.05,2A2.05,2.05,0,0,1,275.8,327.73Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.45,388.55a12,12,0,0,0-24,0c0,.12,0,.22,0,.34s0,.22,0,.33c.13,1.67,1.31,3.3,3.52,4.58,4.69,2.71,12.31,2.71,17,0,2.2-1.28,3.37-2.91,3.51-4.58,0-.11,0-.21,0-.33S408.46,388.67,408.45,388.55Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.45,388.55a12,12,0,0,0-24,0c0,.12,0,.22,0,.34s0,.22,0,.33c.13,1.67,1.31,3.3,3.52,4.58,4.69,2.71,12.31,2.71,17,0,2.2-1.28,3.37-2.91,3.51-4.58,0-.11,0-.21,0-.33S408.46,388.67,408.45,388.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.65,378.06h0a12,12,0,0,0-17.24,10.49c0,.12,0,.22,0,.34s0,.22,0,.33c.13,1.67,1.31,3.3,3.52,4.58a15.87,15.87,0,0,0,6,1.88c-3.12-.54-5.14-4-4.18-7.86C390.89,383.36,395.4,376.91,401.65,378.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.45,389.22c0-.11,0-.21,0-.33s0-.22,0-.34a12,12,0,0,0-4.08-8.68c1.3,1.34,4.21,6.4,1.05,10.26-2.08,2.54-11.93,6.16-20,1.51a8.21,8.21,0,0,0,2.55,2.16c4.69,2.71,12.31,2.71,17,0C407.14,392.52,408.31,390.89,408.45,389.22Z",
    style: {
      fill: "#092166",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.31,379.57c.53,1.23-.5,2.87-2.31,3.66s-3.72.45-4.26-.78.49-2.86,2.31-3.66S395.77,378.34,396.31,379.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34,384.56a1.58,1.58,0,0,1-2.83,1.24,1.58,1.58,0,0,1,2.83-1.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,397.59a16.56,16.56,0,0,0-33.11,0c0,.16,0,.3,0,.46s0,.3,0,.46c.19,2.29,1.8,4.54,4.85,6.3,6.46,3.74,16.95,3.74,23.43,0,3-1.76,4.64-4,4.83-6.3,0-.16,0-.3,0-.46S390.07,397.75,390.06,397.59Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,397.59a16.56,16.56,0,0,0-33.11,0c0,.16,0,.3,0,.46s0,.3,0,.46c.19,2.29,1.8,4.54,4.85,6.3,6.46,3.74,16.95,3.74,23.43,0,3-1.76,4.64-4,4.83-6.3,0-.16,0-.3,0-.46S390.07,397.75,390.06,397.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,383.14h0A16.53,16.53,0,0,0,357,397.59c0,.16,0,.3,0,.46s0,.3,0,.46c.19,2.29,1.8,4.54,4.85,6.3a22,22,0,0,0,8.3,2.6c-4.29-.75-7.07-5.54-5.75-10.84C365.88,390.43,372.09,381.55,380.69,383.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,398.51c0-.16,0-.3,0-.46s0-.3,0-.46a16.53,16.53,0,0,0-5.62-12c1.79,1.85,5.8,8.82,1.45,14.14-2.86,3.49-16.44,8.48-27.61,2.07a11.42,11.42,0,0,0,3.52,3c6.46,3.74,16.95,3.74,23.43,0C388.25,403.05,389.87,400.8,390.06,398.51Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.34,385.22c.74,1.69-.69,3.94-3.19,5s-5.12.62-5.86-1.07.68-3.95,3.18-5S372.59,383.53,373.34,385.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.74,392.09a2.17,2.17,0,1,1-2.65-.74A2,2,0,0,1,363.74,392.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.54,403.47a20.55,20.55,0,0,0-41.09,0c0,.2,0,.38,0,.58s0,.37,0,.57c.24,2.85,2.24,5.64,6,7.82,8,4.63,21,4.63,29.07,0,3.76-2.18,5.77-5,6-7.82a5.52,5.52,0,0,0,0-.57A5.62,5.62,0,0,0,360.54,403.47Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.54,403.47a20.55,20.55,0,0,0-41.09,0c0,.2,0,.38,0,.58s0,.37,0,.57c.24,2.85,2.24,5.64,6,7.82,8,4.63,21,4.63,29.07,0,3.76-2.18,5.77-5,6-7.82a5.52,5.52,0,0,0,0-.57A5.62,5.62,0,0,0,360.54,403.47Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,385.54h0a20.53,20.53,0,0,0-29.46,17.93c0,.2,0,.38,0,.58s0,.37,0,.57c.24,2.85,2.24,5.64,6,7.82a27.48,27.48,0,0,0,10.31,3.22c-5.33-.92-8.78-6.88-7.14-13.45C330.54,394.59,338.24,383.57,348.91,385.54Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.54,404.62a5.52,5.52,0,0,0,0-.57,5.62,5.62,0,0,0,0-.58,20.4,20.4,0,0,0-7-14.84c2.23,2.29,7.2,10.94,1.8,17.54-3.54,4.33-20.39,10.52-34.25,2.57a14.2,14.2,0,0,0,4.36,3.7c8,4.63,21,4.63,29.07,0C358.3,410.26,360.31,407.47,360.54,404.62Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.79,388.12c.92,2.1-.85,4.9-4,6.26s-6.36.76-7.28-1.33.85-4.9,3.95-6.26S338.87,386,339.79,388.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.88,396.65a2.7,2.7,0,1,1-3.29-.92A2.45,2.45,0,0,1,327.88,396.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,391.37a7.26,7.26,0,0,0-14.52,0,1.41,1.41,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.73,3.73,0,0,0,2.12,2.76,11.35,11.35,0,0,0,10.28,0,3.73,3.73,0,0,0,2.12-2.76,1.48,1.48,0,0,0,0-.21A1.41,1.41,0,0,0,418.62,391.37Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,391.37a7.26,7.26,0,0,0-14.52,0,1.41,1.41,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.73,3.73,0,0,0,2.12,2.76,11.35,11.35,0,0,0,10.28,0,3.73,3.73,0,0,0,2.12-2.76,1.48,1.48,0,0,0,0-.21A1.41,1.41,0,0,0,418.62,391.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.51,385h0a7.26,7.26,0,0,0-10.41,6.34,1.41,1.41,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.73,3.73,0,0,0,2.12,2.76,9.65,9.65,0,0,0,3.65,1.14c-1.89-.33-3.11-2.43-2.53-4.75C408,388.23,410.74,384.33,414.51,385Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,391.78a1.48,1.48,0,0,0,0-.21,1.41,1.41,0,0,0,0-.2,7.23,7.23,0,0,0-2.46-5.25c.79.81,2.54,3.87.63,6.2-1.25,1.54-7.21,3.73-12.11.91a5.09,5.09,0,0,0,1.54,1.31,11.35,11.35,0,0,0,10.28,0A3.73,3.73,0,0,0,418.62,391.78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.29,385.94c.32.74-.3,1.73-1.4,2.22s-2.25.27-2.57-.47.3-1.73,1.39-2.22S411,385.2,411.29,385.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.08,389a1,1,0,1,1-1.17-.32A.86.86,0,0,1,407.08,389Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,382.63a12,12,0,0,1,24,0c0,.12,0,.22,0,.34s0,.22,0,.33c-.14,1.67-1.31,3.3-3.52,4.58-4.69,2.71-12.31,2.71-17,0-2.2-1.28-3.37-2.91-3.51-4.58,0-.11,0-.22,0-.33S156.78,382.75,156.79,382.63Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,382.63a12,12,0,0,1,24,0c0,.12,0,.22,0,.34s0,.22,0,.33c-.14,1.67-1.31,3.3-3.52,4.58-4.69,2.71-12.31,2.71-17,0-2.2-1.28-3.37-2.91-3.51-4.58,0-.11,0-.22,0-.33S156.78,382.75,156.79,382.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.59,372.14h0a11.89,11.89,0,0,1,5.22-1.21,12,12,0,0,1,12,11.7c0,.12,0,.22,0,.34s0,.22,0,.33c-.14,1.67-1.31,3.3-3.52,4.58a16,16,0,0,1-6,1.88c3.12-.54,5.14-4,4.18-7.87C174.34,377.43,169.83,371,163.59,372.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,383.3c0-.11,0-.22,0-.33s0-.22,0-.34a12,12,0,0,1,4.08-8.69c-1.31,1.34-4.21,6.41-1.05,10.27,2.07,2.53,11.93,6.16,20,1.5a8.23,8.23,0,0,1-2.55,2.17c-4.69,2.71-12.31,2.71-17,0C158.1,386.6,156.93,385,156.79,383.3Z",
    style: {
      fill: "#092166",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,373.65c-.54,1.22.5,2.86,2.31,3.66s3.72.45,4.26-.78-.5-2.86-2.31-3.66S169.47,372.42,168.93,373.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,378.63a1.58,1.58,0,1,0,1.92-.53A1.42,1.42,0,0,0,175.9,378.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.74,381.37a17.44,17.44,0,0,1,34.87,0,4,4,0,0,1,0,.49,3.85,3.85,0,0,1,0,.48c-.2,2.42-1.9,4.79-5.1,6.64-6.81,3.93-17.86,3.93-24.68,0-3.19-1.85-4.89-4.22-5.09-6.64,0-.16,0-.32,0-.48S192.73,381.54,192.74,381.37Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.74,381.37a17.44,17.44,0,0,1,34.87,0,4,4,0,0,1,0,.49,3.85,3.85,0,0,1,0,.48c-.2,2.42-1.9,4.79-5.1,6.64-6.81,3.93-17.86,3.93-24.68,0-3.19-1.85-4.89-4.22-5.09-6.64,0-.16,0-.32,0-.48S192.73,381.54,192.74,381.37Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,366.15h0a17.42,17.42,0,0,1,25,15.22,4,4,0,0,1,0,.49,3.85,3.85,0,0,1,0,.48c-.2,2.42-1.9,4.79-5.1,6.64a23.22,23.22,0,0,1-8.75,2.73c4.52-.78,7.45-5.83,6.06-11.41C218.21,373.83,211.66,364.48,202.61,366.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.74,382.34c0-.16,0-.32,0-.48s0-.32,0-.49a17.35,17.35,0,0,1,5.92-12.6c-1.89,2-6.11,9.29-1.53,14.89,3,3.68,17.31,8.93,29.08,2.18a12,12,0,0,1-3.7,3.14c-6.81,3.93-17.86,3.93-24.68,0C194.64,387.13,192.94,384.76,192.74,382.34Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,368.34c-.78,1.78.72,4.16,3.35,5.31s5.4.65,6.18-1.13-.72-4.15-3.35-5.31S211.13,366.56,210.35,368.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.46,375.58a2.29,2.29,0,1,0,2.79-.78A2.07,2.07,0,0,0,220.46,375.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.39,391.61a16.56,16.56,0,0,1,33.1,0c0,.16,0,.3,0,.46s0,.3,0,.46c-.19,2.29-1.8,4.54-4.84,6.3-6.46,3.74-17,3.74-23.43,0-3-1.76-4.65-4-4.83-6.3a5.3,5.3,0,0,1,0-.92Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.39,391.61a16.56,16.56,0,0,1,33.1,0c0,.16,0,.3,0,.46s0,.3,0,.46c-.19,2.29-1.8,4.54-4.84,6.3-6.46,3.74-17,3.74-23.43,0-3-1.76-4.65-4-4.83-6.3a5.3,5.3,0,0,1,0-.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75,377.16h0a16.53,16.53,0,0,1,23.74,14.45c0,.16,0,.3,0,.46s0,.3,0,.46c-.19,2.29-1.8,4.54-4.84,6.3a21.9,21.9,0,0,1-8.31,2.59c4.29-.74,7.07-5.53,5.75-10.83C201.56,384.45,195.35,375.57,186.75,377.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.39,392.53a5.3,5.3,0,0,1,0-.92,16.47,16.47,0,0,1,5.62-12c-1.8,1.85-5.8,8.82-1.46,14.14,2.86,3.49,16.44,8.48,27.61,2.07a11.63,11.63,0,0,1-3.51,3c-6.46,3.74-17,3.74-23.43,0C179.19,397.07,177.57,394.82,177.39,392.53Z",
    style: {
      fill: "#092166",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.11,379.24c-.74,1.68.68,3.94,3.18,5s5.12.62,5.86-1.07-.68-3.95-3.18-5S194.85,377.55,194.11,379.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,386.11a2.17,2.17,0,1,0,2.65-.74A1.95,1.95,0,0,0,203.7,386.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,401a20.55,20.55,0,0,1,41.08,0,5.33,5.33,0,0,1,0,.57,5.43,5.43,0,0,1,0,.57c-.23,2.85-2.23,5.64-6,7.82-8,4.64-21,4.64-29.08,0-3.75-2.18-5.76-5-6-7.82a5.43,5.43,0,0,1,0-.57A5.33,5.33,0,0,1,208.07,401Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,401a20.55,20.55,0,0,1,41.08,0,5.33,5.33,0,0,1,0,.57,5.43,5.43,0,0,1,0,.57c-.23,2.85-2.23,5.64-6,7.82-8,4.64-21,4.64-29.08,0-3.75-2.18-5.76-5-6-7.82a5.43,5.43,0,0,1,0-.57A5.33,5.33,0,0,1,208.07,401Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,383.06h0A20.52,20.52,0,0,1,249.15,401a5.33,5.33,0,0,1,0,.57,5.43,5.43,0,0,1,0,.57c-.23,2.85-2.23,5.64-6,7.82a27.48,27.48,0,0,1-10.31,3.22c5.33-.92,8.78-6.87,7.14-13.45C238.07,392.11,230.36,381.09,219.7,383.06Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,402.14a5.43,5.43,0,0,1,0-.57,5.33,5.33,0,0,1,0-.57,20.44,20.44,0,0,1,7-14.85c-2.23,2.29-7.19,10.94-1.8,17.54,3.55,4.34,20.4,10.52,34.26,2.57a14.2,14.2,0,0,1-4.36,3.7c-8,4.64-21,4.64-29.08,0C210.31,407.78,208.3,405,208.07,402.14Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,385.64c-.92,2.1.85,4.9,4,6.26s6.36.77,7.28-1.33-.85-4.89-4-6.26S229.74,383.55,228.82,385.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.72,394.17a2.7,2.7,0,1,0,3.29-.91A2.45,2.45,0,0,0,240.72,394.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.18,404.68a18.76,18.76,0,0,0-37.51,0,4.7,4.7,0,0,0,0,.53,4.52,4.52,0,0,0,0,.52c.21,2.6,2,5.15,5.49,7.14,7.32,4.23,19.21,4.23,26.54,0,3.43-2,5.26-4.54,5.48-7.14,0-.18,0-.34,0-.52S323.19,404.86,323.18,404.68Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.18,404.68a18.76,18.76,0,0,0-37.51,0,4.7,4.7,0,0,0,0,.53,4.52,4.52,0,0,0,0,.52c.21,2.6,2,5.15,5.49,7.14,7.32,4.23,19.21,4.23,26.54,0,3.43-2,5.26-4.54,5.48-7.14,0-.18,0-.34,0-.52S323.19,404.86,323.18,404.68Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.56,388.31h0a18.74,18.74,0,0,0-26.89,16.37,4.7,4.7,0,0,0,0,.53,4.52,4.52,0,0,0,0,.52c.21,2.6,2,5.15,5.49,7.14a25.11,25.11,0,0,0,9.41,2.94c-4.87-.84-8-6.28-6.52-12.28C295.79,396.57,302.82,386.51,312.56,388.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.18,405.73c0-.18,0-.34,0-.52s0-.35,0-.53a18.68,18.68,0,0,0-6.37-13.55c2,2.09,6.57,10,1.64,16-3.24,4-18.62,9.61-31.27,2.35a13.1,13.1,0,0,0,4,3.38c7.32,4.23,19.21,4.23,26.54,0C321.13,410.88,323,408.33,323.18,405.73Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.23,390.67c.84,1.91-.77,4.47-3.6,5.71s-5.81.7-6.65-1.21.78-4.47,3.61-5.71S303.39,388.76,304.23,390.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.36,398.45a2.46,2.46,0,1,1-3-.83A2.21,2.21,0,0,1,293.36,398.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,406.72a17.84,17.84,0,0,1,35.67,0,6.26,6.26,0,0,1,0,1c-.2,2.47-1.94,4.89-5.22,6.79-7,4-18.27,4-25.24,0-3.26-1.9-5-4.32-5.21-6.79,0-.17,0-.33,0-.5S244.83,406.89,244.84,406.72Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,406.72a17.84,17.84,0,0,1,35.67,0,6.26,6.26,0,0,1,0,1c-.2,2.47-1.94,4.89-5.22,6.79-7,4-18.27,4-25.24,0-3.26-1.9-5-4.32-5.21-6.79,0-.17,0-.33,0-.5S244.83,406.89,244.84,406.72Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.94,391.15h0a17.81,17.81,0,0,1,25.57,15.57,6.26,6.26,0,0,1,0,1c-.2,2.47-1.94,4.89-5.22,6.79a23.63,23.63,0,0,1-9,2.79c4.63-.8,7.63-6,6.2-11.67C270.89,399,264.2,389.44,254.94,391.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,407.72c0-.17,0-.33,0-.5s0-.33,0-.5a17.78,17.78,0,0,1,6.06-12.89c-1.94,2-6.25,9.51-1.57,15.23,3.09,3.77,17.71,9.14,29.75,2.23a12.34,12.34,0,0,1-3.79,3.22c-7,4-18.27,4-25.24,0C246.79,412.61,245.05,410.19,244.84,407.72Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.86,393.39c-.8,1.82.74,4.25,3.43,5.44s5.52.66,6.32-1.16-.74-4.25-3.43-5.43S263.66,391.57,262.86,393.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.2,400.79a2.34,2.34,0,1,0,2.85-.79A2.11,2.11,0,0,0,273.2,400.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,413a7.27,7.27,0,0,0-14.53,0,1.34,1.34,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.72,3.72,0,0,0,2.13,2.76,11.35,11.35,0,0,0,10.28,0,3.78,3.78,0,0,0,2.12-2.76V413Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,413a7.27,7.27,0,0,0-14.53,0,1.34,1.34,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.72,3.72,0,0,0,2.13,2.76,11.35,11.35,0,0,0,10.28,0,3.78,3.78,0,0,0,2.12-2.76V413Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,406.62h0A7.25,7.25,0,0,0,276.6,413a1.34,1.34,0,0,0,0,.2,1.48,1.48,0,0,0,0,.21,3.72,3.72,0,0,0,2.13,2.76,9.55,9.55,0,0,0,3.64,1.14c-1.88-.33-3.1-2.43-2.52-4.76C280.52,409.82,283.24,405.92,287,406.62Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,413.37V413a7.24,7.24,0,0,0-2.47-5.25c.79.81,2.54,3.87.64,6.2-1.26,1.54-7.21,3.72-12.12.91a5,5,0,0,0,1.55,1.31,11.35,11.35,0,0,0,10.28,0A3.78,3.78,0,0,0,291.13,413.37Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79,407.53c.32.74-.3,1.73-1.4,2.21s-2.25.28-2.57-.47.3-1.73,1.4-2.21S283.46,406.79,283.79,407.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,410.55a1,1,0,1,1-1.16-.33A.86.86,0,0,1,279.58,410.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,385.45a7.27,7.27,0,0,1,14.53,0,2,2,0,0,1,0,.4,3.73,3.73,0,0,1-2.12,2.77,11.38,11.38,0,0,1-10.29,0,3.78,3.78,0,0,1-2.12-2.77v-.4Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,385.45a7.27,7.27,0,0,1,14.53,0,2,2,0,0,1,0,.4,3.73,3.73,0,0,1-2.12,2.77,11.38,11.38,0,0,1-10.29,0,3.78,3.78,0,0,1-2.12-2.77v-.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,379.11h0a7.24,7.24,0,0,1,10.41,6.34,2,2,0,0,1,0,.4,3.73,3.73,0,0,1-2.12,2.77,9.65,9.65,0,0,1-3.65,1.13c1.88-.32,3.1-2.42,2.52-4.75C157.22,382.31,154.5,378.41,150.73,379.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,385.85v-.4a7.23,7.23,0,0,1,2.47-5.25c-.79.81-2.54,3.87-.64,6.2,1.26,1.53,7.22,3.72,12.12.91a5.23,5.23,0,0,1-1.54,1.31,11.38,11.38,0,0,1-10.29,0A3.78,3.78,0,0,1,146.61,385.85Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,380c-.32.74.3,1.73,1.4,2.21s2.25.27,2.57-.47-.3-1.73-1.39-2.21S154.28,379.28,154,380Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.16,383a1,1,0,1,0,1.16-.32A.87.87,0,0,0,158.16,383Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--smoke--inject-26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.64,
    cy: 424.94,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.64,
    cy: 424.94,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.64,
    cy: 424.94,
    rx: 58.18,
    ry: 23.85,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.38,412.62a25.85,25.85,0,0,1,51.69,0c0,.25,0,.47,0,.72s0,.47,0,.72c-.29,3.58-2.82,7.09-7.57,9.84-10.08,5.83-26.47,5.83-36.58,0-4.72-2.75-7.24-6.26-7.54-9.84,0-.25,0-.47,0-.72S151.36,412.87,151.38,412.62Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.38,412.62a25.85,25.85,0,0,1,51.69,0c0,.25,0,.47,0,.72s0,.47,0,.72c-.29,3.58-2.82,7.09-7.57,9.84-10.08,5.83-26.47,5.83-36.58,0-4.72-2.75-7.24-6.26-7.54-9.84,0-.25,0-.47,0-.72S151.36,412.87,151.38,412.62Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,390.06h0a25.82,25.82,0,0,1,37.06,22.56c0,.25,0,.47,0,.72s0,.47,0,.72c-.29,3.58-2.82,7.09-7.57,9.84a34.47,34.47,0,0,1-13,4.05c6.71-1.16,11.05-8.65,9-16.92C189.13,401.44,179.43,387.58,166,390.06Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.38,414.06c0-.25,0-.47,0-.72s0-.47,0-.72a25.73,25.73,0,0,1,8.78-18.68c-2.81,2.89-9.06,13.77-2.27,22.07,4.47,5.45,25.66,13.24,43.1,3.23a18,18,0,0,1-5.49,4.66c-10.08,5.83-26.47,5.83-36.58,0C154.2,421.15,151.68,417.64,151.38,414.06Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.49,393.31c-1.16,2.63,1.07,6.16,5,7.87s8,1,9.16-1.67-1.07-6.16-5-7.87S178.65,390.67,177.49,393.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.46,404c-.6,1.37.28,3.09,2,3.82s3.53.23,4.14-1.14-.28-3.09-2-3.83S193.07,402.66,192.46,404Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.78,418.21a22,22,0,0,0-43.89,0c0,.21,0,.4,0,.61s0,.4,0,.61c.25,3,2.39,6,6.42,8.36,8.57,4.95,22.48,4.95,31.07,0,4-2.34,6.15-5.32,6.4-8.36,0-.21,0-.4,0-.61S257.8,418.42,257.78,418.21Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.78,418.21a22,22,0,0,0-43.89,0c0,.21,0,.4,0,.61s0,.4,0,.61c.25,3,2.39,6,6.42,8.36,8.57,4.95,22.48,4.95,31.07,0,4-2.34,6.15-5.32,6.4-8.36,0-.21,0-.4,0-.61S257.8,418.42,257.78,418.21Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.36,399.05h0a21.93,21.93,0,0,0-31.47,19.16c0,.21,0,.4,0,.61s0,.4,0,.61c.25,3,2.39,6,6.42,8.36a29.09,29.09,0,0,0,11,3.43c-5.7-1-9.38-7.34-7.63-14.36C225.73,408.72,234,396.94,245.36,399.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.78,419.43c0-.21,0-.4,0-.61s0-.4,0-.61a21.83,21.83,0,0,0-7.45-15.87c2.38,2.46,7.69,11.7,1.92,18.74-3.79,4.64-21.79,11.25-36.6,2.75a15.29,15.29,0,0,0,4.66,4c8.57,4.95,22.48,4.95,31.07,0C255.39,425.45,257.53,422.47,257.78,419.43Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.61,401.81c1,2.23-.9,5.23-4.22,6.68s-6.79.82-7.77-1.42.9-5.23,4.22-6.68S234.63,399.57,235.61,401.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,410.91a2.88,2.88,0,1,1-3.51-1A2.6,2.6,0,0,1,222.89,410.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.09,422a14.52,14.52,0,0,0-29,0,2.82,2.82,0,0,0,0,.41,2.68,2.68,0,0,0,0,.4c.16,2,1.58,4,4.24,5.53,5.67,3.27,14.87,3.27,20.55,0,2.65-1.54,4.07-3.52,4.23-5.53,0-.14,0-.26,0-.4S280.1,422.11,280.09,422Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.09,422a14.52,14.52,0,0,0-29,0,2.82,2.82,0,0,0,0,.41,2.68,2.68,0,0,0,0,.4c.16,2,1.58,4,4.24,5.53,5.67,3.27,14.87,3.27,20.55,0,2.65-1.54,4.07-3.52,4.23-5.53,0-.14,0-.26,0-.4S280.1,422.11,280.09,422Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,409.3h0A14.5,14.5,0,0,0,251.07,422a2.82,2.82,0,0,0,0,.41,2.68,2.68,0,0,0,0,.4c.16,2,1.58,4,4.24,5.53a19.43,19.43,0,0,0,7.29,2.27c-3.77-.65-6.21-4.85-5.05-9.5C258.9,415.7,264.34,407.91,271.88,409.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.09,422.78c0-.14,0-.26,0-.4s0-.27,0-.41a14.46,14.46,0,0,0-4.93-10.49c1.58,1.63,5.09,7.74,1.28,12.4-2.51,3.06-14.41,7.43-24.21,1.81a10.19,10.19,0,0,0,3.08,2.62c5.67,3.27,14.87,3.27,20.55,0C278.51,426.77,279.93,424.79,280.09,422.78Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.43,411.13c.65,1.48-.6,3.46-2.79,4.42s-4.49.54-5.14-.94.6-3.46,2.79-4.42S264.78,409.65,265.43,411.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,417.15a1.91,1.91,0,1,1-2.32-.64A1.72,1.72,0,0,1,257,417.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,424.46a19.73,19.73,0,0,0-39.44,0,7.57,7.57,0,0,0,0,1.1c.22,2.73,2.14,5.41,5.77,7.51,7.69,4.45,20.2,4.45,27.92,0,3.6-2.1,5.53-4.78,5.75-7.51a7.57,7.57,0,0,0,0-1.1Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,424.46a19.73,19.73,0,0,0-39.44,0,7.57,7.57,0,0,0,0,1.1c.22,2.73,2.14,5.41,5.77,7.51,7.69,4.45,20.2,4.45,27.92,0,3.6-2.1,5.53-4.78,5.75-7.51a7.57,7.57,0,0,0,0-1.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.25,407.24h0A19.7,19.7,0,0,0,274,424.46a7.57,7.57,0,0,0,0,1.1c.22,2.73,2.14,5.41,5.77,7.51a26.39,26.39,0,0,0,9.9,3.09c-5.12-.89-8.43-6.6-6.86-12.91C284.61,415.93,292,405.35,302.25,407.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,425.56a7.57,7.57,0,0,0,0-1.1,19.63,19.63,0,0,0-6.7-14.25c2.15,2.2,6.91,10.5,1.73,16.84-3.4,4.16-19.58,10.1-32.89,2.47a13.83,13.83,0,0,0,4.19,3.55c7.69,4.45,20.2,4.45,27.92,0C311.26,431,313.19,428.29,313.41,425.56Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.49,409.72c.88,2-.82,4.7-3.79,6s-6.11.73-7-1.28.81-4.7,3.79-6S292.6,407.71,293.49,409.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06,417.91a2.59,2.59,0,1,1-3.16-.88A2.34,2.34,0,0,1,282.06,417.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.24,367.43a22.43,22.43,0,0,1-7.93,17.13A14.61,14.61,0,0,0,219,395.7v51.77c0,1.37-.9,2.74-2.71,3.78a11.41,11.41,0,0,1-3.39,1.24,15.86,15.86,0,0,1-6.29,0,11.81,11.81,0,0,1-3.38-1.24c-1.8-1-2.7-2.41-2.7-3.78V395.6a14.5,14.5,0,0,0-5.3-11,22.34,22.34,0,0,1-8-17.33,22.5,22.5,0,0,1,45,.18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.24,367.43a22.43,22.43,0,0,1-7.93,17.13A14.61,14.61,0,0,0,219,395.7v51.77c0,1.37-.9,2.74-2.71,3.78a11.41,11.41,0,0,1-3.39,1.24,15.86,15.86,0,0,1-6.29,0,11.81,11.81,0,0,1-3.38-1.24c-1.8-1-2.7-2.41-2.7-3.78V395.6a14.5,14.5,0,0,0-5.3-11,22.34,22.34,0,0,1-8-17.33,22.5,22.5,0,0,1,45,.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,367.43A12.55,12.55,0,0,1,217,377.66a10.16,10.16,0,0,0-4.12,8.34v61.47a3.18,3.18,0,0,1-3.11,3.22h-.07a3.18,3.18,0,0,1-3.11-3.22V385.84a10,10,0,0,0-4.12-8.19,12.53,12.53,0,0,1-5.28-10.57,12.55,12.55,0,0,1,25.1.35Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,367.43A12.55,12.55,0,0,1,217,377.66a10.16,10.16,0,0,0-4.12,8.34v61.47a3.18,3.18,0,0,1-3.11,3.22h-.07a3.18,3.18,0,0,1-3.11-3.22V385.84a10,10,0,0,0-4.12-8.19,12.53,12.53,0,0,1-5.28-10.57,12.55,12.55,0,0,1,25.1.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.26,375.75a5.87,5.87,0,1,1,5.87,5.86A5.87,5.87,0,0,1,213.26,375.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.54,364.07a3.59,3.59,0,1,1,3.59,3.59A3.58,3.58,0,0,1,215.54,364.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7,358.36a1.78,1.78,0,1,1,1.77,1.77A1.78,1.78,0,0,1,208.7,358.36Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,360.49a4.82,4.82,0,1,1,4.81,4.82A4.81,4.81,0,0,1,194.52,360.49Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.97,
    cy: 369.2,
    r: 2.26,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.07,
    cy: 377.1,
    r: 3.67,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,382.65a3,3,0,1,1,3,3A3,3,0,0,1,204.15,382.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.42,364.07a1.54,1.54,0,1,1,1.54,1.54A1.54,1.54,0,0,1,189.42,364.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.94,357.7a2,2,0,1,1,2,2A2,2,0,0,1,222.94,357.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,367.66a2,2,0,1,1,2,2A2.05,2.05,0,0,1,225,367.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.8,369.31a2,2,0,1,1,2,2A2,2,0,0,1,203.8,369.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.44,430.13a12,12,0,0,0-24,0c0,.11,0,.22,0,.33s0,.22,0,.34c.14,1.66,1.31,3.3,3.52,4.57,4.69,2.72,12.31,2.72,17,0,2.2-1.27,3.37-2.91,3.51-4.57,0-.12,0-.22,0-.34S336.45,430.24,336.44,430.13Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.44,430.13a12,12,0,0,0-24,0c0,.11,0,.22,0,.33s0,.22,0,.34c.14,1.66,1.31,3.3,3.52,4.57,4.69,2.72,12.31,2.72,17,0,2.2-1.27,3.37-2.91,3.51-4.57,0-.12,0-.22,0-.34S336.45,430.24,336.44,430.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.64,419.63h0a12,12,0,0,0-17.24,10.5c0,.11,0,.22,0,.33s0,.22,0,.34c.14,1.66,1.31,3.3,3.52,4.57a15.88,15.88,0,0,0,6,1.89c-3.12-.54-5.14-4-4.18-7.87C318.89,424.93,323.4,418.48,329.64,419.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.44,430.8c0-.12,0-.22,0-.34s0-.22,0-.33a12,12,0,0,0-4.08-8.69c1.31,1.34,4.21,6.41,1.05,10.26-2.07,2.54-11.93,6.16-20,1.51a8.21,8.21,0,0,0,2.55,2.16c4.69,2.72,12.31,2.72,17,0C335.13,434.1,336.3,432.46,336.44,430.8Z",
    style: {
      fill: "#092166",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.3,421.14c.54,1.23-.5,2.87-2.31,3.67s-3.72.44-4.26-.78.5-2.87,2.31-3.66S323.76,419.92,324.3,421.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33,426.13a1.58,1.58,0,1,1-1.92-.53A1.42,1.42,0,0,1,317.33,426.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05,439.16a16.56,16.56,0,0,0-33.11,0c0,.16,0,.31,0,.46s0,.31,0,.47c.19,2.29,1.81,4.54,4.85,6.3,6.46,3.73,16.95,3.73,23.43,0,3-1.76,4.64-4,4.83-6.3,0-.16,0-.31,0-.47S318.06,439.32,318.05,439.16Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05,439.16a16.56,16.56,0,0,0-33.11,0c0,.16,0,.31,0,.46s0,.31,0,.47c.19,2.29,1.81,4.54,4.85,6.3,6.46,3.73,16.95,3.73,23.43,0,3-1.76,4.64-4,4.83-6.3,0-.16,0-.31,0-.47S318.06,439.32,318.05,439.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,424.71h0a16.54,16.54,0,0,0-23.74,14.45c0,.16,0,.31,0,.46s0,.31,0,.47c.19,2.29,1.81,4.54,4.85,6.3A22.15,22.15,0,0,0,298.1,449c-4.3-.74-7.08-5.54-5.76-10.83C293.87,432,300.08,423.12,308.68,424.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05,440.09c0-.16,0-.31,0-.47s0-.3,0-.46a16.49,16.49,0,0,0-5.62-12c1.8,1.85,5.8,8.82,1.45,14.13-2.86,3.5-16.43,8.48-27.61,2.08a11.56,11.56,0,0,0,3.52,3c6.46,3.73,16.95,3.73,23.43,0C316.25,444.63,317.86,442.38,318.05,440.09Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,426.79c.74,1.69-.69,3.95-3.18,5s-5.13.62-5.87-1.07.69-3.94,3.18-5S300.59,425.1,301.33,426.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.74,433.66a2.18,2.18,0,1,1-2.65-.73A2,2,0,0,1,291.74,433.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,445.05a20.55,20.55,0,0,0-41.08,0,5.43,5.43,0,0,0,0,.57,5.33,5.33,0,0,0,0,.57c.23,2.85,2.23,5.64,6,7.82,8,4.64,21,4.64,29.08,0,3.75-2.18,5.76-5,6-7.82a5.33,5.33,0,0,0,0-.57A5.43,5.43,0,0,0,288.53,445.05Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,445.05a20.55,20.55,0,0,0-41.08,0,5.43,5.43,0,0,0,0,.57,5.33,5.33,0,0,0,0,.57c.23,2.85,2.23,5.64,6,7.82,8,4.64,21,4.64,29.08,0,3.75-2.18,5.76-5,6-7.82a5.33,5.33,0,0,0,0-.57A5.43,5.43,0,0,0,288.53,445.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.9,427.11h0a20.52,20.52,0,0,0-29.45,17.94,5.43,5.43,0,0,0,0,.57,5.33,5.33,0,0,0,0,.57c.23,2.85,2.23,5.64,6,7.82a27.31,27.31,0,0,0,10.31,3.22c-5.33-.92-8.78-6.87-7.14-13.44C258.53,436.16,266.24,425.14,276.9,427.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,446.19a5.33,5.33,0,0,0,0-.57,5.43,5.43,0,0,0,0-.57,20.43,20.43,0,0,0-7-14.85c2.24,2.29,7.2,10.95,1.81,17.54-3.55,4.34-20.4,10.53-34.26,2.57a14.2,14.2,0,0,0,4.36,3.7c8,4.64,21,4.64,29.08,0C286.29,451.83,288.3,449,288.53,446.19Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.78,429.69c.92,2.1-.85,4.9-3.95,6.26s-6.36.77-7.28-1.33.85-4.89,3.95-6.25S266.86,427.6,267.78,429.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,438.22a2.7,2.7,0,1,1-3.29-.91A2.45,2.45,0,0,1,255.88,438.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,433a7.26,7.26,0,0,0-14.52,0,2,2,0,0,0,0,.4,3.74,3.74,0,0,0,2.12,2.77,11.44,11.44,0,0,0,10.29,0,3.75,3.75,0,0,0,2.11-2.77,2,2,0,0,0,0-.4Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,433a7.26,7.26,0,0,0-14.52,0,2,2,0,0,0,0,.4,3.74,3.74,0,0,0,2.12,2.77,11.44,11.44,0,0,0,10.29,0,3.75,3.75,0,0,0,2.11-2.77,2,2,0,0,0,0-.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,426.6h0A7.26,7.26,0,0,0,332.09,433a2,2,0,0,0,0,.4,3.74,3.74,0,0,0,2.12,2.77,9.83,9.83,0,0,0,3.65,1.13c-1.88-.32-3.1-2.43-2.53-4.75C336,429.8,338.73,425.91,342.5,426.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,433.35a2,2,0,0,0,0-.4,7.22,7.22,0,0,0-2.46-5.25c.79.81,2.54,3.87.64,6.2-1.26,1.53-7.22,3.72-12.12.91a5.23,5.23,0,0,0,1.54,1.31,11.44,11.44,0,0,0,10.29,0A3.75,3.75,0,0,0,346.61,433.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,427.52c.32.74-.3,1.73-1.4,2.21s-2.25.27-2.57-.47.3-1.73,1.39-2.21S339,426.78,339.28,427.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.07,430.53a1,1,0,0,1-1.71.75,1,1,0,0,1,1.71-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,424.2a12,12,0,0,1,24,0c0,.12,0,.22,0,.34s0,.22,0,.33c-.13,1.67-1.31,3.3-3.52,4.58-4.69,2.71-12.31,2.71-17,0-2.2-1.28-3.37-2.91-3.51-4.58,0-.11,0-.22,0-.33S84.77,424.32,84.78,424.2Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,424.2a12,12,0,0,1,24,0c0,.12,0,.22,0,.34s0,.22,0,.33c-.13,1.67-1.31,3.3-3.52,4.58-4.69,2.71-12.31,2.71-17,0-2.2-1.28-3.37-2.91-3.51-4.58,0-.11,0-.22,0-.33S84.77,424.32,84.78,424.2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,413.71h0a12,12,0,0,1,17.24,10.49c0,.12,0,.22,0,.34s0,.22,0,.33c-.13,1.67-1.31,3.3-3.52,4.58a15.87,15.87,0,0,1-6,1.88c3.12-.54,5.14-4,4.18-7.86C102.34,419,97.83,412.56,91.58,413.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,424.87c0-.11,0-.22,0-.33s0-.22,0-.34a12,12,0,0,1,4.08-8.69c-1.3,1.35-4.21,6.41-1,10.27,2.08,2.54,11.93,6.16,20,1.5a8.23,8.23,0,0,1-2.55,2.17c-4.69,2.71-12.31,2.71-17,0C86.09,428.17,84.92,426.54,84.78,424.87Z",
    style: {
      fill: "#092166",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.92,415.22c-.53,1.22.5,2.86,2.31,3.66s3.72.45,4.26-.78-.49-2.86-2.31-3.66S97.46,414,96.92,415.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89,420.21a1.58,1.58,0,1,0,1.92-.54A1.43,1.43,0,0,0,103.89,420.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,423a17.44,17.44,0,0,1,34.87,0,3.77,3.77,0,0,1,0,.48,4,4,0,0,1,0,.49c-.19,2.41-1.89,4.78-5.1,6.63-6.8,3.94-17.86,3.94-24.68,0-3.19-1.85-4.89-4.22-5.09-6.63,0-.17,0-.32,0-.49S120.72,423.11,120.73,423Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,423a17.44,17.44,0,0,1,34.87,0,3.77,3.77,0,0,1,0,.48,4,4,0,0,1,0,.49c-.19,2.41-1.89,4.78-5.1,6.63-6.8,3.94-17.86,3.94-24.68,0-3.19-1.85-4.89-4.22-5.09-6.63,0-.17,0-.32,0-.49S120.72,423.11,120.73,423Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,407.72h0a17.42,17.42,0,0,1,25,15.23,3.77,3.77,0,0,1,0,.48,4,4,0,0,1,0,.49c-.19,2.41-1.89,4.78-5.1,6.63a23.23,23.23,0,0,1-8.75,2.74c4.52-.79,7.45-5.84,6.06-11.42C146.2,415.4,139.66,406.05,130.6,407.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,423.92c0-.17,0-.32,0-.49s0-.32,0-.48a17.36,17.36,0,0,1,5.92-12.61c-1.89,2-6.11,9.29-1.53,14.89,3,3.68,17.31,8.94,29.08,2.18a12,12,0,0,1-3.7,3.14c-6.8,3.94-17.86,3.94-24.68,0C122.63,428.7,120.93,426.33,120.73,423.92Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.35,409.91c-.78,1.78.72,4.16,3.35,5.31s5.39.66,6.17-1.12-.72-4.16-3.35-5.31S139.13,408.14,138.35,409.91Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,417.15a2.29,2.29,0,1,0,2.79-.77A2.06,2.06,0,0,0,148.45,417.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38,433.18a16.56,16.56,0,0,1,33.1,0,3.54,3.54,0,0,1,0,.46,3.46,3.46,0,0,1,0,.46c-.19,2.3-1.8,4.55-4.84,6.31-6.46,3.73-17,3.73-23.43,0-3-1.76-4.64-4-4.83-6.31a3.46,3.46,0,0,1,0-.46A3.54,3.54,0,0,1,105.38,433.18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38,433.18a16.56,16.56,0,0,1,33.1,0,3.54,3.54,0,0,1,0,.46,3.46,3.46,0,0,1,0,.46c-.19,2.3-1.8,4.55-4.84,6.31-6.46,3.73-17,3.73-23.43,0-3-1.76-4.64-4-4.83-6.31a3.46,3.46,0,0,1,0-.46A3.54,3.54,0,0,1,105.38,433.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75,418.73h0a16.54,16.54,0,0,1,23.73,14.45,3.54,3.54,0,0,1,0,.46,3.46,3.46,0,0,1,0,.46c-.19,2.3-1.8,4.55-4.84,6.31a22.15,22.15,0,0,1-8.31,2.59c4.3-.74,7.08-5.54,5.75-10.84C129.55,426,123.34,417.14,114.75,418.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38,434.1a3.46,3.46,0,0,1,0-.46,3.54,3.54,0,0,1,0-.46,16.45,16.45,0,0,1,5.62-12c-1.8,1.85-5.8,8.82-1.45,14.13,2.86,3.5,16.43,8.48,27.6,2.07a11.65,11.65,0,0,1-3.51,3c-6.46,3.73-17,3.73-23.43,0C107.18,438.65,105.57,436.4,105.38,434.1Z",
    style: {
      fill: "#092166",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,420.81c-.74,1.69.68,3.95,3.18,5s5.12.62,5.86-1.07-.68-3.94-3.18-5S122.84,419.12,122.1,420.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69,427.68a2.17,2.17,0,1,0,2.65-.74A2,2,0,0,0,131.69,427.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,442.57a20.55,20.55,0,0,1,41.09,0c0,.2,0,.38,0,.57s0,.38,0,.57c-.24,2.85-2.24,5.64-6,7.82-8,4.64-21,4.64-29.07,0-3.76-2.18-5.77-5-6-7.82a5.33,5.33,0,0,1,0-.57A5.52,5.52,0,0,1,136.06,442.57Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,442.57a20.55,20.55,0,0,1,41.09,0c0,.2,0,.38,0,.57s0,.38,0,.57c-.24,2.85-2.24,5.64-6,7.82-8,4.64-21,4.64-29.07,0-3.76-2.18-5.77-5-6-7.82a5.33,5.33,0,0,1,0-.57A5.52,5.52,0,0,1,136.06,442.57Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.69,424.64h0a20.33,20.33,0,0,1,8.91-2.06,20.56,20.56,0,0,1,20.55,20c0,.2,0,.38,0,.57s0,.38,0,.57c-.24,2.85-2.24,5.64-6,7.82a27.13,27.13,0,0,1-10.31,3.22c5.33-.92,8.78-6.87,7.14-13.44C166.06,433.68,158.36,422.66,147.69,424.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,443.71a5.33,5.33,0,0,1,0-.57,5.52,5.52,0,0,1,0-.57,20.43,20.43,0,0,1,7-14.85c-2.23,2.3-7.2,10.95-1.81,17.54,3.55,4.34,20.4,10.53,34.26,2.57a14.06,14.06,0,0,1-4.36,3.7c-8,4.64-21,4.64-29.07,0C138.3,449.35,136.29,446.56,136.06,443.71Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.81,427.22c-.92,2.09.85,4.89,3.95,6.25s6.36.77,7.28-1.32-.85-4.9-3.95-6.26S157.73,425.12,156.81,427.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,435.74a2.7,2.7,0,1,0,3.29-.91A2.44,2.44,0,0,0,168.72,435.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,446.26a18.76,18.76,0,0,0-37.51,0,6.77,6.77,0,0,0,0,1c.21,2.6,2,5.15,5.49,7.14,7.32,4.23,19.21,4.23,26.55,0,3.43-2,5.26-4.54,5.47-7.14,0-.18,0-.34,0-.52S251.18,446.44,251.17,446.26Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,446.26a18.76,18.76,0,0,0-37.51,0,6.77,6.77,0,0,0,0,1c.21,2.6,2,5.15,5.49,7.14,7.32,4.23,19.21,4.23,26.55,0,3.43-2,5.26-4.54,5.47-7.14,0-.18,0-.34,0-.52S251.18,446.44,251.17,446.26Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.55,429.89h0a18.72,18.72,0,0,0-26.89,16.37,6.77,6.77,0,0,0,0,1c.21,2.6,2,5.15,5.49,7.14a24.93,24.93,0,0,0,9.41,2.94c-4.86-.84-8-6.27-6.52-12.27C223.78,438.15,230.82,428.09,240.55,429.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,447.3c0-.18,0-.34,0-.52s0-.34,0-.52a18.65,18.65,0,0,0-6.37-13.56c2,2.1,6.57,10,1.64,16-3.24,4-18.61,9.61-31.27,2.34a12.83,12.83,0,0,0,4,3.38c7.32,4.23,19.21,4.23,26.55,0C249.13,452.45,251,449.9,251.17,447.3Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.1,
    cy: 434.49,
    rx: 5.6,
    ry: 3.78,
    transform: "translate(-155.54 127.98) rotate(-23.71)",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.36,440a2.46,2.46,0,1,1-3-.83A2.24,2.24,0,0,1,221.36,440Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,448.3a17.84,17.84,0,0,1,35.67,0c0,.17,0,.32,0,.49s0,.33,0,.5c-.21,2.47-1.95,4.9-5.22,6.79-7,4-18.27,4-25.25,0-3.26-1.89-5-4.32-5.2-6.79a4.1,4.1,0,0,1,0-.5A4,4,0,0,1,172.84,448.3Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,448.3a17.84,17.84,0,0,1,35.67,0c0,.17,0,.32,0,.49s0,.33,0,.5c-.21,2.47-1.95,4.9-5.22,6.79-7,4-18.27,4-25.25,0-3.26-1.89-5-4.32-5.2-6.79a4.1,4.1,0,0,1,0-.5A4,4,0,0,1,172.84,448.3Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,432.73h0a17.61,17.61,0,0,1,7.74-1.79,17.84,17.84,0,0,1,17.84,17.36c0,.17,0,.32,0,.49s0,.33,0,.5c-.21,2.47-1.95,4.9-5.22,6.79a23.67,23.67,0,0,1-9,2.79c4.63-.79,7.63-6,6.21-11.67C198.88,440.58,192.19,431,182.93,432.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,449.29a4.1,4.1,0,0,1,0-.5,4,4,0,0,1,0-.49,17.75,17.75,0,0,1,6-12.9c-1.94,2-6.25,9.51-1.56,15.23,3.08,3.77,17.7,9.14,29.74,2.24a12.53,12.53,0,0,1-3.78,3.21c-7,4-18.27,4-25.25,0C174.78,454.19,173,451.76,172.84,449.29Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,435c-.8,1.81.74,4.25,3.43,5.43s5.52.66,6.32-1.15-.74-4.25-3.43-5.44S191.65,433.15,190.85,435Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.19,442.37a2.34,2.34,0,1,0,2.85-.79A2.12,2.12,0,0,0,201.19,442.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.12,454.53a7.27,7.27,0,0,0-14.53,0,1.48,1.48,0,0,0,0,.21,1.34,1.34,0,0,0,0,.2,3.71,3.71,0,0,0,2.13,2.76,11.35,11.35,0,0,0,10.28,0,3.71,3.71,0,0,0,2.12-2.76v-.41Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.12,454.53a7.27,7.27,0,0,0-14.53,0,1.48,1.48,0,0,0,0,.21,1.34,1.34,0,0,0,0,.2,3.71,3.71,0,0,0,2.13,2.76,11.35,11.35,0,0,0,10.28,0,3.71,3.71,0,0,0,2.12-2.76v-.41Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,448.19h0a7.27,7.27,0,0,0-10.42,6.34,1.48,1.48,0,0,0,0,.21,1.34,1.34,0,0,0,0,.2,3.71,3.71,0,0,0,2.13,2.76,9.6,9.6,0,0,0,3.64,1.14c-1.88-.32-3.1-2.43-2.52-4.75C208.51,451.39,211.24,447.5,215,448.19Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.12,454.94v-.41a7.24,7.24,0,0,0-2.47-5.25c.79.82,2.55,3.87.64,6.21-1.26,1.53-7.21,3.72-12.11.91a5,5,0,0,0,1.54,1.3,11.35,11.35,0,0,0,10.28,0A3.71,3.71,0,0,0,219.12,454.94Z",
    style: {
      fill: "#092166",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.78,449.11c.33.74-.3,1.73-1.39,2.21s-2.25.27-2.58-.47.3-1.73,1.4-2.21S211.46,448.36,211.78,449.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.57,452.12a1,1,0,0,1-1.71.75.86.86,0,0,1,.55-1.07A.85.85,0,0,1,207.57,452.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,427a7.26,7.26,0,0,1,14.52,0,1.34,1.34,0,0,1,0,.2,1.48,1.48,0,0,1,0,.21A3.73,3.73,0,0,1,87,430.19a11.35,11.35,0,0,1-10.28,0,3.73,3.73,0,0,1-2.12-2.76,1.48,1.48,0,0,1,0-.21A1.34,1.34,0,0,1,74.61,427Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,427a7.26,7.26,0,0,1,14.52,0,1.34,1.34,0,0,1,0,.2,1.48,1.48,0,0,1,0,.21A3.73,3.73,0,0,1,87,430.19a11.35,11.35,0,0,1-10.28,0,3.73,3.73,0,0,1-2.12-2.76,1.48,1.48,0,0,1,0-.21A1.34,1.34,0,0,1,74.61,427Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.72,420.68h0A7.24,7.24,0,0,1,89.13,427a1.34,1.34,0,0,1,0,.2,1.48,1.48,0,0,1,0,.21A3.73,3.73,0,0,1,87,430.19a9.65,9.65,0,0,1-3.65,1.14c1.89-.33,3.11-2.43,2.53-4.76C85.21,423.88,82.49,420,78.72,420.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,427.43a1.48,1.48,0,0,1,0-.21,1.34,1.34,0,0,1,0-.2,7.23,7.23,0,0,1,2.46-5.25c-.79.81-2.54,3.87-.63,6.2,1.25,1.54,7.21,3.73,12.11.91A5.09,5.09,0,0,1,87,430.19a11.35,11.35,0,0,1-10.28,0A3.73,3.73,0,0,1,74.61,427.43Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.94,421.59c-.32.74.3,1.73,1.4,2.21s2.25.28,2.57-.46-.3-1.74-1.39-2.22S82.27,420.85,81.94,421.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,424.61a1,1,0,1,0,1.17-.33A.87.87,0,0,0,86.15,424.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.82,291.46,281.27,288l-13.55,3.51s-1.63,7.26.15,18.63,9.69,22.75,13.4,22.75,11.63-11.38,13.4-22.75S294.82,291.46,294.82,291.46Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.82,291.46,281.27,288l-13.55,3.51s-1.63,7.26.15,18.63,9.69,22.75,13.4,22.75,11.63-11.38,13.4-22.75S294.82,291.46,294.82,291.46Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,293.1H271.59c-2.65,16,5.86,28.31,9.27,28.31S292.79,309.12,290.14,293.1Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.86,293.1H284a14.08,14.08,0,0,1,1.72,8.56c-.38,4.32-3,9.94-4.9,9.94s-4.51-5.62-4.9-9.94a14,14,0,0,1,1.73-8.56h3.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.16,276.3l-1.49-6.38h-20.8l-1.49,6.38a7.72,7.72,0,0,0,3.46,6.79,12.67,12.67,0,0,0,2.92,1.59,15.66,15.66,0,0,0,11.08,0,12.1,12.1,0,0,0,2.85-1.56A7.73,7.73,0,0,0,293.16,276.3Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.16,276.3l-1.49-6.38h-20.8l-1.49,6.38a7.72,7.72,0,0,0,3.46,6.79,12.67,12.67,0,0,0,2.92,1.59,15.66,15.66,0,0,0,11.08,0,12.1,12.1,0,0,0,2.85-1.56A7.73,7.73,0,0,0,293.16,276.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45,277.56l.15.63.64,2.75a8.51,8.51,0,0,1-3.8,7.07,13.58,13.58,0,0,1-3.13,1.72,17.1,17.1,0,0,1-12,0,13.74,13.74,0,0,1-3.2-1.74,8.49,8.49,0,0,1-3.79-7.1l-1.75,7.48h0c0,2.52,1.44,5,4.31,7a15.89,15.89,0,0,0,3.75,1.82,21.33,21.33,0,0,0,13.38,0,16,16,0,0,0,3.69-1.8c2.87-1.92,4.31-4.44,4.31-7Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45,277.56l.15.63.64,2.75a8.51,8.51,0,0,1-3.8,7.07,13.58,13.58,0,0,1-3.13,1.72,17.1,17.1,0,0,1-12,0,13.74,13.74,0,0,1-3.2-1.74,8.49,8.49,0,0,1-3.79-7.1l-1.75,7.48h0c0,2.52,1.44,5,4.31,7a15.89,15.89,0,0,0,3.75,1.82,21.33,21.33,0,0,0,13.38,0,16,16,0,0,0,3.69-1.8c2.87-1.92,4.31-4.44,4.31-7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,278.19l-.15-.63-.29-1.26a7.73,7.73,0,0,1-3.47,6.79,12.1,12.1,0,0,1-2.85,1.56,15.66,15.66,0,0,1-11.08,0,12.67,12.67,0,0,1-2.92-1.59,7.72,7.72,0,0,1-3.46-6.79l-1.08,4.61a8.49,8.49,0,0,0,3.79,7.1,13.74,13.74,0,0,0,3.2,1.74,17.1,17.1,0,0,0,12,0,13.58,13.58,0,0,0,3.13-1.72,8.51,8.51,0,0,0,3.8-7.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.25,282.22c9.39,0,12.48-3.48,12.48-3.48l-.13-.55-.15-.63-.29-1.26-1.49-6.38h-20.8l-1.49,6.38-.58,2.45S271.85,282.22,281.25,282.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.41,108.18a10.69,10.69,0,0,0-.35-2.64c-1.81-7.76-7-15.09-9.42-18.8a41.43,41.43,0,0,0-3.48-4.42,1.54,1.54,0,0,0-.9-.26,1.51,1.51,0,0,0-.88.3,41.74,41.74,0,0,0-3.31,4.54c-2.31,3.81-8,11.34-9.5,19.16a10.71,10.71,0,0,0-.16,2.65s0,161.42,0,161v.13c0,.09,0,.17,0,.26h0s0,.05,0,.08c.18,1.92,1.53,3.81,4.07,5.28,5.47,3.16,14.35,3.16,19.83,0,2.76-1.6,4.13-3.7,4.1-5.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,191.48c-5.69,3.29-14.92,3.29-20.61,0a8.89,8.89,0,0,1-3.69-3.64v2.75a8.78,8.78,0,0,0,3.69,3.64c5.69,3.29,14.92,3.29,20.61,0a9,9,0,0,0,3.71-3.64v-2.76A9,9,0,0,1,291.7,191.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,242.48c-5.69,3.29-14.92,3.29-20.61,0a8.84,8.84,0,0,1-3.7-3.66v5.5a8.84,8.84,0,0,0,3.7,3.66c5.69,3.29,14.92,3.29,20.61,0a9,9,0,0,0,3.71-3.64v-5.51A9,9,0,0,1,291.7,242.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,175.65c-5.69,3.29-14.92,3.29-20.61,0a8.79,8.79,0,0,1-3.68-3.63c0,.91,0,1.83,0,2.75a9,9,0,0,0,3.69,3.64c5.69,3.28,14.92,3.28,20.61,0a9.09,9.09,0,0,0,3.71-3.65V172A9,9,0,0,1,291.7,175.65Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,122c-5.69,3.29-14.92,3.29-20.61,0a8.83,8.83,0,0,1-3.68-3.62v5.5a8.9,8.9,0,0,0,3.68,3.63c5.69,3.28,14.92,3.28,20.61,0a9,9,0,0,0,3.71-3.65v-5.5A9,9,0,0,1,291.7,122Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,92.43a5.17,5.17,0,0,1-2.06,2,13,13,0,0,1-11.7,0,5.1,5.1,0,0,1-2-2c1.4-2.25,2.71-4.17,3.56-5.57a43,43,0,0,1,3.31-4.55,1.54,1.54,0,0,1,.88-.29,1.61,1.61,0,0,1,.9.26,41,41,0,0,1,3.48,4.41C286.59,88.16,287.93,90.12,289.31,92.43Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.31,275.49c2.76-1.6,4.13-3.7,4.1-5.79V108.18a10.69,10.69,0,0,0-.35-2.64c-1.81-7.76-7-15.09-9.42-18.8a41.43,41.43,0,0,0-3.48-4.42,1.58,1.58,0,0,0-.89-.26c1.43.08,5.2,21.7,5.2,30.22v165A17.59,17.59,0,0,0,291.31,275.49Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.66,289.24c-2.77,9-5.61,18-8.62,26.93a4.73,4.73,0,0,0,1.64,4.85,25.88,25.88,0,0,0,17.19,6.11,26.65,26.65,0,0,0,17.2-6.35,4.66,4.66,0,0,0,1.63-4.8c-3.06-8.78-5.88-17.65-8.62-26.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.87,320.1a26.72,26.72,0,0,1-18-6.41l-.84,2.48a4.73,4.73,0,0,0,1.64,4.85,26,26,0,0,0,17.19,6.11,26.8,26.8,0,0,0,17.2-6.35,4.66,4.66,0,0,0,1.63-4.8c-.33-1-.49-1.44-.83-2.41C280.93,317.94,274.35,319.88,267.87,320.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.87,299.38a35.06,35.06,0,0,0,12.66-2.1c-1-3.09-1.47-4.66-2.45-7.84l-9.19-.09h-1l-1,0-9.19-.09c-1,3.2-1.46,4.78-2.44,7.9A34.64,34.64,0,0,0,267.87,299.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.36,289.28c-.32,2.54-.73,5.84-1.16,9.33a30.37,30.37,0,0,1-3.41-.91c.59-3.36.89-5.05,1.48-8.45Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.07,320.78a26.71,26.71,0,0,1-17.2,6.34c-.43,0-.85,0-1.27,0l-1.22-.07-.62-.06-.94-.1-.59-.1-.59-.1-1-.19-.18,0c-.38-.09-.75-.18-1.1-.28s-.88-.25-1.3-.39l-.73-.26c-.32-.11-.64-.24-.94-.37-.58-.24-1.16-.5-1.69-.76l-.4-.21-.46-.24-.65-.38-.68-.41-.63-.42-.59-.4c.45-2.39.67-3.59,1.11-6a25.66,25.66,0,0,0,4.22,2c-.16,1.17-.36,2.09-.32,2.26C259,326.68,273.44,327.76,285.07,320.78Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.2,298.61c-.84,6.58-1.67,13.16-2.55,19.73a25.66,25.66,0,0,1-4.22-2q1.69-9.31,3.36-18.62A30.37,30.37,0,0,0,260.2,298.61Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,112.27a28,28,0,0,0-.56-6.83C270,85.33,257.53,67.42,251,58a29.37,29.37,0,0,0-5-5.59,4.13,4.13,0,0,0-4.66,0,25.12,25.12,0,0,0-5,5.59c-6.14,9.71-19.06,27.34-23.35,47.45a28,28,0,0,0-.56,6.83l3.9,171.92h0c0,5.6,5.13,11.2,15.38,14.25a42.15,42.15,0,0,0,23.92,0c10.25-3.05,15.38-8.65,15.38-14.25h0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.26,162.55a1.33,1.33,0,0,1-1.33-1.33V131.8a1.33,1.33,0,1,1,2.66,0v29.42A1.32,1.32,0,0,1,243.26,162.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251,161.93a1.34,1.34,0,0,1-1.33-1.33V131.18a1.33,1.33,0,1,1,2.66,0V160.6A1.34,1.34,0,0,1,251,161.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258.31,160.12a1.32,1.32,0,0,1-1.33-1.33V129.37a1.33,1.33,0,1,1,2.66,0v29.42A1.33,1.33,0,0,1,258.31,160.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.86,157.37a1.32,1.32,0,0,1-1.33-1.33V126.62a1.33,1.33,0,1,1,2.66,0V156A1.33,1.33,0,0,1,264.86,157.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.28,153.91a1.33,1.33,0,0,1-1.33-1.33V123.16a1.33,1.33,0,1,1,2.66,0v29.42A1.33,1.33,0,0,1,270.28,153.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.54,161.93a1.34,1.34,0,0,0,1.33-1.33V131.18a1.33,1.33,0,1,0-2.66,0V160.6A1.33,1.33,0,0,0,235.54,161.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.22,160.12a1.32,1.32,0,0,0,1.33-1.33V129.37a1.33,1.33,0,1,0-2.66,0v29.42A1.33,1.33,0,0,0,228.22,160.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.67,157.37A1.32,1.32,0,0,0,223,156V126.62a1.33,1.33,0,0,0-2.66,0V156A1.33,1.33,0,0,0,221.67,157.37Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.25,153.91a1.33,1.33,0,0,0,1.33-1.33V123.16a1.33,1.33,0,0,0-2.66,0v29.42A1.32,1.32,0,0,0,216.25,153.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M263,126.3c0,16.69-1.25,102.74-2.2,170.16,6.76-3.18,10.14-7.72,10.14-12.27h0l3.9-171.92a28,28,0,0,0-.56-6.83C270,85.33,257.53,67.42,251,58c-.54-.78-1.21-1.64-1.89-2.44C257.77,72,263,99.53,263,126.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,52.4a4.13,4.13,0,0,0-4.66,0,25.12,25.12,0,0,0-5,5.59c-6.14,9.71-19.06,27.34-23.35,47.45a28,28,0,0,0-.56,6.83l3.9,171.92c0,4.93,4,9.86,11.94,13.05V176.91c0-59.21,1.67-76.36,4.28-91.07S243,50.84,246,52.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,117.22c13.17,7.61,34.53,7.61,47.7,0a22.55,22.55,0,0,0,7.61-6.74,27.5,27.5,0,0,0-.57-5c-.19-.88-.39-1.74-.61-2.6a24.48,24.48,0,0,1-6.43,5.18c-13.17,7.6-34.53,7.6-47.7,0a24.8,24.8,0,0,1-6.1-4.82c-.18.74-.36,1.49-.52,2.24a28,28,0,0,0-.57,5.63A23.19,23.19,0,0,0,219.58,117.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6,107.73c0,.24-.06.47-.08.7s-.06.7-.08,1c0,.11,0,.23,0,.35,0,.41,0,.83,0,1.24a23.19,23.19,0,0,0,7.19,6.15,39.86,39.86,0,0,0,10,4c.14-3.2.29-6.24.45-9.09A40.71,40.71,0,0,1,219.58,108a24.8,24.8,0,0,1-6.1-4.82c-.18.74-.36,1.49-.52,2.24-.1.5-.19,1-.27,1.52C212.65,107.22,212.63,107.48,212.6,107.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,333l-13.55-3.51L195.71,333s-1.62,7.27.15,18.64,9.69,22.75,13.4,22.75,11.63-11.38,13.4-22.75S222.81,333,222.81,333Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,333l-13.55-3.51L195.71,333s-1.62,7.27.15,18.64,9.69,22.75,13.4,22.75,11.63-11.38,13.4-22.75S222.81,333,222.81,333Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,334.67H199.58c-2.65,16,5.86,28.32,9.27,28.32S220.78,350.7,218.13,334.67Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85,334.67H212a14.13,14.13,0,0,1,1.73,8.56c-.39,4.32-3,9.94-4.91,9.94s-4.51-5.62-4.9-9.94a14,14,0,0,1,1.73-8.56h3.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,317.87l-1.49-6.38h-20.8l-1.49,6.38a7.71,7.71,0,0,0,3.47,6.79,11.89,11.89,0,0,0,2.91,1.59,15.61,15.61,0,0,0,11.08,0,12.5,12.5,0,0,0,2.85-1.57A7.71,7.71,0,0,0,221.15,317.87Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,317.87l-1.49-6.38h-20.8l-1.49,6.38a7.71,7.71,0,0,0,3.47,6.79,11.89,11.89,0,0,0,2.91,1.59,15.61,15.61,0,0,0,11.08,0,12.5,12.5,0,0,0,2.85-1.57A7.71,7.71,0,0,0,221.15,317.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,319.13l.15.63.64,2.75a8.48,8.48,0,0,1-3.8,7.07,13,13,0,0,1-3.13,1.72,17,17,0,0,1-12,0,13.13,13.13,0,0,1-3.19-1.74,8.49,8.49,0,0,1-3.8-7.1L194.54,330h0c0,2.52,1.44,5,4.31,7a15.87,15.87,0,0,0,3.75,1.81,21.33,21.33,0,0,0,13.38,0,16.2,16.2,0,0,0,3.69-1.8c2.87-1.93,4.31-4.45,4.31-7Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,319.13l.15.63.64,2.75a8.48,8.48,0,0,1-3.8,7.07,13,13,0,0,1-3.13,1.72,17,17,0,0,1-12,0,13.13,13.13,0,0,1-3.19-1.74,8.49,8.49,0,0,1-3.8-7.1L194.54,330h0c0,2.52,1.44,5,4.31,7a15.87,15.87,0,0,0,3.75,1.81,21.33,21.33,0,0,0,13.38,0,16.2,16.2,0,0,0,3.69-1.8c2.87-1.93,4.31-4.45,4.31-7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59,319.76l-.15-.63-.29-1.26a7.71,7.71,0,0,1-3.47,6.79,12.5,12.5,0,0,1-2.85,1.57,15.61,15.61,0,0,1-11.08,0,11.89,11.89,0,0,1-2.91-1.59,7.71,7.71,0,0,1-3.47-6.79l-1.08,4.61a8.49,8.49,0,0,0,3.8,7.1,13.13,13.13,0,0,0,3.19,1.74,17,17,0,0,0,12,0,13,13,0,0,0,3.13-1.72,8.48,8.48,0,0,0,3.8-7.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.24,323.8c9.39,0,12.48-3.48,12.48-3.48l-.13-.56-.15-.63-.29-1.26-1.49-6.38h-20.8l-1.49,6.38-.58,2.46S199.84,323.8,209.24,323.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4,149.76a11.32,11.32,0,0,0-.34-2.65c-1.82-7.76-7-15.08-9.42-18.8a42.17,42.17,0,0,0-3.49-4.42,1.56,1.56,0,0,0-1.78,0,41.94,41.94,0,0,0-3.31,4.55c-2.3,3.81-8,11.33-9.5,19.16a10.68,10.68,0,0,0-.16,2.65s0,161.41,0,161v.13c0,.08,0,.17,0,.25h0s0,.06,0,.08c.18,1.92,1.53,3.81,4.07,5.28,5.48,3.16,14.35,3.16,19.83,0,2.77-1.6,4.13-3.7,4.1-5.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,233.06c-5.69,3.28-14.92,3.28-20.61,0a9,9,0,0,1-3.69-3.64v2.75a9,9,0,0,0,3.69,3.64c5.69,3.28,14.92,3.28,20.61,0a9,9,0,0,0,3.71-3.65v-2.75A9,9,0,0,1,219.69,233.06Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,284.05c-5.69,3.29-14.92,3.29-20.61,0a8.84,8.84,0,0,1-3.7-3.66v5.5a8.86,8.86,0,0,0,3.7,3.67c5.69,3.28,14.92,3.28,20.61,0a9,9,0,0,0,3.71-3.65v-5.5A9,9,0,0,1,219.69,284.05Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,217.23c-5.69,3.28-14.92,3.28-20.61,0a8.86,8.86,0,0,1-3.68-3.64v2.75a8.8,8.8,0,0,0,3.68,3.64c5.69,3.29,14.92,3.29,20.61,0a9,9,0,0,0,3.71-3.65v-2.75A9,9,0,0,1,219.69,217.23Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,163.61c-5.69,3.28-14.92,3.28-20.61,0A9,9,0,0,1,195.4,160v5.51a9,9,0,0,0,3.68,3.62c5.69,3.29,14.92,3.29,20.61,0a9,9,0,0,0,3.71-3.65V160A9,9,0,0,1,219.69,163.61Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,134a5.09,5.09,0,0,1-2.06,2,13,13,0,0,1-11.7,0,5.1,5.1,0,0,1-2-2c1.4-2.25,2.71-4.16,3.57-5.56a39.76,39.76,0,0,1,3.3-4.55,1.48,1.48,0,0,1,.88-.3,1.61,1.61,0,0,1,.9.26,42,42,0,0,1,3.48,4.41C214.58,129.73,215.92,131.69,217.3,134Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.3,317.06c2.77-1.6,4.13-3.7,4.1-5.79V149.75a11.31,11.31,0,0,0-.34-2.64c-1.82-7.76-7-15.08-9.42-18.8a43.53,43.53,0,0,0-3.49-4.42,1.58,1.58,0,0,0-.89-.26c1.43.08,5.2,21.7,5.2,30.23v165A17.16,17.16,0,0,0,219.3,317.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.52,250.48l-17.11-15.3c-1.81-1.62-3.09-4.29-3.69-7.69-.57-3.22-1.32-7.62-2.05-12.26-1.84-11.6-3.75-24.71-4.5-24.27,0,0-2.35-2-2.89-1.66v96.45l2.89,1.66L304.58,271V253.68A4.27,4.27,0,0,0,303.52,250.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,191c.75-.44,2.66,12.67,4.5,24.27.73,4.64,1.48,9,2.05,12.26.6,3.4,1.88,6.07,3.69,7.69l17.11,15.3a4.27,4.27,0,0,1,1.06,3.2V271l-28.41,16.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,214.84l1.66-1c.64-.37,1.19,0,1.34.86l2.47,14.6.66,3.93c.69,4.09,2.19,7.32,4.32,9.33l14.05,13.21a5.23,5.23,0,0,1,1.24,3.81v6.95l-25.74,14.87Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,214.84l1.66-1c.64-.37,1.19,0,1.34.86l2.47,14.6.66,3.93c.69,4.09,2.19,7.32,4.32,9.33l14.05,13.21a5.23,5.23,0,0,1,1.24,3.81v6.95l-25.74,14.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,213.88c.64-.37,1.19,0,1.34.86l2.47,14.6.66,3.93c.69,4.09,2.19,7.32,4.32,9.33l14.05,13.21a5.23,5.23,0,0,1,1.24,3.81v6.95l-2.66,1.54v-6.95a1.88,1.88,0,0,0-.44-1.36l-14.05-13.21c-2.5-2.34-4.24-6.1-5.05-10.88l-2.89-17.15-.65.38v-4.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.19,202.47c-.76.44-2.67,15.75-4.51,29.47-.73,5.49-1.48,10.75-2.05,14.63a41.41,41.41,0,0,1-3.69,12l-17.11,35.05a10.4,10.4,0,0,0-1.06,4.43v17.32l2.88,1.66,28.42-16.4V204.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,204.14c-.76.44-2.67,15.74-4.51,29.46-.73,5.5-1.48,10.76-2.05,14.63a41.32,41.32,0,0,1-3.69,12l-17.11,35.06a10.32,10.32,0,0,0-1.06,4.42V317l28.42-16.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,228l-1.67,1a3.45,3.45,0,0,0-1.34,2.4l-2.46,17.45-.67,4.7a50.1,50.1,0,0,1-4.32,14.32l-14.05,29.43a12.53,12.53,0,0,0-1.24,5.24v7l25.75-14.86Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,228l-1.67,1a3.45,3.45,0,0,0-1.34,2.4l-2.46,17.45-.67,4.7a50.1,50.1,0,0,1-4.32,14.32l-14.05,29.43a12.53,12.53,0,0,0-1.24,5.24v7l25.75-14.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4,229a3.45,3.45,0,0,0-1.34,2.4l-2.46,17.45-.67,4.7a50.1,50.1,0,0,1-4.32,14.32l-14.05,29.43a12.53,12.53,0,0,0-1.24,5.24v7l2.66-1.53V301a4.45,4.45,0,0,1,.44-1.87l14.06-29.43a58.35,58.35,0,0,0,5-16.71l2.89-20.49.66-.38V228Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,199.79a18.26,18.26,0,0,0-.37-4.49,94.85,94.85,0,0,0-12.83-31.09c-.83-1.28-2.63-4.2-3.37-4.71a2.73,2.73,0,0,0-3.06,0c-.73.51-2.5,3.45-3.36,4.71a94.15,94.15,0,0,0-12.83,31.09,18.26,18.26,0,0,0-.37,4.49l.13,98.82h0c0,3.68,3.37,7.36,10.1,9.36a27.67,27.67,0,0,0,15.72,0c6.74-2,10.11-5.68,10.11-9.36h0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,199.79a18.26,18.26,0,0,0-.37-4.49,94.85,94.85,0,0,0-12.83-31.09c-.83-1.28-2.63-4.2-3.37-4.71a2.73,2.73,0,0,0-3.06,0c-.73.51-2.5,3.45-3.36,4.71a94.15,94.15,0,0,0-12.83,31.09,18.26,18.26,0,0,0-.37,4.49l.13,98.82h0c0,3.68,3.37,7.36,10.1,9.36a27.67,27.67,0,0,0,15.72,0c6.74-2,10.11-5.68,10.11-9.36h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.84,298.61h0l.13-98.82a18.26,18.26,0,0,0-.37-4.49,94.85,94.85,0,0,0-12.83-31.09l-.69-1.08c3.73,9.5,9.64,24.73,10,46,.23,12.57-.67,71.17-1.44,96.72C284.1,303.87,285.84,301.24,285.84,298.61Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.17,159.36a2.73,2.73,0,0,0-1.3-.33,2.69,2.69,0,0,0-1.53.47c-.73.51-2.5,3.45-3.36,4.71a94.15,94.15,0,0,0-12.83,31.09,18.26,18.26,0,0,0-.37,4.49l.13,98.82c0,3.68,3.37,7.36,10.1,9.36l.29.07c-1.35-30.79-6.14-111.94-1.48-126.14C262,172.31,267,158.62,269.17,159.36Z",
    style: {
      fill: "#092166",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,164.21a75.72,75.72,0,0,0-5.24,9.24,16.38,16.38,0,0,0,10.14,3.24A15.83,15.83,0,0,0,278,173.5a92.07,92.07,0,0,0-5.24-9.29h0c-.57-.88-1.6-2.53-2.43-3.65a5.37,5.37,0,0,0-.94-1.06,2.73,2.73,0,0,0-3.06,0,2.73,2.73,0,0,0-.32.3c-.84.92-2.29,3.31-3,4.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,173.5a91,91,0,0,0-5.24-9.29h0l-.12-.19,0-.08c-.1-.14-.2-.29-.3-.46s-.15-.22-.22-.34c1.25,3.17,2.74,7,4.19,11.49C276.91,174.26,277.47,173.88,278,173.5Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,164.21a75.72,75.72,0,0,0-5.24,9.24,20.9,20.9,0,0,0,3.31,1.91c2.93-8.25,6.38-16.58,8.12-16h0a3,3,0,0,0-.58-.24h-.07l-.29-.06-.35,0a2.69,2.69,0,0,0-1.53.47,2.73,2.73,0,0,0-.32.3c-.84.92-2.29,3.31-3,4.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,202.57v-2.78a18.26,18.26,0,0,0-.37-4.49c-.34-1.58-.71-3.12-1.12-4.63a10.77,10.77,0,0,1-4.1,3.82,21.61,21.61,0,0,1-6.87,2.42,6.31,6.31,0,0,0-5.36,5.63l0,1.18A4.39,4.39,0,0,0,273,208.5a26.85,26.85,0,0,0,9.29-3.07A15.25,15.25,0,0,0,286,202.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,202.57v-2.78a18.26,18.26,0,0,0-.37-4.49c-.17-.79-.35-1.57-.54-2.35s-.37-1.49-.56-2.22l0-.06a10.47,10.47,0,0,1-3.6,3.52c.52,3.58.91,7.38,1.1,11.42l.34-.18A15.25,15.25,0,0,0,286,202.57Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.32,301.36l16.75,13.18,2.37-1.37c.13-4.85-1.45-9.14-5-13.67-1.49-1.93-2.86-3.72-4.09-5.42a59.91,59.91,0,0,1-4.86-7.64c-2-4-2.52-6.47-2.49-9.21a1.29,1.29,0,0,1,0-.28v-.26l-1.26.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.89,308.05a17.91,17.91,0,0,1,.48,2.9L293,312.32v-.08a18.81,18.81,0,0,0-.47-2.8v0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.89,308.05a17.91,17.91,0,0,1,.48,2.9L293,312.32v-.08a18.81,18.81,0,0,0-.47-2.8v0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.79,277.3a25.28,25.28,0,0,0,1.95,10c1.5,4,4.45,8.48,8.38,13.55,3.51,4.52,5.08,8.81,4.95,13.66l-16.75-13.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.56,296.87l16,12.55a18.89,18.89,0,0,1,.49,2.9l-16.58-13Z",
    style: {
      fill: "#092166"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-2--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planet--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rings--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,96.17a33.55,33.55,0,1,1,33.54-33.55A33.59,33.59,0,0,1,427,96.17Zm0-66.31a32.77,32.77,0,1,0,32.76,32.76A32.8,32.8,0,0,0,427,29.86Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,98.6a36,36,0,1,1,36-36A36,36,0,0,1,427,98.6Zm0-71.17a35.19,35.19,0,1,0,35.19,35.19A35.24,35.24,0,0,0,427,27.43Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,101.59a39,39,0,1,1,39-39A39,39,0,0,1,427,101.59Zm0-77.16a38.19,38.19,0,1,0,38.19,38.19A38.24,38.24,0,0,0,427,24.43Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,105.33a42.71,42.71,0,1,1,42.7-42.71A42.76,42.76,0,0,1,427,105.33Zm0-84.63A41.92,41.92,0,1,0,469,62.62,42,42,0,0,0,427,20.7Z",
    style: {
      fill: "#092166"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet--inject-26"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 427.03,
    cy: 62.62,
    r: 30.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.03,
    cy: 62.62,
    r: 30.8,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.58,44.14c-.22-.53-.45-1-.69-1.55-.43-.89-5.14-9.34-5.44-9.24a30,30,0,0,0-5.38,2.35c1.87,2.78,4.22,5.5,5.89,8.37a38.41,38.41,0,0,1,2.75,6.77A10.66,10.66,0,0,0,422,53.66a3.87,3.87,0,0,0,2.53,1.67.94.94,0,0,0,.5,0c.37-.16.46-.62.5-1A22.84,22.84,0,0,0,423.58,44.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.59,83.58c-5.22-5.07-14.93-14.56-19-18.85-3.1-3.24-7.38-4.71-10.5-7.82-2.13-2.14-3-5.2-3.82-8.1-.48-1.63-1.36-6.77-3.8-6.19-.08.84.43,2.77-.48,3.35s-1.58-1.13-1.87-1.63S407,39.24,407,39.2a31.74,31.74,0,0,0-2.51,2.41c2.71,5,7.07,13,8.06,14.68,1.46,2.45,0,5.15-1.82,2.52-1.13-1.63-6.15-8-9.79-12.61a31.29,31.29,0,0,0-2.93,6c2.86,4.2,6.12,9.35,10.78,11.74a5.66,5.66,0,0,0,5,.28c1-.53,1.89-1.51,3-1.78,1.44-.33,2.86.56,4.05,1.42,2.48,1.79,4.89,3.67,7.18,5.69a19.88,19.88,0,0,1,3.24,3c.47.68.56,2.19-.22,2.75,0,.29-1.12.24-1.28.2a3.45,3.45,0,0,1-1.12-.66c-1-.68-2.12-1.29-3.17-1.93-.82-.5-1.86-1-2.68-.5a3,3,0,0,0,1.06,2.22,45.82,45.82,0,0,0,6.8,6.11,5.1,5.1,0,0,0,1.52.86,1.89,1.89,0,0,0,1.67-.21c.48-.36.71-1,1.23-1.3a1.63,1.63,0,0,1,1.61.09c1.11.64,2,1.85,3,2.61a45.58,45.58,0,0,1,5.08,4.91A30.58,30.58,0,0,0,449.59,83.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,93.42a30.8,30.8,0,0,0,11.23-2.12c-5.07-4.56-13.12-11.71-15.53-13.27-2.15-1.39-3.63.77-4.9,2.24a4.69,4.69,0,0,1-2.32,1.83c-1.44.29-2.84-1.2-2.88-2.59a4.48,4.48,0,0,1,1.24-2.92,9,9,0,0,0,2-2.59c.58-1.63-.37-3.36-1.28-4.82-.37-.58-.8-1.22-1.48-1.36-.93-.21-1.74.6-2.41,1.28a15.09,15.09,0,0,1-2.65,2.13,3.65,3.65,0,0,1-2,.7,4.11,4.11,0,0,1-2.13-1,17.53,17.53,0,0,1-4.07-3.85c-.63-.81-1.25-1.62-1.87-2.44-.34-.46-1.75-1.81-1.75-2.35v.3A30.8,30.8,0,0,0,427,93.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.6,34.51c-.14,1.66.57,3.63,2.95,6.78,1.24,1.66,2.54,3.27,3.85,4.87,1,1.25,2.87,2.73,2.85,4.47a4.14,4.14,0,0,1-1.78,2.87A15.86,15.86,0,0,1,445,55.16c-.73.39-1.59.88-1.61,1.7s.72,1.29,1.37,1.67c2.48,1.45,5,2.83,7.56,4.14a16.35,16.35,0,0,1,3.51,1.86c.65.59,1.05,1.42,1.74,2a19.54,19.54,0,0,0,.28-3.9A30.79,30.79,0,0,0,439.6,34.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.43,53a10.71,10.71,0,0,1,1.21-.76c.91-.49,2-1,2.21-2,.32-1.36-1.05-2.47-2.24-3.19l-3.72-2.27a7.46,7.46,0,0,1-1.68-1.26,7,7,0,0,1-1.1-1.94,45.25,45.25,0,0,1-1.9-5.54c-.19-.7-.58-3.79-1.65-3.91a31.71,31.71,0,0,0-3.53-.21,30.13,30.13,0,0,0-3.82.25c.63,0,2.05,3.71,2.25,4.27a51.36,51.36,0,0,1,2.28,7.52c.46,2.51,3.59,3.77,5.55,5.14a1.73,1.73,0,0,1,.7.72,1.54,1.54,0,0,1-.17,1.18,35.93,35.93,0,0,1-2.08,3.26,5,5,0,0,0-.87,3.67,6.4,6.4,0,0,0,2.05,2.9c6.58,6.29,13.53,12.35,19.76,18.94a30.91,30.91,0,0,0,3.25-6.38c.22-.61-3.37-3.5-3.84-3.88-2.11-1.68-4.5-3.06-6.62-4.77l-5.91-4.8a5.58,5.58,0,0,1-2.12-2.58,3.61,3.61,0,0,1,.68-3.06A6,6,0,0,1,439.43,53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.47,81.11c.22.52.45,1,.69,1.54.43.9,5.15,9.34,5.45,9.24A29.93,29.93,0,0,0,442,89.54c-1.87-2.78-4.22-5.5-5.88-8.37a37.7,37.7,0,0,1-2.76-6.77A10.81,10.81,0,0,0,432,71.58a3.88,3.88,0,0,0-2.53-1.67,1,1,0,0,0-.49,0c-.37.16-.47.63-.5,1A22.76,22.76,0,0,0,430.47,81.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.46,41.66c5.22,5.08,14.93,14.56,19,18.85,3.1,3.24,7.37,4.71,10.49,7.83,2.14,2.13,3,5.2,3.83,8.1.47,1.63,1.35,6.77,3.79,6.19.09-.84-.42-2.78.48-3.35s1.59,1.13,1.88,1.62S447.07,86,447,86a33.7,33.7,0,0,0,2.52-2.41c-2.71-5-7.07-13-8.06-14.68-1.46-2.44,0-5.14,1.81-2.52,1.13,1.63,6.16,8,9.79,12.61a30.71,30.71,0,0,0,2.93-6c-2.86-4.19-6.12-9.35-10.78-11.74a5.69,5.69,0,0,0-5-.28c-1.05.54-1.88,1.51-3,1.78-1.44.33-2.85-.56-4.05-1.42-2.48-1.79-4.89-3.67-7.18-5.69a19.78,19.78,0,0,1-3.23-3c-.48-.69-.57-2.2.21-2.76,0-.29,1.12-.24,1.28-.2a3.8,3.8,0,0,1,1.13.66c1,.69,2.11,1.29,3.17,1.94.81.49,1.85,1,2.67.5a3,3,0,0,0-1.06-2.23,47,47,0,0,0-6.8-6.11,5.38,5.38,0,0,0-1.51-.85,1.91,1.91,0,0,0-1.68.2c-.48.36-.71,1-1.23,1.3a1.63,1.63,0,0,1-1.61-.09c-1.11-.63-1.95-1.85-3-2.61a46.47,46.47,0,0,1-5.08-4.91A31.61,31.61,0,0,0,404.46,41.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,31.82a30.76,30.76,0,0,0-11.23,2.12c5.06,4.57,13.11,11.71,15.52,13.27,2.15,1.39,3.64-.77,4.9-2.24a4.81,4.81,0,0,1,2.33-1.83c1.44-.29,2.83,1.21,2.87,2.59a4.47,4.47,0,0,1-1.23,2.92,9,9,0,0,0-2,2.6c-.58,1.62.37,3.35,1.29,4.81a2.66,2.66,0,0,0,1.47,1.37c.93.2,1.74-.61,2.41-1.29A14.75,14.75,0,0,1,446,54a3.58,3.58,0,0,1,2-.71,4.15,4.15,0,0,1,2.13,1,18,18,0,0,1,4.07,3.85c.62.81,1.25,1.63,1.86,2.45.35.45,1.75,1.8,1.75,2.35,0-.11,0-.21,0-.31A30.8,30.8,0,0,0,427,31.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.45,90.74c.15-1.67-.57-3.64-2.94-6.79-1.25-1.65-2.54-3.27-3.85-4.87-1-1.25-2.87-2.73-2.85-4.47a4,4,0,0,1,1.78-2.86,14.84,14.84,0,0,1,2.49-1.67c.72-.39,1.59-.88,1.6-1.7s-.72-1.28-1.37-1.67q-3.72-2.17-7.56-4.14a16.35,16.35,0,0,1-3.51-1.86c-.64-.58-1-1.41-1.73-2a18.82,18.82,0,0,0-.28,3.9A30.81,30.81,0,0,0,414.45,90.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.63,72.3a12.75,12.75,0,0,1-1.21.75c-.92.5-2,1-2.22,2-.31,1.36,1.05,2.47,2.24,3.2l3.72,2.27a7.17,7.17,0,0,1,1.68,1.26,6.71,6.71,0,0,1,1.1,1.93,47.2,47.2,0,0,1,1.91,5.55c.19.69.58,3.78,1.64,3.9a29.52,29.52,0,0,0,3.54.21,31.94,31.94,0,0,0,3.81-.24c-.62,0-2-3.72-2.25-4.28a51.32,51.32,0,0,1-2.27-7.52c-.47-2.51-3.59-3.76-5.56-5.14a1.65,1.65,0,0,1-.69-.72,1.5,1.5,0,0,1,.17-1.18,35.93,35.93,0,0,1,2.08-3.26,5,5,0,0,0,.86-3.67,6.3,6.3,0,0,0-2.05-2.89c-6.58-6.3-13.53-12.35-19.76-18.94A30.38,30.38,0,0,0,398.13,52c-.23.6,3.37,3.5,3.84,3.87,2.11,1.68,4.49,3.06,6.61,4.78l5.92,4.79A5.58,5.58,0,0,1,416.62,68a3.58,3.58,0,0,1-.69,3.06A6,6,0,0,1,414.63,72.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.48,67.25C455.21,78.63,434.67,89.08,418.21,82c-17.5-7.49-20.79-31.16-12.23-41.88v0a30.8,30.8,0,1,0,51.5,27.12Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.48,
    cy: 48.17,
    r: 12.98,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.78,
    cy: 62.11,
    r: 5.94,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,62.62a30.8,30.8,0,0,0,57,16.2c-.7,1.08-9.41,14.79-30.94,10.84-22.42-4.1-26.06-27-25.69-31.87A32.12,32.12,0,0,0,396.23,62.62Z",
    style: {
      opacity: 0.05
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-1--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7,91.42a23.35,23.35,0,1,1,30.35-13A23.34,23.34,0,0,1,70.7,91.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7,91.42a23.35,23.35,0,1,1,30.35-13A23.34,23.34,0,0,1,70.7,91.42Z",
    style: {
      fill: "#fff",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.78,
    cy: 68.62,
    r: 20.68,
    transform: "translate(-14.68 115.62) rotate(-68.37)",
    style: {
      fill: "#fff",
      opacity: 0.11666699999999999
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.17,
    cy: 67.49,
    r: 18.01,
    transform: "translate(-16.42 109.72) rotate(-66.06)",
    style: {
      fill: "#fff",
      opacity: 0.23333299999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.86,80.6A15.34,15.34,0,1,1,88.8,72.06,15.35,15.35,0,0,1,68.86,80.6Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24,77a12.67,12.67,0,1,1,16.48-7A12.69,12.69,0,0,1,68.24,77Z",
    style: {
      fill: "#fff",
      opacity: 0.466667
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.35,
    cy: 64.09,
    r: 10,
    transform: "translate(-10.93 14.81) rotate(-11.01)",
    style: {
      fill: "#fff",
      opacity: 0.583333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,69.77a7.33,7.33,0,1,1,9.54-4.08A7.33,7.33,0,0,1,67,69.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.05,78.43a23.33,23.33,0,0,1-30.35,13c-.38-.15-.74-.31-1.11-.48A23.35,23.35,0,0,0,79.53,46.4a23.36,23.36,0,0,1,21.52,32Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46,53.3A21.69,21.69,0,0,1,76.93,91.17a23,23,0,0,0,11.74-40,22.63,22.63,0,0,0-3-2.23A21.42,21.42,0,0,1,93.46,53.3Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.87,85.19a7.33,7.33,0,1,1,9.53-4.08A7.33,7.33,0,0,1,66.87,85.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,64.25A7.33,7.33,0,1,1,80,60.17,7.32,7.32,0,0,1,70.44,64.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.43,69.3a3.61,3.61,0,1,1,4.69-2A3.6,3.6,0,0,1,60.43,69.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126,47.39c-.77-1.36-2.74-3.64-7.26-3.64-4.7,0-12.4,2.38-22.89,7.08l-1.27.57-.49.21.48.4.23-.1,1.28-.58c10.42-4.66,18-7,22.66-7,4.24,0,6.07,2.1,6.77,3.35,3.13,5.52-2.89,12.89-20.13,24.65-1,.69-2.05,1.39-3.1,2.07-4.6,3-9.56,6-14.79,9s-10.82,5.9-16,8.36c-1.14.54-2.27,1.08-3.38,1.58C57,98.41,48.91,101,44.06,101c-4.24,0-6.06-2.11-6.77-3.36-3-5.33,2.12-12,17.73-23l1.15-.81.2-.15c0-.2-.06-.4-.09-.61l-.44.31-1.14.8C38.79,85.4,33.61,92.27,36.8,97.91c.77,1.36,2.74,3.64,7.26,3.64,4.93,0,13.12-2.59,24.33-7.72,1.27-.58,2.57-1.2,3.9-1.84,5-2.4,10.26-5.17,15.47-8.12,5.06-2.87,9.87-5.79,14.34-8.71,1.22-.8,2.42-1.6,3.59-2.39C123.23,60.81,129.29,53.22,126,47.39Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.42,70.92c-.59.41-1.2.81-1.81,1.22-4.91,3.28-10.27,6.57-16,9.79S74.93,88.3,69.44,90.87l-2,.93C60,95.23,49.8,99.32,44.06,99.32c-3.22,0-4.67-1.36-5.32-2.51C36.32,92.54,41.64,86.13,56,76l.76-.54c0,.19.1.38.16.57l-.6.42C42.25,86.38,37,92.57,39.23,96.54c.58,1,1.88,2.22,4.83,2.22,5.64,0,15.71-4.06,23.16-7.47l1.58-.73c5.58-2.62,11.63-5.75,17.58-9.11s11.29-6.67,16.29-10h0c.49-.32,1-.65,1.44-1,20.52-14,20.93-19.08,19.45-21.7-.58-1-1.88-2.22-4.83-2.22-5.36,0-14.79,3.72-21.75,6.83l-.66.31-.42-.43.85-.38c7-3.14,16.52-6.89,22-6.89,3.22,0,4.67,1.37,5.32,2.51C125.63,51.3,125.33,56.67,104.42,70.92Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.48,69.54l-.75.51c-5.16,3.48-10.84,7-16.91,10.42S73.34,87.23,67.57,89.9l-.81.37C56.37,95,48.3,97.64,44.06,97.64c-1.94,0-3.24-.56-3.86-1.66C38.35,92.72,43.83,86.64,57,77.4l.31-.21c.06.18.12.36.19.54h0l-.18.12C41.5,89,39.55,93.69,40.69,95.71c.51.91,1.65,1.37,3.37,1.37,4.17,0,12.14-2.59,22.46-7.32l.48-.21c5.84-2.7,12.25-6,18.55-9.57s12-7.06,17.18-10.61l.44-.3c13.94-9.5,20.66-16.42,18.93-19.48-.51-.91-1.65-1.37-3.37-1.37-4,0-11.43,2.37-21.07,6.69l-.19.08c-.12-.15-.24-.3-.37-.44l.34-.15c9.7-4.35,17.26-6.74,21.29-6.74,1.94,0,3.24.56,3.86,1.66C124.54,52.76,118.11,59.57,103.48,69.54Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.33,56.46l-.11.31c-.23.6-1.3,2.44-6.43,6.43l-.28.21A162.1,162.1,0,0,1,83,75.44a158.06,158.06,0,0,1-20.48,10l-.33.13c-3.45,1.29-6.15,2-7.63,2a2.9,2.9,0,0,1-.56-.05l-.32-.07.11-.3C54,86.58,54.9,85,59.2,81.47c.09.17.18.33.28.49-3.46,2.81-4.63,4.33-5,5h.08a25.12,25.12,0,0,0,7.23-1.9l.53-.2A159.43,159.43,0,0,0,82.7,75a161.52,161.52,0,0,0,18.47-12l.44-.34c4.16-3.25,5.5-5,5.92-5.72h-.08a26,26,0,0,0-7.41,2l-.27-.5a26.49,26.49,0,0,1,7.68-2,3,3,0,0,1,.56,0Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.73,69.37c0,.22,0,.45,0,.68,0,.46,0,.91-.06,1.38h0c0,.24,0,.47-.06.71a21.25,21.25,0,0,1-.34,2.24c0,.26-.11.52-.17.78a21.81,21.81,0,0,1-1,3.27A23.32,23.32,0,0,1,72.29,92l-.76-.25c-.28-.1-.55-.2-.83-.32-.43-.17-.85-.35-1.26-.55l-.64-.31q-.63-.32-1.23-.66L67,89.55a23.21,23.21,0,0,1-4.83-4l-.4-.45.53-.2A159.43,159.43,0,0,0,82.7,75a161.52,161.52,0,0,0,18.47-12l.44-.34q.11.28.18.57A22.82,22.82,0,0,1,102.73,69.37Z",
    style: {
      fill: "#fff",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,50c1.46,2.58-6.23,9.89-18.68,18.37-5.14,3.51-11.1,7.22-17.55,10.87C78.45,83,72,86.34,66.18,89c-13.38,6.12-23.32,8.84-24.76,6.3s5.28-9,16.34-16.76a21.78,21.78,0,0,0,1,2.19c-4.18,3.37-6.43,6-5.8,7.08s4.36.46,9.82-1.62a160.56,160.56,0,0,0,20.59-10A162.88,162.88,0,0,0,102,64.08c4.93-3.81,7.67-6.8,7-8s-4.3-.47-9.68,1.57a23.44,23.44,0,0,0-1.33-2C110.68,50,120,47.55,121.37,50Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,50c1.46,2.58-6.23,9.89-18.68,18.37-5.14,3.51-11.1,7.22-17.55,10.87C78.45,83,72,86.34,66.18,89c-13.38,6.12-23.32,8.84-24.76,6.3s5.28-9,16.34-16.76a21.78,21.78,0,0,0,1,2.19c-4.18,3.37-6.43,6-5.8,7.08s4.36.46,9.82-1.62a160.56,160.56,0,0,0,20.59-10A162.88,162.88,0,0,0,102,64.08c4.93-3.81,7.67-6.8,7-8s-4.3-.47-9.68,1.57a23.44,23.44,0,0,0-1.33-2C110.68,50,120,47.55,121.37,50Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Star--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.84,181.62a6.75,6.75,0,1,1,6.75-6.75A6.75,6.75,0,0,1,436.84,181.62Zm0-13.15a6.4,6.4,0,1,0,6.41,6.4A6.41,6.41,0,0,0,436.84,168.47Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.77,174.87a1.93,1.93,0,1,1-1.93-1.93A1.92,1.92,0,0,1,438.77,174.87Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--star--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.17,51.51a9.9,9.9,0,1,1,9.89-9.9A9.91,9.91,0,0,1,182.17,51.51Zm0-19.29a9.39,9.39,0,1,0,9.39,9.39A9.4,9.4,0,0,0,182.17,32.22Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185,41.61a2.83,2.83,0,1,1-2.83-2.83A2.83,2.83,0,0,1,185,41.61Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--star--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.26,174.89a6.64,6.64,0,1,1,6.64-6.64A6.65,6.65,0,0,1,71.26,174.89Zm0-12.94a6.3,6.3,0,1,0,6.3,6.3A6.31,6.31,0,0,0,71.26,162Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.16,168.25a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,73.16,168.25Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--star--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.52,92.81a6.64,6.64,0,1,1,6.64-6.64A6.65,6.65,0,0,1,341.52,92.81Zm0-12.94a6.3,6.3,0,1,0,6.3,6.3A6.31,6.31,0,0,0,341.52,79.87Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.42,86.17a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,343.42,86.17Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.46,128.3a1.08,1.08,0,1,1-1.53,0A1.09,1.09,0,0,1,43.46,128.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,133a1.76,1.76,0,1,1-2.49,0A1.77,1.77,0,0,1,53.44,133Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,42.46a1.08,1.08,0,1,1-.6,1.41A1.09,1.09,0,0,1,346.55,42.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.94,35.28a1.77,1.77,0,1,1-1,2.3A1.78,1.78,0,0,1,354.94,35.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,132a1.76,1.76,0,1,1-1.76-1.76A1.76,1.76,0,0,1,405.63,132Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.36,136.84a1.05,1.05,0,1,1-1.05-1.05A1,1,0,0,1,400.36,136.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,130.26a.85.85,0,1,1-.85-.85A.85.85,0,0,1,397.38,130.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,80.33a1.33,1.33,0,1,1-1.82.48A1.32,1.32,0,0,1,141,80.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.29,75.94a.78.78,0,0,1-.78,1.34.78.78,0,1,1,.78-1.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.68,208.17a1.33,1.33,0,0,1-1.33,2.3,1.33,1.33,0,1,1,1.33-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,203.78a.78.78,0,1,1-1.06.28A.77.77,0,0,1,409,203.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.05,43.09l-2.5.87-.71,2.55a.3.3,0,0,1-.53.1l-1.6-2.11-2.65.12a.31.31,0,0,1-.26-.48L282.32,42l-.93-2.48a.3.3,0,0,1,.37-.4l2.53.77,2.08-1.65a.3.3,0,0,1,.49.23l.05,2.65,2.21,1.46A.3.3,0,0,1,289.05,43.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.73,111.67l-2.5.87-.71,2.55a.3.3,0,0,1-.53.1l-1.6-2.11-2.65.12a.3.3,0,0,1-.26-.47l1.52-2.18-.93-2.48a.31.31,0,0,1,.37-.4l2.53.77,2.07-1.65a.3.3,0,0,1,.49.23l.06,2.65,2.21,1.46A.3.3,0,0,1,187.73,111.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,148.05l-1.47.51-.41,1.5a.18.18,0,0,1-.32.06l-.93-1.24-1.56.07a.18.18,0,0,1-.15-.28l.89-1.27-.55-1.46a.18.18,0,0,1,.22-.23l1.49.45,1.21-1a.18.18,0,0,1,.29.14l0,1.55,1.3.86A.17.17,0,0,1,309.3,148.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.23,219.21l-4,1.4-1.14,4.12a.49.49,0,0,1-.86.16l-2.57-3.4-4.26.19a.49.49,0,0,1-.42-.77l2.44-3.5-1.5-4a.49.49,0,0,1,.59-.64L57.57,214l3.33-2.66a.49.49,0,0,1,.79.37l.09,4.27,3.56,2.35A.48.48,0,0,1,65.23,219.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Comets--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--comets--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,237.57a2.38,2.38,0,0,1,3.37,0,2.39,2.39,0,1,1-3.37,0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.49,238.05a2.37,2.37,0,1,1,1.68,4,2.4,2.4,0,0,1-1.68-.7,2.37,2.37,0,0,1,0-3.34Z",
    style: {
      fill: "#092166",
      opacity: 0.9901979999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,238.52a2.35,2.35,0,0,1,3.32,3.32,2.35,2.35,0,1,1-3.32-3.32Z",
    style: {
      fill: "#092166",
      opacity: 0.9803959999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.45,239a2.32,2.32,0,1,1,3.28,3.28,2.32,2.32,0,1,1-3.28-3.28Z",
    style: {
      fill: "#092166",
      opacity: 0.970594
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.92,239.48a2.29,2.29,0,0,1,3.26,0,2.3,2.3,0,0,1-3.26,3.25,2.31,2.31,0,0,1,0-3.25Z",
    style: {
      fill: "#092166",
      opacity: 0.960792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.4,240a2.3,2.3,0,0,1,1.61-.66,2.28,2.28,0,1,1,0,4.55A2.28,2.28,0,0,1,422.4,240Z",
    style: {
      fill: "#092166",
      opacity: 0.9509900000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.88,240.43a2.26,2.26,0,1,1-.66,1.6A2.25,2.25,0,0,1,422.88,240.43Z",
    style: {
      fill: "#092166",
      opacity: 0.9411879999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.35,240.91a2.23,2.23,0,0,1,1.58-.66,2.25,2.25,0,0,1,2.24,2.24,2.24,2.24,0,0,1-2.24,2.23,2.22,2.22,0,0,1-2.23-2.23A2.22,2.22,0,0,1,423.35,240.91Z",
    style: {
      fill: "#092166",
      opacity: 0.9313859999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.83,241.38a2.21,2.21,0,1,1-.65,1.57A2.22,2.22,0,0,1,423.83,241.38Z",
    style: {
      fill: "#092166",
      opacity: 0.921584
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.31,241.86a2.2,2.2,0,0,1,3.1,0,2.2,2.2,0,0,1,0,3.1,2.19,2.19,0,1,1-3.1-3.1Z",
    style: {
      fill: "#092166",
      opacity: 0.911782
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.78,242.34a2.16,2.16,0,0,1,1.54-.64,2.17,2.17,0,0,1,0,4.34,2.17,2.17,0,0,1-1.54-3.7Z",
    style: {
      fill: "#092166",
      opacity: 0.9019800000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.26,242.81a2.15,2.15,0,1,1-.63,1.52A2.14,2.14,0,0,1,425.26,242.81Z",
    style: {
      fill: "#092166",
      opacity: 0.8921779999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.74,243.29a2.13,2.13,0,0,1,3.63,1.5,2.13,2.13,0,0,1-4.26,0A2.1,2.1,0,0,1,425.74,243.29Z",
    style: {
      fill: "#092166",
      opacity: 0.8823759999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.21,243.77a2.11,2.11,0,0,1,3.6,1.48,2.11,2.11,0,1,1-4.21,0A2.07,2.07,0,0,1,426.21,243.77Z",
    style: {
      fill: "#092166",
      opacity: 0.872574
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.69,244.24a2.09,2.09,0,1,1,0,2.95,2.09,2.09,0,0,1,0-2.95Z",
    style: {
      fill: "#092166",
      opacity: 0.862772
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.17,244.72a2.06,2.06,0,0,1,2.91,2.91,2.06,2.06,0,1,1-2.91-2.91Z",
    style: {
      fill: "#092166",
      opacity: 0.8529700000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,245.19a2,2,0,0,1,2.89,2.89,2,2,0,0,1-2.89-2.89Z",
    style: {
      fill: "#092166",
      opacity: 0.8431679999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.12,245.67a2,2,0,0,1,2.85,0,2,2,0,0,1,.59,1.43,2,2,0,0,1-.59,1.42,2,2,0,0,1-3.44-1.42A2,2,0,0,1,428.12,245.67Z",
    style: {
      fill: "#092166",
      opacity: 0.8333659999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6,246.15a2,2,0,1,1-.59,1.41A2,2,0,0,1,428.6,246.15Z",
    style: {
      fill: "#092166",
      opacity: 0.823564
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.07,246.62a2,2,0,0,1,1.4-.57,2,2,0,1,1,0,3.94,2,2,0,0,1-1.4-3.37Z",
    style: {
      fill: "#092166",
      opacity: 0.813762
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.55,247.1a2,2,0,1,1-.57,1.38A1.95,1.95,0,0,1,429.55,247.1Z",
    style: {
      fill: "#092166",
      opacity: 0.8039600000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,247.58a1.9,1.9,0,0,1,1.36-.57,1.93,1.93,0,0,1,1.93,1.93,1.91,1.91,0,0,1-1.93,1.93,1.93,1.93,0,0,1-1.93-1.93A1.9,1.9,0,0,1,430,247.58Z",
    style: {
      fill: "#092166",
      opacity: 0.7941579999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.5,248.05a1.93,1.93,0,0,1,2.7,0,1.91,1.91,0,0,1,0,2.7,1.91,1.91,0,0,1-2.7,0,1.91,1.91,0,0,1,0-2.7Z",
    style: {
      fill: "#092166",
      opacity: 0.7843559999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,248.53a1.9,1.9,0,1,1-.55,1.34A1.87,1.87,0,0,1,431,248.53Z",
    style: {
      fill: "#092166",
      opacity: 0.774554
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.46,249a1.87,1.87,0,0,1,3.18,1.32,1.87,1.87,0,0,1-3.73,0A1.83,1.83,0,0,1,431.46,249Z",
    style: {
      fill: "#092166",
      opacity: 0.764752
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.93,249.48a1.85,1.85,0,1,1-.54,1.31A1.84,1.84,0,0,1,431.93,249.48Z",
    style: {
      fill: "#092166",
      opacity: 0.75495
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.41,250a1.81,1.81,0,1,1-.54,1.29A1.82,1.82,0,0,1,432.41,250Z",
    style: {
      fill: "#092166",
      opacity: 0.745149
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.88,250.44a1.84,1.84,0,0,1,1.28-.53,1.8,1.8,0,0,1,0,3.6,1.84,1.84,0,0,1-1.28-.53,1.81,1.81,0,0,1,0-2.54Z",
    style: {
      fill: "#092166",
      opacity: 0.735347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.36,250.91a1.78,1.78,0,1,1,0,2.52,1.79,1.79,0,0,1,0-2.52Z",
    style: {
      fill: "#092166",
      opacity: 0.725545
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84,251.39a1.75,1.75,0,1,1,2.48,2.48,1.74,1.74,0,0,1-2.48,0,1.74,1.74,0,0,1,0-2.48Z",
    style: {
      fill: "#092166",
      opacity: 0.715743
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.31,251.87a1.74,1.74,0,0,1,2.46,0,1.7,1.7,0,0,1,.51,1.22,1.74,1.74,0,0,1-3,1.23,1.76,1.76,0,0,1-.5-1.23A1.73,1.73,0,0,1,434.31,251.87Z",
    style: {
      fill: "#092166",
      opacity: 0.7059409999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,252.34a1.72,1.72,0,1,1,0,2.43,1.75,1.75,0,0,1-.5-1.22A1.73,1.73,0,0,1,434.79,252.34Z",
    style: {
      fill: "#092166",
      opacity: 0.696139
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.27,252.82a1.68,1.68,0,1,1-.5,1.2A1.68,1.68,0,0,1,435.27,252.82Z",
    style: {
      fill: "#092166",
      opacity: 0.686337
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,253.3a1.67,1.67,0,0,1,1.18-.49,1.67,1.67,0,0,1,1.67,1.67,1.65,1.65,0,0,1-.49,1.18,1.67,1.67,0,0,1-1.18.49,1.71,1.71,0,0,1-1.18-.49,1.68,1.68,0,0,1-.48-1.18A1.66,1.66,0,0,1,435.74,253.3Z",
    style: {
      fill: "#092166",
      opacity: 0.676535
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,253.77a1.65,1.65,0,0,1,2.33,0,1.66,1.66,0,0,1,.48,1.17,1.65,1.65,0,0,1-3.29,0A1.66,1.66,0,0,1,436.22,253.77Z",
    style: {
      fill: "#092166",
      opacity: 0.666733
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7,254.25a1.6,1.6,0,0,1,1.15-.48,1.63,1.63,0,0,1,0,3.26,1.6,1.6,0,0,1-1.15-.48,1.62,1.62,0,0,1,0-2.3Z",
    style: {
      fill: "#092166",
      opacity: 0.6569309999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.17,254.73a1.6,1.6,0,0,1,1.14-.47,1.56,1.56,0,0,1,1.13.47,1.59,1.59,0,0,1,0,2.26,1.56,1.56,0,0,1-1.13.47,1.6,1.6,0,0,1-1.14-2.73Z",
    style: {
      fill: "#092166",
      opacity: 0.647129
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.65,255.2a1.59,1.59,0,0,1,2.24,0,1.58,1.58,0,0,1,.46,1.12,1.58,1.58,0,1,1-3.16,0A1.58,1.58,0,0,1,437.65,255.2Z",
    style: {
      fill: "#092166",
      opacity: 0.637327
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.13,255.68a1.55,1.55,0,0,1,2.2,0,1.52,1.52,0,0,1,.46,1.1,1.56,1.56,0,1,1-3.12,0A1.52,1.52,0,0,1,438.13,255.68Z",
    style: {
      fill: "#092166",
      opacity: 0.627525
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.6,256.16a1.56,1.56,0,0,1,1.09-.46,1.54,1.54,0,0,1,1.09.46,1.54,1.54,0,0,1-1.09,2.62,1.55,1.55,0,0,1-1.09-.45,1.53,1.53,0,0,1,0-2.17Z",
    style: {
      fill: "#092166",
      opacity: 0.617723
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,256.63a1.53,1.53,0,0,1,1.07-.44,1.52,1.52,0,1,1,0,3,1.53,1.53,0,0,1-1.07-.44,1.53,1.53,0,0,1,0-2.15Z",
    style: {
      fill: "#092166",
      opacity: 0.6079209999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.56,257.11a1.48,1.48,0,1,1-.44,1.06A1.49,1.49,0,0,1,439.56,257.11Z",
    style: {
      fill: "#092166",
      opacity: 0.598119
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,257.59a1.47,1.47,0,1,1,2.09,2.08,1.48,1.48,0,0,1-2.09,0,1.49,1.49,0,0,1-.43-1A1.48,1.48,0,0,1,440,257.59Z",
    style: {
      fill: "#092166",
      opacity: 0.588317
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.51,258.06a1.45,1.45,0,1,1,0,2.06,1.49,1.49,0,0,1-.43-1A1.47,1.47,0,0,1,440.51,258.06Z",
    style: {
      fill: "#092166",
      opacity: 0.578515
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,258.54a1.4,1.4,0,0,1,1-.42,1.43,1.43,0,0,1,0,2.86,1.4,1.4,0,0,1-1-.42,1.42,1.42,0,0,1,0-2Z",
    style: {
      fill: "#092166",
      opacity: 0.568713
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.46,259a1.44,1.44,0,0,1,1-.41,1.41,1.41,0,0,1,0,2.82,1.41,1.41,0,0,1-1-2.41Z",
    style: {
      fill: "#092166",
      opacity: 0.5589109999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.94,259.49a1.4,1.4,0,0,1,2,0,1.4,1.4,0,0,1,.41,1,1.39,1.39,0,0,1-2.78,0A1.4,1.4,0,0,1,441.94,259.49Z",
    style: {
      fill: "#092166",
      opacity: 0.549109
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.42,260a1.32,1.32,0,0,1,1-.4,1.37,1.37,0,0,1,1.37,1.36,1.37,1.37,0,0,1-1.37,1.37,1.37,1.37,0,0,1-1.36-1.37A1.32,1.32,0,0,1,442.42,260Z",
    style: {
      fill: "#092166",
      opacity: 0.539307
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.89,260.44a1.35,1.35,0,0,1,.95-.39,1.33,1.33,0,0,1,1,.39,1.38,1.38,0,0,1,.4.95,1.37,1.37,0,0,1-1.35,1.35,1.36,1.36,0,0,1-.95-.4,1.33,1.33,0,0,1-.39-.95A1.37,1.37,0,0,1,442.89,260.44Z",
    style: {
      fill: "#092166",
      opacity: 0.529505
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.37,260.92a1.3,1.3,0,0,1,.93-.39,1.33,1.33,0,0,1,.94.39,1.36,1.36,0,0,1,.38.94,1.31,1.31,0,0,1-1.32,1.32,1.33,1.33,0,0,1-1.32-1.32A1.33,1.33,0,0,1,443.37,260.92Z",
    style: {
      fill: "#092166",
      opacity: 0.519703
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.85,261.4a1.29,1.29,0,0,1,1.83,0,1.25,1.25,0,0,1,.38.92,1.3,1.3,0,0,1-2.6,0A1.26,1.26,0,0,1,443.85,261.4Z",
    style: {
      fill: "#092166",
      opacity: 0.5099009999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.32,261.87a1.29,1.29,0,0,1,1.81,0,1.28,1.28,0,0,1,.37.91,1.26,1.26,0,0,1-.37.9,1.27,1.27,0,0,1-1.81,0,1.26,1.26,0,0,1-.37-.9A1.28,1.28,0,0,1,444.32,261.87Z",
    style: {
      fill: "#092166",
      opacity: 0.500099
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.8,262.35a1.24,1.24,0,0,1,1.77,0,1.23,1.23,0,0,1,.37.89,1.26,1.26,0,1,1-2.51,0A1.23,1.23,0,0,1,444.8,262.35Z",
    style: {
      fill: "#092166",
      opacity: 0.490297
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.28,262.83a1.2,1.2,0,0,1,.87-.36,1.23,1.23,0,1,1,0,2.46,1.2,1.2,0,0,1-.87-.36,1.21,1.21,0,0,1,0-1.74Z",
    style: {
      fill: "#092166",
      opacity: 0.480495
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75,263.3a1.23,1.23,0,1,1-.35.86A1.24,1.24,0,0,1,445.75,263.3Z",
    style: {
      fill: "#092166",
      opacity: 0.470693
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.23,263.78a1.18,1.18,0,0,1,1.68,0,1.2,1.2,0,0,1,.35.84,1.18,1.18,0,0,1-.35.84,1.18,1.18,0,0,1-1.68,0,1.18,1.18,0,0,1-.35-.84A1.2,1.2,0,0,1,446.23,263.78Z",
    style: {
      fill: "#092166",
      opacity: 0.460891
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.7,264.26a1.17,1.17,0,0,1,2,.82,1.19,1.19,0,0,1-.34.83,1.18,1.18,0,0,1-1.66,0,1.19,1.19,0,0,1-.34-.83A1.17,1.17,0,0,1,446.7,264.26Z",
    style: {
      fill: "#092166",
      opacity: 0.45108899999999996
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.18,264.73a1.15,1.15,0,0,1,.81-.33,1.15,1.15,0,1,1,0,2.29,1.15,1.15,0,0,1-.81-.33,1.17,1.17,0,0,1,0-1.63Z",
    style: {
      fill: "#092166",
      opacity: 0.441287
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.66,265.21a1.11,1.11,0,0,1,.79-.33,1.13,1.13,0,0,1,1.13,1.13,1.11,1.11,0,0,1-.33.79,1.13,1.13,0,0,1-.8.33,1.13,1.13,0,0,1-1.12-1.12A1.13,1.13,0,0,1,447.66,265.21Z",
    style: {
      fill: "#092166",
      opacity: 0.431485
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.13,265.69a1.11,1.11,0,0,1,1.89.78,1.11,1.11,0,1,1-2.21,0A1.1,1.1,0,0,1,448.13,265.69Z",
    style: {
      fill: "#092166",
      opacity: 0.421683
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.61,266.16a1.08,1.08,0,0,1,.77-.31,1.06,1.06,0,0,1,.76.31,1.09,1.09,0,0,1,.32.77,1.09,1.09,0,0,1-1.08,1.08,1.09,1.09,0,0,1-.77-.32,1.07,1.07,0,0,1-.32-.76A1.09,1.09,0,0,1,448.61,266.16Z",
    style: {
      fill: "#092166",
      opacity: 0.411881
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,266.64a1,1,0,0,1,.75-.31,1.05,1.05,0,0,1,.75.31,1.06,1.06,0,0,1-.75,1.81,1.06,1.06,0,0,1-.75-1.81Z",
    style: {
      fill: "#092166",
      opacity: 0.40207899999999996
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.56,267.12a1.07,1.07,0,0,1,.74-.31,1.06,1.06,0,0,1,1,1,1.07,1.07,0,0,1-.31.74,1,1,0,0,1-.73.3,1,1,0,0,1-1-1A1,1,0,0,1,449.56,267.12Z",
    style: {
      fill: "#092166",
      opacity: 0.392277
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,267.59a1,1,0,0,1,1.44,0,1,1,0,1,1-1.44,0Z",
    style: {
      fill: "#092166",
      opacity: 0.382475
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.52,268.07a1,1,0,0,1,1.4,0,1,1,0,0,1,.3.7,1,1,0,0,1-1.7.71,1,1,0,0,1-.29-.71A1,1,0,0,1,450.52,268.07Z",
    style: {
      fill: "#092166",
      opacity: 0.372673
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,268.55a1,1,0,0,1,1.38,0,.94.94,0,0,1,.29.68,1,1,0,0,1-.29.69,1,1,0,0,1-1.38,0,1,1,0,0,1-.28-.69A1,1,0,0,1,451,268.55Z",
    style: {
      fill: "#092166",
      opacity: 0.362871
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.47,269a1,1,0,0,1,.67-.28,1,1,0,0,1,.68.28,1,1,0,0,1,0,1.35,1,1,0,0,1-.68.28,1,1,0,0,1-.67-.28,1,1,0,0,1,0-1.35Z",
    style: {
      fill: "#092166",
      opacity: 0.35306899999999997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,269.5a.91.91,0,0,1,.65-.27.92.92,0,0,1,.93.93.91.91,0,0,1-.27.65.94.94,0,0,1-.66.28,1,1,0,0,1-.93-.93A.94.94,0,0,1,452,269.5Z",
    style: {
      fill: "#092166",
      opacity: 0.343267
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.42,270a.91.91,0,0,1,1.55.64.93.93,0,0,1-.26.64.91.91,0,0,1-1.29,0,.93.93,0,0,1-.26-.64A.9.9,0,0,1,452.42,270Z",
    style: {
      fill: "#092166",
      opacity: 0.333465
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.9,270.45a.89.89,0,0,1,.63-.26.87.87,0,0,1,.62.26.89.89,0,0,1,.26.63.91.91,0,0,1-.26.63.87.87,0,0,1-.62.26.89.89,0,0,1-.63-.26.91.91,0,0,1-.26-.63A.89.89,0,0,1,452.9,270.45Z",
    style: {
      fill: "#092166",
      opacity: 0.323663
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.38,270.93a.82.82,0,0,1,.61-.25.86.86,0,1,1,0,1.72.82.82,0,0,1-.61-.25.85.85,0,0,1,0-1.22Z",
    style: {
      fill: "#092166",
      opacity: 0.313861
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.85,271.41a.83.83,0,0,1,.6-.25.85.85,0,0,1,.84.84.83.83,0,0,1-.25.6.82.82,0,0,1-.59.24.82.82,0,0,1-.84-.84A.82.82,0,0,1,453.85,271.41Z",
    style: {
      fill: "#092166",
      opacity: 0.30405899999999997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.33,271.88a.82.82,0,0,1,1.4.58.8.8,0,0,1-.24.58.82.82,0,0,1-1.16,0,.8.8,0,0,1-.24-.58A.82.82,0,0,1,454.33,271.88Z",
    style: {
      fill: "#092166",
      opacity: 0.294257
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.81,272.36a.76.76,0,0,1,.56-.24.8.8,0,0,1,.57.24.8.8,0,0,1,.23.56.79.79,0,0,1-.8.8.79.79,0,0,1-.56-.23.8.8,0,0,1-.24-.57A.77.77,0,0,1,454.81,272.36Z",
    style: {
      fill: "#092166",
      opacity: 0.284455
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28,272.83a.8.8,0,0,1,1.1,0,.78.78,0,0,1,.23.55.76.76,0,0,1-.23.55.77.77,0,0,1-1.1,0,.76.76,0,0,1-.23-.55A.78.78,0,0,1,455.28,272.83Z",
    style: {
      fill: "#092166",
      opacity: 0.274653
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.76,273.31a.77.77,0,0,1,.53-.22.76.76,0,0,1,.54,1.29.75.75,0,0,1-.54.22.73.73,0,0,1-.53-.22.76.76,0,0,1,0-1.07Z",
    style: {
      fill: "#092166",
      opacity: 0.264851
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.24,273.79a.71.71,0,0,1,1,0,.7.7,0,0,1,.22.52.73.73,0,0,1-.74.73.71.71,0,0,1-.51-.21.72.72,0,0,1-.22-.52A.7.7,0,0,1,456.24,273.79Z",
    style: {
      fill: "#092166",
      opacity: 0.25505
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.71,274.26a.74.74,0,0,1,1,0,.71.71,0,1,1-1,1,.71.71,0,0,1,0-1Z",
    style: {
      fill: "#092166",
      opacity: 0.245248
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.19,274.74a.7.7,0,0,1,.49-.2.71.71,0,0,1,.49.2.7.7,0,0,1,.2.49.68.68,0,0,1-.69.69.7.7,0,0,1-.49-.2.71.71,0,0,1-.2-.49A.7.7,0,0,1,457.19,274.74Z",
    style: {
      fill: "#092166",
      opacity: 0.235446
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.67,275.22a.63.63,0,0,1,.47-.2.67.67,0,0,1,0,1.34.63.63,0,0,1-.47-.2.65.65,0,0,1,0-.94Z",
    style: {
      fill: "#092166",
      opacity: 0.22564399999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.14,275.69a.65.65,0,1,1-.19.46A.68.68,0,0,1,458.14,275.69Z",
    style: {
      fill: "#092166",
      opacity: 0.21584199999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.62,276.17a.63.63,0,0,1,.88,0,.62.62,0,0,1,0,.89.63.63,0,0,1-.88,0,.63.63,0,0,1-.18-.45A.62.62,0,0,1,458.62,276.17Z",
    style: {
      fill: "#092166",
      opacity: 0.20604000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.1,276.65a.56.56,0,0,1,.42-.18.6.6,0,0,1,.43.18.59.59,0,0,1,0,.85.6.6,0,0,1-.43.18.56.56,0,0,1-.42-.18.58.58,0,0,1-.18-.43A.58.58,0,0,1,459.1,276.65Z",
    style: {
      fill: "#092166",
      opacity: 0.196238
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.57,277.12A.58.58,0,0,1,460,277a.58.58,0,0,1,.58.59.54.54,0,0,1-.17.41.57.57,0,0,1-.41.17.58.58,0,0,1-.58-.58A.61.61,0,0,1,459.57,277.12Z",
    style: {
      fill: "#092166",
      opacity: 0.186436
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.05,277.6a.54.54,0,0,1,.39-.16.55.55,0,0,1,.56.56.53.53,0,0,1-.16.39.54.54,0,0,1-.79,0,.54.54,0,0,1-.17-.39A.56.56,0,0,1,460.05,277.6Z",
    style: {
      fill: "#092166",
      opacity: 0.17663399999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.52,278.08a.53.53,0,0,1,.39-.16.52.52,0,0,1,.38.16.56.56,0,0,1,0,.76.54.54,0,0,1-.77,0,.56.56,0,0,1,0-.76Z",
    style: {
      fill: "#092166",
      opacity: 0.16683199999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,278.55a.51.51,0,0,1,.37-.15.51.51,0,0,1,.36.15.51.51,0,0,1,.15.37.49.49,0,0,1-.15.36.5.5,0,0,1-.73,0,.49.49,0,0,1-.15-.36A.51.51,0,0,1,461,278.55Z",
    style: {
      fill: "#092166",
      opacity: 0.15703
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.48,279a.5.5,0,0,1,.35-.14.52.52,0,0,1,.35.14.51.51,0,0,1,0,.7.52.52,0,0,1-.35.14.5.5,0,0,1-.35-.14.48.48,0,0,1,0-.7Z",
    style: {
      fill: "#092166",
      opacity: 0.147228
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,279.51a.48.48,0,0,1,.34-.14.48.48,0,0,1,.47.47.48.48,0,0,1-.14.34.46.46,0,0,1-.33.13.45.45,0,0,1-.47-.47A.46.46,0,0,1,462,279.51Z",
    style: {
      fill: "#092166",
      opacity: 0.137426
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.43,280a.45.45,0,0,1,.77.32.46.46,0,0,1-.13.32.46.46,0,0,1-.64,0,.46.46,0,0,1-.13-.32A.48.48,0,0,1,462.43,280Z",
    style: {
      fill: "#092166",
      opacity: 0.127624
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.91,280.46a.41.41,0,0,1,.6,0,.39.39,0,0,1,.13.3.4.4,0,0,1-.13.31.44.44,0,0,1-.6,0,.44.44,0,0,1-.13-.31A.43.43,0,0,1,462.91,280.46Z",
    style: {
      fill: "#092166",
      opacity: 0.117822
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.38,280.94a.41.41,0,0,1,.58,0,.38.38,0,0,1,.12.28.38.38,0,0,1-.12.29.41.41,0,0,1-.58,0,.43.43,0,0,1-.12-.29A.42.42,0,0,1,463.38,280.94Z",
    style: {
      fill: "#092166",
      opacity: 0.10802
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.86,281.41a.39.39,0,0,1,.27-.11.38.38,0,0,1,.39.39.39.39,0,0,1-.11.27.41.41,0,0,1-.28.11.38.38,0,0,1-.38-.38A.41.41,0,0,1,463.86,281.41Z",
    style: {
      fill: "#092166",
      opacity: 0.098218
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.34,281.89a.36.36,0,0,1,.25-.11.38.38,0,0,1,.37.37.34.34,0,0,1-.11.25.36.36,0,0,1-.26.11.36.36,0,0,1-.25-.11.34.34,0,0,1-.11-.25A.36.36,0,0,1,464.34,281.89Z",
    style: {
      fill: "#092166",
      opacity: 0.088416
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.81,282.37a.33.33,0,0,1,.25-.1.33.33,0,0,1,.24.1.34.34,0,0,1,0,.48.37.37,0,0,1-.24.1.37.37,0,0,1-.25-.1.34.34,0,0,1,0-.48Z",
    style: {
      fill: "#092166",
      opacity: 0.078614
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.29,282.84a.32.32,0,0,1,.23-.09.31.31,0,0,1,.22.09.33.33,0,0,1,.1.23.34.34,0,0,1-.1.23.31.31,0,0,1-.22.09.32.32,0,0,1-.23-.09.33.33,0,0,1-.09-.23A.32.32,0,0,1,465.29,282.84Z",
    style: {
      fill: "#092166",
      opacity: 0.068812
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.77,283.32a.27.27,0,0,1,.21-.09.29.29,0,0,1,.21.09.29.29,0,0,1,0,.42.29.29,0,0,1-.21.09.3.3,0,0,1-.21-.51Z",
    style: {
      fill: "#092166",
      opacity: 0.05901000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24,283.8a.25.25,0,0,1,.2-.09.28.28,0,0,1,.2.09.27.27,0,0,1,.08.19.28.28,0,0,1-.08.2.32.32,0,0,1-.2.08.27.27,0,0,1-.28-.28A.27.27,0,0,1,466.24,283.8Z",
    style: {
      fill: "#092166",
      opacity: 0.049207999999999995
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.72,284.27a.27.27,0,0,1,.36,0,.25.25,0,0,1,.08.18.23.23,0,0,1-.08.18.24.24,0,0,1-.36,0,.23.23,0,0,1-.07-.18A.24.24,0,0,1,466.72,284.27Z",
    style: {
      fill: "#092166",
      opacity: 0.039406
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.2,284.75a.24.24,0,0,1,.16-.07.26.26,0,0,1,.17.07.24.24,0,0,1,.07.16.24.24,0,0,1-.07.17.26.26,0,0,1-.17.07.24.24,0,0,1-.16-.07.21.21,0,0,1-.07-.17A.2.2,0,0,1,467.2,284.75Z",
    style: {
      fill: "#092166",
      opacity: 0.029604
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.67,285.23a.2.2,0,0,1,.3,0,.19.19,0,0,1,.06.15.18.18,0,0,1-.06.14.2.2,0,0,1-.3,0,.18.18,0,0,1-.06-.14A.19.19,0,0,1,467.67,285.23Z",
    style: {
      fill: "#092166",
      opacity: 0.019802
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.47,285.84a.19.19,0,0,1-.05.13.18.18,0,0,1-.14.06.16.16,0,0,1-.13-.06.2.2,0,0,1-.06-.13.22.22,0,0,1,.06-.14.19.19,0,0,1,.13-.05.17.17,0,0,1,.19.19Z",
    style: {
      fill: "#092166",
      opacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.83,238.38a1.24,1.24,0,0,1,1.75,1.76,1.24,1.24,0,0,1-1.75-1.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.64,248a1.33,1.33,0,0,1,.95-.39,1.35,1.35,0,0,1,1.35,1.35,1.32,1.32,0,0,1-.4.95,1.35,1.35,0,0,1-1,.39,1.33,1.33,0,0,1-.95-.39,1.32,1.32,0,0,1-.4-.95A1.34,1.34,0,0,1,419.64,248Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,248.19a1.35,1.35,0,0,1,1-.39,1.34,1.34,0,0,1,0,2.67,1.35,1.35,0,0,1-1-.39,1.34,1.34,0,0,1,0-1.89Z",
    style: {
      fill: "#092166",
      opacity: 0.9901979999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.05,248.39a1.34,1.34,0,0,1,1.87,0,1.33,1.33,0,0,1,0,1.88,1.34,1.34,0,0,1-1.87,0,1.33,1.33,0,0,1,0-1.88Z",
    style: {
      fill: "#092166",
      opacity: 0.9803959999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.25,248.6a1.31,1.31,0,0,1,.93-.38,1.29,1.29,0,0,1,.93.38,1.33,1.33,0,0,1,.38.93,1.31,1.31,0,0,1-2.62,0A1.33,1.33,0,0,1,420.25,248.6Z",
    style: {
      fill: "#092166",
      opacity: 0.970594
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.46,248.81a1.27,1.27,0,0,1,.92-.38,1.3,1.3,0,1,1,0,2.59,1.27,1.27,0,0,1-.92-.38,1.29,1.29,0,0,1,0-1.83Z",
    style: {
      fill: "#092166",
      opacity: 0.960792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.67,249a1.28,1.28,0,0,1,.91-.37,1.29,1.29,0,0,1,.91.37,1.3,1.3,0,0,1,0,1.82,1.31,1.31,0,0,1-.91.38,1.29,1.29,0,0,1-.91-2.2Z",
    style: {
      fill: "#092166",
      opacity: 0.9509900000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.87,249.22a1.27,1.27,0,0,1,.9-.37,1.27,1.27,0,1,1,0,2.54,1.27,1.27,0,0,1-.9-.37,1.28,1.28,0,0,1,0-1.8Z",
    style: {
      fill: "#092166",
      opacity: 0.9411879999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.08,249.43a1.25,1.25,0,0,1,.89-.37,1.23,1.23,0,0,1,.89.37,1.22,1.22,0,0,1,.37.89,1.25,1.25,0,0,1-.37.89,1.27,1.27,0,0,1-.89.37,1.29,1.29,0,0,1-.89-.37,1.25,1.25,0,0,1-.37-.89A1.22,1.22,0,0,1,421.08,249.43Z",
    style: {
      fill: "#092166",
      opacity: 0.9313859999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.29,249.63a1.25,1.25,0,0,1,2.13.88,1.29,1.29,0,0,1-.37.89,1.25,1.25,0,0,1-2.13-.89A1.21,1.21,0,0,1,421.29,249.63Z",
    style: {
      fill: "#092166",
      opacity: 0.921584
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.49,249.84a1.24,1.24,0,0,1,1.75,0,1.24,1.24,0,0,1-.88,2.11,1.2,1.2,0,0,1-.87-.37,1.23,1.23,0,0,1,0-1.74Z",
    style: {
      fill: "#092166",
      opacity: 0.911782
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,250a1.24,1.24,0,0,1,1.73,0,1.24,1.24,0,0,1,.36.87,1.23,1.23,0,0,1-2.45,0A1.24,1.24,0,0,1,421.7,250Z",
    style: {
      fill: "#092166",
      opacity: 0.9019800000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,250.25a1.23,1.23,0,0,1,1.72,0,1.24,1.24,0,0,1,.35.86,1.21,1.21,0,0,1-2.42,0A1.24,1.24,0,0,1,421.9,250.25Z",
    style: {
      fill: "#092166",
      opacity: 0.8921779999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,250.46a1.17,1.17,0,0,1,1.69,0,1.2,1.2,0,0,1,0,1.69,1.2,1.2,0,1,1-1.69-1.69Z",
    style: {
      fill: "#092166",
      opacity: 0.8823759999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.32,250.66a1.17,1.17,0,0,1,1.67,0,1.18,1.18,0,0,1,0,1.68,1.17,1.17,0,0,1-1.67,0,1.18,1.18,0,0,1,0-1.68Z",
    style: {
      fill: "#092166",
      opacity: 0.872574
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52,250.87a1.18,1.18,0,1,1-.34.83A1.18,1.18,0,0,1,422.52,250.87Z",
    style: {
      fill: "#092166",
      opacity: 0.862772
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.73,251.07a1.17,1.17,0,0,1,.82-.34,1.18,1.18,0,0,1,.82.34,1.16,1.16,0,0,1,.34.82,1.13,1.13,0,0,1-.34.82,1.14,1.14,0,0,1-.82.34,1.16,1.16,0,0,1-1.16-1.16A1.16,1.16,0,0,1,422.73,251.07Z",
    style: {
      fill: "#092166",
      opacity: 0.8529700000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.93,251.28a1.15,1.15,0,0,1,1.63,0,1.15,1.15,0,0,1,.33.81,1.15,1.15,0,1,1-2.29,0A1.15,1.15,0,0,1,422.93,251.28Z",
    style: {
      fill: "#092166",
      opacity: 0.8431679999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,251.49a1.1,1.1,0,0,1,.8-.34,1.14,1.14,0,0,1,.81,1.94,1.17,1.17,0,0,1-.81.33,1.13,1.13,0,0,1-.8-1.93Z",
    style: {
      fill: "#092166",
      opacity: 0.8333659999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.35,251.69a1.11,1.11,0,0,1,1.58,0,1.12,1.12,0,0,1,0,1.59,1.11,1.11,0,0,1-1.58,0,1.12,1.12,0,0,1,0-1.59Z",
    style: {
      fill: "#092166",
      opacity: 0.823564
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.55,251.9a1.11,1.11,0,0,1,.79-.33,1.13,1.13,0,0,1,1.11,1.11,1.11,1.11,0,0,1-1.11,1.11,1.09,1.09,0,0,1-1.11-1.11A1.11,1.11,0,0,1,423.55,251.9Z",
    style: {
      fill: "#092166",
      opacity: 0.813762
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.76,252.1a1.1,1.1,0,0,1,1.55,0,1.11,1.11,0,0,1,0,1.56,1.1,1.1,0,0,1-1.55-1.56Z",
    style: {
      fill: "#092166",
      opacity: 0.8039600000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,252.31a1.11,1.11,0,0,1,.77-.32,1.09,1.09,0,0,1,1.09,1.09,1.11,1.11,0,0,1-.32.77,1.08,1.08,0,0,1-.77.31,1.06,1.06,0,0,1-1.08-1.08A1.08,1.08,0,0,1,424,252.31Z",
    style: {
      fill: "#092166",
      opacity: 0.7941579999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,252.52a1.07,1.07,0,0,1,.76-.32,1.09,1.09,0,0,1,.76.32,1.07,1.07,0,0,1,0,1.51,1.09,1.09,0,0,1-.76.32,1.08,1.08,0,0,1-1.07-1.08A1.05,1.05,0,0,1,424.17,252.52Z",
    style: {
      fill: "#092166",
      opacity: 0.7843559999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.38,252.72a1.06,1.06,0,0,1,.75-.31,1.06,1.06,0,0,1,1.06,1.06,1.08,1.08,0,0,1-.31.75,1.05,1.05,0,0,1-.75.31,1,1,0,0,1-.75-.31,1,1,0,0,1-.31-.75A1.05,1.05,0,0,1,424.38,252.72Z",
    style: {
      fill: "#092166",
      opacity: 0.774554
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.58,252.93a1,1,0,0,1,.74-.31,1,1,0,0,1,.74,1.79,1.05,1.05,0,0,1-.74.31,1.09,1.09,0,0,1-.74-.31,1.06,1.06,0,0,1,0-1.48Z",
    style: {
      fill: "#092166",
      opacity: 0.764752
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79,253.14a1,1,0,0,1,.73-.31,1,1,0,0,1,.73.31,1,1,0,0,1,.31.73,1,1,0,0,1-.31.73,1,1,0,0,1-.73.3,1,1,0,0,1-1-1A1,1,0,0,1,424.79,253.14Z",
    style: {
      fill: "#092166",
      opacity: 0.75495
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,253.34a1,1,0,0,1,.72-.3,1,1,0,0,1,0,2.05,1,1,0,0,1-.72-.3,1,1,0,0,1,0-1.45Z",
    style: {
      fill: "#092166",
      opacity: 0.745149
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,253.55a1,1,0,0,1,1.43,0,1,1,0,0,1,.29.71,1,1,0,0,1-.29.72,1,1,0,0,1-1.43,0,1,1,0,0,1-.29-.72A1,1,0,0,1,425.2,253.55Z",
    style: {
      fill: "#092166",
      opacity: 0.735347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.41,253.75a1,1,0,0,1,.7-.29,1,1,0,0,1,1,1,1,1,0,0,1-1,1,1,1,0,0,1-.7-.3,1,1,0,0,1-.29-.7A1,1,0,0,1,425.41,253.75Z",
    style: {
      fill: "#092166",
      opacity: 0.725545
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.61,254a1,1,0,0,1,1.4,0,1,1,0,0,1,0,1.39,1,1,0,0,1-1.4,0,1,1,0,0,1,0-1.39Z",
    style: {
      fill: "#092166",
      opacity: 0.715743
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.82,254.17a1,1,0,0,1,.69-.29,1,1,0,0,1,.68.29.94.94,0,0,1,.29.68,1,1,0,0,1-.29.69.94.94,0,0,1-.68.28,1,1,0,0,1-.69-.28,1,1,0,0,1-.29-.69A.94.94,0,0,1,425.82,254.17Z",
    style: {
      fill: "#092166",
      opacity: 0.7059409999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,254.37a1,1,0,0,1,1.35,0,1,1,0,0,1,0,1.36,1,1,0,0,1-1.35,0,.94.94,0,0,1,0-1.36Z",
    style: {
      fill: "#092166",
      opacity: 0.696139
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.23,254.58a.94.94,0,0,1,.67-.28.92.92,0,0,1,.67.28.91.91,0,0,1,.28.67.94.94,0,0,1-.28.67,1,1,0,0,1-.67.27,1,1,0,0,1-.67-.27,1,1,0,0,1-.28-.67A1,1,0,0,1,426.23,254.58Z",
    style: {
      fill: "#092166",
      opacity: 0.686337
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.44,254.78a.94.94,0,0,1,1.32,0,1,1,0,0,1,.27.66,1,1,0,0,1-.27.67.94.94,0,0,1-1.32,0,1,1,0,0,1-.28-.67A1,1,0,0,1,426.44,254.78Z",
    style: {
      fill: "#092166",
      opacity: 0.676535
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.64,255a.93.93,0,0,1,1.58.65.91.91,0,0,1-.27.65.93.93,0,0,1-1.31,0,.91.91,0,0,1-.27-.65A.92.92,0,0,1,426.64,255Z",
    style: {
      fill: "#092166",
      opacity: 0.666733
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.85,255.2a.91.91,0,0,1,1.29,0,.92.92,0,0,1,.26.64.93.93,0,0,1-.26.64.92.92,0,0,1-1.56-.64A.89.89,0,0,1,426.85,255.2Z",
    style: {
      fill: "#092166",
      opacity: 0.6569309999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.06,255.4a.9.9,0,0,1,1.53.64.86.86,0,0,1-.27.63.89.89,0,0,1-1.26,0,.86.86,0,0,1-.27-.63A.9.9,0,0,1,427.06,255.4Z",
    style: {
      fill: "#092166",
      opacity: 0.647129
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.26,255.61a.88.88,0,1,1-.26.62A.89.89,0,0,1,427.26,255.61Z",
    style: {
      fill: "#092166",
      opacity: 0.637327
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.47,255.81a.88.88,0,0,1,1.23,0,.87.87,0,0,1,0,1.24.88.88,0,0,1-1.23,0,.87.87,0,0,1,0-1.24Z",
    style: {
      fill: "#092166",
      opacity: 0.627525
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.67,256a.86.86,0,0,1,1.22,1.22.86.86,0,0,1-1.22-1.22Z",
    style: {
      fill: "#092166",
      opacity: 0.617723
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.88,256.23a.84.84,0,0,1,1.2,0,.83.83,0,0,1,0,1.19.84.84,0,0,1-1.2,0,.83.83,0,0,1,0-1.19Z",
    style: {
      fill: "#092166",
      opacity: 0.6079209999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.09,256.43a.82.82,0,0,1,.59-.24.82.82,0,0,1,.83.83.82.82,0,0,1-.24.59.87.87,0,0,1-.59.25.83.83,0,0,1-.59-.25.79.79,0,0,1-.25-.59A.83.83,0,0,1,428.09,256.43Z",
    style: {
      fill: "#092166",
      opacity: 0.598119
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.29,256.64a.82.82,0,0,1,1.16,0,.8.8,0,0,1,0,1.16.82.82,0,0,1-1.16-1.16Z",
    style: {
      fill: "#092166",
      opacity: 0.588317
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.5,256.84a.83.83,0,0,1,.57-.23.81.81,0,0,1,.57,1.38.78.78,0,0,1-.57.24.8.8,0,0,1-.57-.24.81.81,0,0,1,0-1.15Z",
    style: {
      fill: "#092166",
      opacity: 0.578515
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.7,257.05a.83.83,0,0,1,.57-.23.8.8,0,0,1,.56.23.81.81,0,0,1,0,1.13.8.8,0,0,1-.56.23.8.8,0,0,1-.57-1.36Z",
    style: {
      fill: "#092166",
      opacity: 0.568713
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.91,257.26a.78.78,0,0,1,1.11,0,.78.78,0,0,1,.23.55.82.82,0,0,1-.23.56.78.78,0,0,1-1.11,0,.82.82,0,0,1-.23-.56A.78.78,0,0,1,428.91,257.26Z",
    style: {
      fill: "#092166",
      opacity: 0.5589109999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.12,257.46a.75.75,0,0,1,.54-.22.75.75,0,0,1,.77.77.75.75,0,0,1-.22.54.78.78,0,0,1-.55.23.79.79,0,0,1-.77-.77A.78.78,0,0,1,429.12,257.46Z",
    style: {
      fill: "#092166",
      opacity: 0.549109
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.32,257.67a.75.75,0,0,1,.54-.22.76.76,0,0,1,.54.22.76.76,0,0,1,0,1.07.76.76,0,0,1-.54.22.75.75,0,0,1-.54-.22.76.76,0,0,1,0-1.07Z",
    style: {
      fill: "#092166",
      opacity: 0.539307
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.53,257.88a.73.73,0,0,1,.53-.22.75.75,0,0,1,.74.74.73.73,0,0,1-.22.53.7.7,0,0,1-.52.22.75.75,0,0,1-.75-.75A.7.7,0,0,1,429.53,257.88Z",
    style: {
      fill: "#092166",
      opacity: 0.529505
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.74,258.08a.74.74,0,0,1,1,0,.72.72,0,0,1,0,1,.74.74,0,0,1-1,0,.72.72,0,0,1,0-1Z",
    style: {
      fill: "#092166",
      opacity: 0.519703
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.94,258.29a.73.73,0,0,1,.51-.21.72.72,0,0,1,.72.72.73.73,0,0,1-.21.51.71.71,0,0,1-.51.21.72.72,0,0,1-.72-.72A.71.71,0,0,1,429.94,258.29Z",
    style: {
      fill: "#092166",
      opacity: 0.5099009999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.15,258.49a.72.72,0,0,1,1,0,.71.71,0,0,1,0,1,.73.73,0,0,1-1,0,.71.71,0,0,1,0-1Z",
    style: {
      fill: "#092166",
      opacity: 0.500099
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.35,258.7a.71.71,0,0,1,1,0,.71.71,0,0,1,.2.49.7.7,0,0,1-.69.7.7.7,0,0,1-.5-.21.7.7,0,0,1-.2-.49A.71.71,0,0,1,430.35,258.7Z",
    style: {
      fill: "#092166",
      opacity: 0.490297
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.56,258.91a.65.65,0,0,1,.48-.2.68.68,0,1,1,0,1.36.65.65,0,0,1-.48-.2.68.68,0,0,1,0-1Z",
    style: {
      fill: "#092166",
      opacity: 0.480495
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.77,259.11a.68.68,0,0,1,.94,0,.66.66,0,0,1,0,.95.67.67,0,1,1-.94-.95Z",
    style: {
      fill: "#092166",
      opacity: 0.470693
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,259.32a.66.66,0,0,1,.47-.19.62.62,0,0,1,.46.19.65.65,0,0,1,.2.46.67.67,0,0,1-.2.47.62.62,0,0,1-.46.19.65.65,0,0,1-.66-.66A.63.63,0,0,1,431,259.32Z",
    style: {
      fill: "#092166",
      opacity: 0.460891
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.18,259.52a.67.67,0,0,1,.91,0,.65.65,0,0,1,0,.92.64.64,0,0,1-.91,0,.65.65,0,0,1,0-.92Z",
    style: {
      fill: "#092166",
      opacity: 0.45108899999999996
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.38,259.73a.67.67,0,0,1,.45-.19.64.64,0,0,1,.45.19.65.65,0,0,1,.19.45.67.67,0,0,1-.19.45.63.63,0,0,1-.45.18.62.62,0,0,1-.63-.63A.64.64,0,0,1,431.38,259.73Z",
    style: {
      fill: "#092166",
      opacity: 0.441287
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,259.94a.6.6,0,0,1,.88,0,.62.62,0,0,1,.18.44.6.6,0,0,1-.18.43.6.6,0,0,1-.88,0,.6.6,0,0,1-.18-.43A.62.62,0,0,1,431.59,259.94Z",
    style: {
      fill: "#092166",
      opacity: 0.431485
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.8,260.14a.58.58,0,0,1,.43-.18.61.61,0,0,1,.43.18.65.65,0,0,1,.17.43.63.63,0,0,1-.17.43.61.61,0,0,1-.43.18.58.58,0,0,1-.43-.18.6.6,0,0,1-.18-.43A.61.61,0,0,1,431.8,260.14Z",
    style: {
      fill: "#092166",
      opacity: 0.421683
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,260.35a.59.59,0,0,1,.85,0,.6.6,0,0,1,0,.84.59.59,0,0,1-.85,0,.6.6,0,0,1,0-.84Z",
    style: {
      fill: "#092166",
      opacity: 0.411881
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.21,260.55a.58.58,0,0,1,1,.42.54.54,0,0,1-.17.41.58.58,0,0,1-1-.41A.63.63,0,0,1,432.21,260.55Z",
    style: {
      fill: "#092166",
      opacity: 0.40207899999999996
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.41,260.76a.6.6,0,0,1,.41-.17.56.56,0,0,1,.4.17.57.57,0,0,1,0,.81.55.55,0,0,1-.4.16.59.59,0,0,1-.41-.16.57.57,0,0,1-.16-.41A.57.57,0,0,1,432.41,260.76Z",
    style: {
      fill: "#092166",
      opacity: 0.392277
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.62,261a.54.54,0,0,1,.79,0,.54.54,0,0,1,.16.39.55.55,0,0,1-.16.4.57.57,0,0,1-.79,0,.55.55,0,0,1-.16-.4A.54.54,0,0,1,432.62,261Z",
    style: {
      fill: "#092166",
      opacity: 0.382475
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.83,261.17a.55.55,0,0,1,.38-.16.55.55,0,0,1,.55.55.55.55,0,0,1-.55.54.55.55,0,0,1-.54-.54A.54.54,0,0,1,432.83,261.17Z",
    style: {
      fill: "#092166",
      opacity: 0.372673
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,261.38a.53.53,0,0,1,.76,0,.54.54,0,0,1,.15.38.53.53,0,0,1-.15.37.53.53,0,0,1-.76,0,.53.53,0,0,1-.15-.37A.54.54,0,0,1,433,261.38Z",
    style: {
      fill: "#092166",
      opacity: 0.362871
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.24,261.59a.49.49,0,0,1,.37-.16.52.52,0,0,1,.37.16.51.51,0,0,1,.15.36.51.51,0,0,1-.15.37.55.55,0,0,1-.37.15.51.51,0,0,1-.52-.52A.51.51,0,0,1,433.24,261.59Z",
    style: {
      fill: "#092166",
      opacity: 0.35306899999999997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.45,261.79a.47.47,0,0,1,.35-.15.48.48,0,0,1,.36.15.51.51,0,0,1,0,.72.48.48,0,0,1-.36.15.47.47,0,0,1-.35-.15.51.51,0,0,1,0-.72Z",
    style: {
      fill: "#092166",
      opacity: 0.343267
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.65,262a.49.49,0,0,1,.35-.15.51.51,0,0,1,.5.5.49.49,0,0,1-.15.35.5.5,0,0,1-.35.14.48.48,0,0,1-.49-.49A.5.5,0,0,1,433.65,262Z",
    style: {
      fill: "#092166",
      opacity: 0.333465
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86,262.2a.48.48,0,0,1,.34-.14.49.49,0,0,1,.34.14.52.52,0,0,1,.14.35.51.51,0,0,1-.14.34.49.49,0,0,1-.34.14.48.48,0,0,1-.34-.14.47.47,0,0,1-.14-.34A.47.47,0,0,1,433.86,262.2Z",
    style: {
      fill: "#092166",
      opacity: 0.323663
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.06,262.41a.48.48,0,0,1,.34-.14.47.47,0,0,1,.33.8.43.43,0,0,1-.33.14.44.44,0,0,1-.34-.14.48.48,0,0,1,0-.66Z",
    style: {
      fill: "#092166",
      opacity: 0.313861
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.27,262.62a.47.47,0,0,1,.32-.14.47.47,0,0,1,.33.14.42.42,0,0,1,.13.32.44.44,0,0,1-.13.32.47.47,0,0,1-.33.14.47.47,0,0,1-.32-.14.44.44,0,0,1-.13-.32A.42.42,0,0,1,434.27,262.62Z",
    style: {
      fill: "#092166",
      opacity: 0.30405899999999997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.48,262.82a.46.46,0,0,1,.31-.13.44.44,0,0,1,.45.45.46.46,0,0,1-.13.31.44.44,0,0,1-.32.13.44.44,0,0,1-.44-.44A.44.44,0,0,1,434.48,262.82Z",
    style: {
      fill: "#092166",
      opacity: 0.294257
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.68,263a.43.43,0,0,1,.31-.13.44.44,0,0,1,.43.43.4.4,0,0,1-.13.31.43.43,0,0,1-.3.13.48.48,0,0,1-.31-.13.43.43,0,0,1-.12-.31A.42.42,0,0,1,434.68,263Z",
    style: {
      fill: "#092166",
      opacity: 0.284455
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.89,263.23a.42.42,0,0,1,.3-.12.42.42,0,0,1,.29.12.45.45,0,0,1,.13.3.43.43,0,0,1-.13.3.42.42,0,0,1-.29.12.41.41,0,0,1-.42-.42A.44.44,0,0,1,434.89,263.23Z",
    style: {
      fill: "#092166",
      opacity: 0.274653
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.09,263.44a.42.42,0,0,1,.29-.12.41.41,0,0,1,.41.41.42.42,0,0,1-.12.29.4.4,0,0,1-.29.12.42.42,0,0,1-.29-.12.47.47,0,0,1-.12-.29A.45.45,0,0,1,435.09,263.44Z",
    style: {
      fill: "#092166",
      opacity: 0.264851
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.3,263.65a.39.39,0,0,1,.56,0,.36.36,0,0,1,.11.28.35.35,0,0,1-.11.27.39.39,0,0,1-.56,0,.36.36,0,0,1-.12-.27A.36.36,0,0,1,435.3,263.65Z",
    style: {
      fill: "#092166",
      opacity: 0.25505
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.51,263.85a.39.39,0,0,1,.27-.11.38.38,0,0,1,.38.38.39.39,0,0,1-.11.27.37.37,0,0,1-.27.12.41.41,0,0,1-.39-.39A.37.37,0,0,1,435.51,263.85Z",
    style: {
      fill: "#092166",
      opacity: 0.245248
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.71,264.06A.38.38,0,0,1,436,264a.4.4,0,0,1,.27.11.39.39,0,0,1,0,.52.4.4,0,0,1-.27.11.38.38,0,0,1-.26-.11.36.36,0,0,1,0-.52Z",
    style: {
      fill: "#092166",
      opacity: 0.235446
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.92,264.26a.39.39,0,0,1,.25-.1.37.37,0,0,1,.25.1.36.36,0,0,1,.11.26.36.36,0,0,1-.11.25.33.33,0,0,1-.25.1.35.35,0,0,1-.25-.1.36.36,0,0,1-.11-.25A.36.36,0,0,1,435.92,264.26Z",
    style: {
      fill: "#092166",
      opacity: 0.22564399999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12,264.47a.35.35,0,0,1,.25-.1.31.31,0,0,1,.24.1.34.34,0,0,1,.1.24.34.34,0,0,1-.34.35.35.35,0,0,1-.25-.59Z",
    style: {
      fill: "#092166",
      opacity: 0.21584199999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.33,264.68a.31.31,0,0,1,.24-.1.3.3,0,0,1,.23.1.34.34,0,0,1,.1.23.37.37,0,0,1-.1.24.33.33,0,0,1-.23.09.34.34,0,0,1-.24-.09.37.37,0,0,1-.1-.24A.34.34,0,0,1,436.33,264.68Z",
    style: {
      fill: "#092166",
      opacity: 0.20604000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.54,264.88a.31.31,0,0,1,.22-.09.32.32,0,0,1,.23.09.33.33,0,0,1,.09.23.35.35,0,0,1-.09.23.32.32,0,0,1-.23.09.31.31,0,0,1-.22-.09.37.37,0,0,1-.1-.23A.34.34,0,0,1,436.54,264.88Z",
    style: {
      fill: "#092166",
      opacity: 0.196238
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.74,265.09a.31.31,0,0,1,.53.22.29.29,0,0,1-.09.21.31.31,0,0,1-.44,0,.29.29,0,0,1-.09-.21A.31.31,0,0,1,436.74,265.09Z",
    style: {
      fill: "#092166",
      opacity: 0.186436
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,265.3a.29.29,0,0,1,.21-.09.3.3,0,0,1,.21.09.3.3,0,0,1,.08.2.29.29,0,0,1-.29.3.29.29,0,0,1-.21-.09.27.27,0,0,1-.09-.21A.27.27,0,0,1,437,265.3Z",
    style: {
      fill: "#092166",
      opacity: 0.17663399999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.16,265.5a.27.27,0,0,1,.19-.08.28.28,0,0,1,.2.08.28.28,0,0,1,.09.2.27.27,0,0,1-.09.2.28.28,0,0,1-.2.08.27.27,0,0,1-.19-.08.27.27,0,0,1-.09-.2A.28.28,0,0,1,437.16,265.5Z",
    style: {
      fill: "#092166",
      opacity: 0.16683199999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.36,265.71a.27.27,0,1,1-.08.19A.27.27,0,0,1,437.36,265.71Z",
    style: {
      fill: "#092166",
      opacity: 0.15703
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.57,265.91a.27.27,0,0,1,.36,0,.27.27,0,0,1,.08.19.27.27,0,0,1-.08.18.27.27,0,0,1-.36,0,.27.27,0,0,1-.08-.18A.27.27,0,0,1,437.57,265.91Z",
    style: {
      fill: "#092166",
      opacity: 0.147228
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.77,266.12a.24.24,0,0,1,.18-.07.24.24,0,0,1,.24.24.24.24,0,0,1-.07.18.28.28,0,0,1-.17.07.24.24,0,0,1-.25-.25A.28.28,0,0,1,437.77,266.12Z",
    style: {
      fill: "#092166",
      opacity: 0.137426
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,266.33a.2.2,0,0,1,.16-.07.23.23,0,1,1,0,.46.2.2,0,0,1-.16-.07.22.22,0,0,1,0-.32Z",
    style: {
      fill: "#092166",
      opacity: 0.127624
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.19,266.53a.2.2,0,0,1,.15-.06.25.25,0,0,1,.16.06.23.23,0,0,1,.06.16.22.22,0,0,1-.06.15.26.26,0,0,1-.16.07.21.21,0,0,1-.15-.07.19.19,0,0,1-.07-.15A.2.2,0,0,1,438.19,266.53Z",
    style: {
      fill: "#092166",
      opacity: 0.117822
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.39,266.74a.2.2,0,0,1,.15-.06.18.18,0,0,1,.14.06.2.2,0,0,1,.06.14.2.2,0,0,1-.06.15.18.18,0,0,1-.14.06.21.21,0,0,1-.21-.21A.2.2,0,0,1,438.39,266.74Z",
    style: {
      fill: "#092166",
      opacity: 0.10802
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.6,266.94a.2.2,0,0,1,.14-.05.19.19,0,0,1,.13.05.19.19,0,0,1,0,.28.16.16,0,0,1-.13.06.17.17,0,0,1-.14-.06.19.19,0,0,1,0-.28Z",
    style: {
      fill: "#092166",
      opacity: 0.098218
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.8,267.15a.21.21,0,0,1,.13,0,.19.19,0,0,1,.13,0,.15.15,0,0,1,.05.13.17.17,0,0,1-.05.13.19.19,0,0,1-.13,0,.17.17,0,0,1-.18-.18A.19.19,0,0,1,438.8,267.15Z",
    style: {
      fill: "#092166",
      opacity: 0.088416
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,267.36a.13.13,0,0,1,.12-.05.15.15,0,0,1,.12.05.17.17,0,0,1,.05.12.21.21,0,0,1-.05.12.18.18,0,0,1-.12,0,.17.17,0,0,1-.12,0,.21.21,0,0,1-.05-.12A.17.17,0,0,1,439,267.36Z",
    style: {
      fill: "#092166",
      opacity: 0.078614
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.22,267.56a.16.16,0,0,1,.22.22.16.16,0,1,1-.22-.22Z",
    style: {
      fill: "#092166",
      opacity: 0.068812
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.42,267.77a.14.14,0,0,1,.1,0,.15.15,0,0,1,.11,0,.18.18,0,0,1,0,.1.15.15,0,0,1,0,.1.15.15,0,0,1-.11,0,.14.14,0,0,1-.1,0,.15.15,0,0,1,0-.1A.18.18,0,0,1,439.42,267.77Z",
    style: {
      fill: "#092166",
      opacity: 0.05901000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.63,268a.14.14,0,0,1,.09,0,.12.12,0,0,1,.09,0,.13.13,0,0,1,0,.1.11.11,0,0,1,0,.09.1.1,0,0,1-.09,0,.14.14,0,0,1-.13-.13A.13.13,0,0,1,439.63,268Z",
    style: {
      fill: "#092166",
      opacity: 0.049207999999999995
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.83,268.18l.09,0a.11.11,0,0,1,.08,0,.12.12,0,0,1,0,.08.13.13,0,0,1,0,.09.11.11,0,0,1-.08,0l-.09,0a.12.12,0,0,1,0-.09A.11.11,0,0,1,439.83,268.18Z",
    style: {
      fill: "#092166",
      opacity: 0.039406
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,268.39a.11.11,0,0,1,.08,0,.11.11,0,0,1,.07,0,.09.09,0,0,1,0,.07.11.11,0,0,1,0,.08.11.11,0,0,1-.07,0,.1.1,0,0,1-.11-.11A.09.09,0,0,1,440,268.39Z",
    style: {
      fill: "#092166",
      opacity: 0.029604
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.25,268.59l.06,0,.07,0a.09.09,0,0,1,0,.07.11.11,0,0,1,0,.07l-.07,0-.06,0a.11.11,0,0,1,0-.07A.09.09,0,0,1,440.25,268.59Z",
    style: {
      fill: "#092166",
      opacity: 0.019802
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.59,268.86a.08.08,0,0,1-.08.08.09.09,0,0,1-.08-.08.08.08,0,0,1,0-.06.1.1,0,0,1,.12,0A.08.08,0,0,1,440.59,268.86Z",
    style: {
      fill: "#092166",
      opacity: 0.01
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDeployment);
export default __webpack_public_path__ + "static/media/p_deployment.d6da9ea2a3287ec5ac27b09c9825e12e.svg";
export { ForwardRef as ReactComponent };